/** - Este Script se encarga de todas las funciones necesaroas para la interface del visualizador
 * @author Maki Paordi - IGM (Sección: SIG)
 */

import './typedef';
import $, { event } from "jquery";

import { toUserExtent } from "ol/proj";
import { Layer } from "ol/layer";
// import { newImageData } from "ol/source/raster";

//esto se usa para poder referenciar imagenes en el build que sean locales
var M_Editar_Detener = require('./imagenes/iconos/M_Editar_Detener.svg');
var M_Editar_Iniciar = require('./imagenes/iconos/M_Editar_Iniciar.svg');

var M_LogoIGM_Negro = require('./imagenes/iconos/logo sgm 2020 Negro.svg');
var M_LogoIGM_Celeste = require('./imagenes/iconos/logo sgm 2020 Celeste.svg');
var M_LogoIGM_Color = require('./imagenes/iconos/logo sgm 2020.svg');

var LD_HideLayerDisplay = require('./imagenes/iconos/LD_HideLayerDisplay.svg');
var LD_ShowLayerDisplay = require('./imagenes/iconos/LD_ShowLayerDisplay.svg');

var LD_HideLayer = require('./imagenes/iconos/LD_HideLayer.svg');
var LD_ShowLayer = require('./imagenes/iconos/LD_ShowLayer.svg');

var LD_ContextMenu = require('./imagenes/iconos/LD_ContextMenu.svg');

var W_Minimizar = require('./imagenes/iconos/W_Minimizar.svg');
var W_Cerrar = require('./imagenes/iconos/W_Cerrar.svg');
var W_CheckInfoClose = require('./imagenes/iconos/W_CheckInfoClose.svg');
var W_CheckInfoOpen = require('./imagenes/iconos/W_CheckInfoOpen.svg');

var W_Bool_False = require('./imagenes/iconos/W_Bool_False.svg');
var W_Bool_True = require('./imagenes/iconos/W_Bool_True.svg');

let w = /** @type {ExtendedWindow} */ (window);

w.InterfaceColor = 0;
w.InterfaceBG = 0;

w.InterfaceBlur = 2;

//le coloco la version y la fecha al bloque que se 
//ve en los tips rapidos (la ventana de presentacion)
document.getElementById('Version_Text').textContent = w.Version + " (actualizado el " + w.LastUpdateDate + ")";

/** - variable de visible que determina si estara visible el LayerDisplay al comienzo */
let isLayerDusplayVisible = true;

/** - El Boton que esconde el LAYER DISPLAY
 * @type {HTMLElement}
 */
var botonHideDisplay = document.getElementsByClassName("hideLayerDisplay")[0];

/** - El Bloque donde va la barra de escala
 * @type {HTMLElement}
 */
var ScaleBar_Container = document.getElementsByClassName("ScaleBar_Container")[0];

/** - Cantidad de ventanas minimizadas
 * @type {number}
 */
var minimizedWindows = 0;

CheckMinimizedWindowsQuantity();
recalculateBottomTextVisibility();

//comprueva si el usuario es nuevo
//esto se disparara solamente si es una sesion nueva, si se recarga la
//pagina no se dispara y si se vuelve para atras tampoco,
//si se cierra la ventana y en una pestaña nueva se abre el visualizador ahi si se disparara
function startController(){
    //aca tendria que estar el codigo para impactar en la base de datos mysql que entro un usuario nuevo
    if (sessionStorage.getItem("SesionFirstLogin") == null){
        sessionStorage.setItem("SesionFirstLogin", new Date(Date.now()).toString()  );
    }

    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        w.isMobile = true;
        isLayerDusplayVisible = false;

        //cambia la barra de escala para que no sea gigante
        //w.scaleBarAndroidVersion();

    }else{
        MostrarLayerDisplay("inicio");
        // let isLayerDusplayVisible = true;
        // document.getElementById("LayerDisplay").style.display = "block";
        // document.getElementsByClassName("hideLayerDisplay")[0].getElementsByClassName("LD_icon")[0].src = LD_HideLayerDisplay;
        // document.getElementsByClassName("hideLayerDisplay")[0].id = "Esconde el panel de Capas";
    }

}

startController();
//REVISAR
//w.setProjectionOnMap( document.getElementById("BI_ProjectionDropDown").value )

//este script tendra las funciones basicas de interfaces
//ajenas a open layers

//#region Clases

//objeto que tendra los datos de la capa
/** Clase LayerData, tiene todos los datos extras necesarios para la interface sobre las Capas del mapa
 *
*/
class LayerData {

    /**
     * @constructor
     * @param {Object} parametros - Opriones con las que se crear la Ventana
     * @param {number} parametros.id - id de la capa, es unico por capas e irrepetible
     * @param {boolean} parametros.Visible - Si la capa esta visible
     * @param {string} parametros.Nombre - Nombre de la capa
     * @param {string} parametros.Formato - Formato de la capa ("WMS, OL, GeoJSON, KML o BaseMap")
     * @param {HTMLelement} parametros.GUILayer - HTMLElement de la capa que la representa en la interface
     * @param {Layer} parametros.OpenLayerSource - Layer de OpenLayer Asociada a esta capa
     * @param {boolean} parametros.Listado - Si la capa ya esta listada en la interface, se usa para control
     * @param {number} parametros.Opacacity - Opacasicad en numero, 0 transparente, 1 visible completamente
     * @param {boolean} parametros.CapaPreCargada - Valor que indica si esta capa es precargacda, esto proboca que la misma no sea eliminable
     * @param {string} parametros.Metadata - Metadatos de la capa
     * @param {string} parametros.EstadoDeLaCapa - Estado de la capa representado en texto, Ej "editando" o "eliminado"
     * @param {boolean} parametros.CapaDescargable - Si la capa sera descargable o no (para la funcion copiar WMS al protapapeles)
     * @param {string} parametros.Attributions - Atributions en formato HTML text Ej "<a href="link">Link</<>"
     * @param {BoundingBox} parametros.BoundingBox - BoundingBox dela capa, contiene el sistema de referencia y las coordenadas de las esquinas opuestas de la bounding box
     * @param {string[]} parametros.LayerTitles - Lista de los titulos de las capas que conforma la capa (Solo WMS)
     * @param {string[]} parametros.LayerNames - Lista de los nombres de las capas que conforma la capa (Solo WMS)
     */
    // @param {{id: number, Visible: boolean, Nombre: string, Formato: string, GUILayer: HTMLElement, OpenLayerSource: Layer, Listado: boolean, Opacacity: number, CapaPreCargada:boolean, Metadata: string, EstadoDeLaCapa: string, CapaDescargable: boolean, Attributions: HTMLElement, LayerTitles: string[], LayerNames: string[] }} parametros

    constructor(parametros) {
        this.id = w.GlobarlLayerID;
        w.GlobarlLayerID++;
        this.Visible = parametros.Visible;
        this.Nombre = parametros.Nombre;
        this.Formato = parametros.Formato;
        this.GUILayer = parametros.GUILayer;
        this.OpenLayerSource = parametros.OpenLayerSource;
        this.Listado = parametros.Listado;
        this.Opacacity = parametros.Opacacity;
        this.CapaPreCargada = parametros.CapaPreCargada;
        this.Metadata = parametros.Metadata;
        this.EstadoDeLaCapa = parametros.EstadoDeLaCapa;
        this.CapaDescargable = parametros.CapaDescargable;
        this.Attributions = parametros.Attributions;
        this.BoundingBox = parametros.BoundingBox;
        if(parametros.LayerTitles != undefined && parametros.LayerTitles != null){
          this.LayerTitles = parametros.LayerTitles;
          this.LayerNames = parametros.LayerNames;
        }
    }

    /** - setea si esta capa es descargable
     * @param {boolean} value 
     */
    setDescargable(value){
      this.CapaDescargable = value;
    }
}

/** Clase ResultLayerGetInfo, tiene todos los resultados de la consulta de pedir informacion
 */
class ResultLayerGetInfo{
    /**
     * @constructor
     * @param {Object} valores - Opriones con las que se crear la Ventana
     * @param {string} valores.Nombre - Nombre de la capa
     * @param {string} valores.Title - Titulo de la capa
     * @param {string[]} valores.Fields - Lista de los campos de la tabla
     * @param {string[]} valores.Values - Lista de los valores de los campos de la tabla
     * @param {string} valores.ServerType - Tipo de servidor
     */
    constructor(valores){
      if(valores != null && valores != undefined){
        this.Nombre = valores.Nombre
        this.Title = valores.Title
        this.Fields = valores.Fields
        this.Values = valores.Values
        this.ServerType = valores.ServerType
      }

    }
}

//#endregion

//#region variables globales

//declaro variables Globales de los botones del menu contextual
var CM_BotonZoomToLayer = document.getElementById("Zoom a la capa");
var CM_Renombrar = document.getElementById("Renombrar Capa");
var CM_BotonVerTabla = document.getElementById("Ver tabla");
var CM_BotonMetadata = document.getElementById("Ver metadatos");
var CM_BotonCambiarSimbolo = document.getElementById("Cambiar simbolo");
var CM_BotonEditarDatos = document.getElementById("Editar datos");
var CM_BotonDescargar = document.getElementById("Descargar capa");
var CM_BotonDescargarWMS = document.getElementById("Copiar URL del WMS");
var CM_BotonEliminar = document.getElementById("Eliminar capa");
var CM_BarraTransparencia = document.querySelectorAll(".CM_BarraTransparencia")[0];

//#endregion

//#region Metodos Re utilizables

/**funcion para apagar styles (true = prendido, false = apagado)
 * @param {string} ID
 * @param {boolean} newValue
 */
function toggleStyle(ID, newValue){
    //console.log(document.getElementById(ID));
    document.getElementById(ID).disabled = !newValue;
}

/**
 * - toma un string para el tipo de fecha y devuelve un string formateado en español
 * @param {string} tipo -tipo de fecha a devolver, ej: "dia" = 22 de Julio del 2021 | "diasemana" = Jueves 22 de Julio | "diasemanaaño" = Jueves 22 de Julio del 2021 | "año" = 2021 | "mes" = Julio 2021
 * @returns {string}
 */
w.GetDateOnText = function(tipo){

    var fecha = new Date();
    var anio = fecha.getFullYear();
    var mes = fecha.getMonth();
    var dia = fecha.getDate();
    var diaSemana = fecha.getDay();
    var hora = fecha.getHours();
    var min = fecha.getMinutes();

    var mesTexto = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    var diaSemanaTexto = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

    if(tipo != undefined){

        switch(tipo.toLowerCase()){
            case "dia":
                return dia + " de " + mesTexto[mes] + " del " + anio;
                break;

            case "diasemana":
                return diaSemanaTexto[diaSemana] + " " + dia + " de " + mesTexto[mes];
                break;

            case "diasemanaaño":
                return diaSemanaTexto[diaSemana] + " " + dia + " de " + mesTexto[mes] + " del " + anio;
                break;

            case "año":
                return anio;
                break;

            case "mes":
                return mesTexto[mes] + " del " + anio;
                break;
        }
        
    }else{

        return dia + " de " + mesTexto[mes] + " del " + anio + " - " + hora + "h " + min + "m";
    }

}

/** - setea el desenfoque de fondo de la interface
 * @param {number} multiply - cantidad de desenfoque, se calcula (4*multiply) en px 
 */
 function ChangeInterfaceBlur( multiply ){
    let blurValue = (multiply*4);
    root.style.setProperty('--filtro-desenfoque', ((blurValue) + "px"));
}

/** - activa la patnalla completa en todas las plataformas menos Safari de IOS*/
function toggleFullScreen() {
    if (!document.fullscreenElement &&    // alternative standard method
        !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
        if (document.documentElement.msRequestFullscreen){
            document.documentElement.msRequestFullscreen();
        }else if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
            w.scroll({top: -50, behavior: 'smooth'});
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }else if (document.webkitEnterFullscreen) {
            vid.webkitEnterFullscreen(); //for iphone this code worked
        }

    } else {
        if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.cancelFullScreen) {
            document.exitFullScreen();
        } else if (document.exitFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen ) {
            document.webkitExitFullscreen ();
        } else if (document.webkitCancelFullscreen ) {
            document.webkitCancelFullscreen ();
        }
    }
}

/** - Esto cambia la barra de escala segun si hay o no ventanas minimizadas*/
function CheckMinimizedWindowsQuantity(){
    //console.log("minimizedWindows = " + minimizedWindows);
    if(minimizedWindows>0){
        ScaleBar_Container.className = ScaleBar_Container.className.replace('ExtraHeigthPositionOFF','ExtraHeigthPositionON');
    }else{
        ScaleBar_Container.className = ScaleBar_Container.className.replace('ExtraHeigthPositionON','ExtraHeigthPositionOFF');
    }
}

/** - esocnde el elemento HTML del que le pasamos la id
 * @param {number} idDelElementoHTML ID del elemento HTML a Ocultar
*/
function EsconderElementoHTMLPorID(idDelElementoHTML) {
    document.getElementById(idDelElementoHTML).style.display = "none";
}

/** - mustra el elemento HTML del que le pasamos la id
 * @param {number} idDelElementoHTML ID del elemento HTML a Mostrar
*/
function MostrarElementoHTMLPorID(idDelElementoHTML) {
    document.getElementById(idDelElementoHTML).style.display = "inline";
}

/** - Esocnde el elemento HTML que le pasamos por parametro
 * @param {HTMLElement} ElementoHTML Elemento HTML a Ocultar
*/
function EsconderElementoHTML(ElementoHTML) {
    ElementoHTML.style.display = "none";
}

/** - Mustra el elemento HTML que le pasamos por parametro
 * @param {HTMLElement} ElementoHTML Elemento HTML a Mostrar
*/
function MostrarElementoHTML(ElementoHTML) {
    ElementoHTML.style.display = "inline";
}

/** - funcion para mostrar elemento en la posicion XY, y con el calculo de posicion que se le pasa por paramtero
 * @param {HTMLElement} ElementoHTML - Elemento HTML a Mover
 * @param {string} PositionXY - Posicion a mover el HTML con el siguiente formato: "XUnits|YUnits" Ejemplo: "20px|20px" o también "20vw|20vh"
 * @param {string} positionType - Tipo de posicionamiento, por ejemplo "Absolute"
*/
function MoverHTMLElementToXY(ElementoHTML, PositionXY, positionType) {
    ElementoHTML.style.position = positionType;
    ElementoHTML.style.left = PositionXY.split("|")[0];
    ElementoHTML.style.top = PositionXY.split("|")[1];
}

/** - funcion para mostrar elemento en la posicion XY relativa a la pantalla Xposition|Ypostion se calcula con VH y VW
 * @param {HTMLElement} ElementoHTML - Elemento HTML a Mover
 * @param {string} PositionXY - Posicion a mover el HTML con el siguiente formato: "Xpx|Ypx" Ejemplo: "20px|20px"
 * @param {string} positionType - Tipo de posicionamiento, por ejemplo "Absolute"
*/
function MoverHTMLElementToXYRelative(ElementoHTML, PositionXY, positionType) {
    ElementoHTML.style.position = positionType;

    var X = PositionXY.split("|")[0].split("px")[0];
    var Y = PositionXY.split("|")[1].split("px")[0];

    //(100*X)/100% de La X Ventana
    var XCalculada = (100 * X) / w.innerWidth;
    var YCalculada = (100 * Y) / w.innerHeight;

    ElementoHTML.style.left = XCalculada + "vw";
    ElementoHTML.style.top = YCalculada + "vh";
}

/** - funcion para mostrar elemento en la posicion XY relativa a la pantalla Xposition|Ypostion pero acepta porcentajes
 * @param {HTMLElement} ElementoHTML - Elemento HTML a Mover
 * @param {string} PositionXY - Posicion a mover el HTML con el siguiente formato: "Xpx|Ypx" Ejemplo: "20px|20px"
 * @param {string} positionType - Tipo de posicionamiento, por ejemplo "Absolute"
*/
function MoverHTMLElementToYRelativePorcentage(ElementoHTML, PositionXY, positionType) {
    ElementoHTML.style.position = positionType;

    var Y = PositionXY.split("|")[1].split("px")[0];

    //(100*X)/100% de La X Ventana
    var YCalculada = (100 * Y) / w.innerHeight;

    ElementoHTML.style.top = YCalculada + "%";
}

/** - Posicion en X del Mouse
 * @return {number}
*/
function MousePositionX(e) {
    var x = e.clientX;
    return x;
}

/** - Posicion en Y del Mouse
 * @return {number}
*/
function MousePositionY(e) {
    var x = e.clientY;
    return x;
}

/** - Posicion en X del Touch en dispositivos moviles
 * @param {Event} theEvent Evento de Toque, es necesario para calcular la posicion
 * @return {number}
*/
function TouchPositionX(theEvent) {
    var x = theEvent.touches[0].clientX;
    return x;
}

/** - Posicion en Y del Touch en dispositivos moviles
 * @param {Event} theEvent Evento de Toque, es necesario para calcular la posicion
 * @return {number}
*/
function TouchPositionY(theEvent) {
    var x = theEvent.touches[0].clientY;
    return x;
}

/** - Altura de la Pantalla
 * @return {number}
*/
function ScreenWidth() {
    return $(w).width();
}

/** - Anchura de la pantalla
 * @return {number}
*/
function ScreenHeight() {
    return $(w).height();
}

/** - si le pasamos el HTMLElement de un LayerElement nos devuelve la id (numero)
 * @param {HTMLElement} HTMLElement Elemento que usaremos de referencia para obtener el ID de la Layer
 * @return {number}
*/
function getLayerID(HTMLElement){
    return (HTMLElement.id.split("-")[0]);
}

/** - si le pasamos el HTMLElement hijo de un LayerElement nos devuelve el LayerElement (HTMLElement)
 * @param {HTMLElement} HTMLElement Elemento que usaremos de referencia para obtener el LayerElement
 * @return {HTMLElement}
*/
function getLayerElementFromChidElement(HTMLElement){
    var ready = false;
    let ActualHTMLElement = HTMLElement;

    while(!ready){
        if(hasClass(ActualHTMLElement, 'LayerElement')){
            ready = true;
        }else{
            ActualHTMLElement = ActualHTMLElement.parentElement;
        }
    }

    return ActualHTMLElement;
}

/** - Esto cambia el boton y la transparencia del nombre de la capa segun si esta es visible o no, pero lo hace con los datos de LayerData
 *
 * @param {HTMLElement} ChakcboxElement Elemento del Checkbox para cambairlo visualmente.
 * @param {LayerData} LayerData Layer a la que se va a afectar
 */
function SetLayerVisibilityByLayerDataOnGUI(ChakcboxElement, LayerData){
    //activa y desactiva la capa seleccionada, tambien cambia su icono y opacity de texto
    var checkbox = ChakcboxElement.getElementsByClassName("LE_Checkbox")[0];
    checkbox.checked = !LayerData.Visible;

    var checkboxIcon = ChakcboxElement.getElementsByClassName("LE_Icon")[0];
    checkboxIcon.src = LayerData.Visible == false ? LD_ShowLayer : LD_HideLayer;

    var checkboxText = ChakcboxElement.parentElement.getElementsByClassName("LE_Name_Container")[0]
    // checkboxText.style.opacity = LayerData.Visible == false ? 1 : 0.3;
    if(LayerData.Visible != false){
        checkboxText.classList.add("LE_Name_Disabled");
    }else{
        checkboxText.classList.remove("LE_Name_Disabled");
    }
}

/** - Esto setea la visibilidad por defecto de una capa en la gui e internamente usando el elemento LayerData
 *
 * @param {HTMLElement} ChakcboxElement Elemento del Checkbox para cambairlo visualmente.
 * @param {LayerData} LayerData Layer a la que se va a afectar
 */
function SetLayeDefaultVisibilityByLayerDataOnGUI(ChakcboxElement, LayerData){
    //activa y desactiva la capa seleccionada, tambien cambia su icono y opacity de texto
    var checkbox = ChakcboxElement.getElementsByClassName("LE_Checkbox")[0];
    checkbox.checked = LayerData.Visible;

    var checkboxIcon = ChakcboxElement.getElementsByClassName("LE_Icon")[0];
    checkboxIcon.src = LayerData.Visible? LD_ShowLayer : LD_HideLayer;

    var checkboxText = ChakcboxElement.parentElement.getElementsByClassName("LE_Name_Container")[0]
    //checkboxText.style.opacity = LayerData.Visible? 1 : 0.3;
    if(LayerData.Visible == false){
        checkboxText.classList.add("LE_Name_Disabled");
    }else{
        checkboxText.classList.remove("LE_Name_Disabled");
    }
}

/** Setea la Visibilidad en el LayerData usando la ID de la capa
 *
 * @param {number} idDeLaCapa LayerData A afectar
 * @param {boolean} isVisible Valor a aplicar, true = visible, false = no visible
 */
function SetLayerVisibility(idDeLaCapa, isVisible) {
    w.layersDelMapa.Lista[idDeLaCapa].Visible = isVisible;
    //w.map.getLayers().getArray()[idDeLaCapa].set('visible', isVisible);
    //cambiada para funcionar con layers mas genericas
    w.layersDelMapa.Lista[idDeLaCapa].OpenLayerSource.set('visible', isVisible) ;
}

/** Setea la Visibilidad en el LayerData usando LayerData
 *
 * @param {LayerData} LayerData LayerData A afectar
 * @param {boolean} isVisible Valor a aplicar, true = visible, false = no visible
 */
function SetLayerVisibilityByLayerData(LayerData, isVisible) {
    LayerData.Visible = isVisible;
    //w.map.getLayers().getArray()[idDeLaCapa].set('visible', isVisible);
    //cambiada para funcionar con layers mas genericas
    LayerData.OpenLayerSource.set('visible', isVisible) ;
}

function Get_TipoDeCapa(layerData){
    let ArchivoVectorial = "geojson json kml gpx igc topojson ol";
    let ArchivoRaster = "geotif geotiff";
    let Servicio = "wms basemap";

    if(ArchivoVectorial.indexOf(layerData.Formato.toLowerCase()) != -1 ){
        return "Archivo Vectorial";
    }

    if(ArchivoRaster.indexOf(layerData.Formato.toLowerCase()) != -1 ){
        return "Archivo Raster";
    }

    if(Servicio.indexOf(layerData.Formato.toLowerCase()) != -1 ){
        return "Servicio Web";
    }

    return "Desconocido";
}

/** - obtiene el offset del click del mouse con respecto de un Elemento HTML
 * @param {HTMLElement} elemento elemento html al que vamos a comprobar le ofset del click
 * @returns {{left:number, top:number}} Regresa un objeto con las coordenadas en {left,top}
 */
function getOffset(elemento) {
    const rect = elemento.getBoundingClientRect();
    return {
        left: rect.left + w.scrollX,
        top: rect.top + w.scrollY
    };
}

/** - Crea un Tooltip con el Retraso pasdo por parametros, y tiene la capasidad de reemplazar ciertos Textos con funciones HTML
 *
 * @param {HTMLElement} elem - Elemento sobre el que estara el ToolTip
 * @param {number} delayInMs - Retraso para aparecer en Milisegundos
 * @param {string} texto - Texto a mostrar en el ToolTip
 * @param {string} FunctionText - Funcion que Reemplazara Contenidos, "=>" reemplaza el Contenido a la izquierda con el de la derecha ej "\n=>nbsp" cambiaria el salto de linea estandar de JS por el de HTML
 */
var delayToolTip = function (elem, delayInMs, textoHTML) {
    var timeout = null;

    elem.onmouseover = function () {
        if (textoHTML != null) {
            timeout = setTimeout(function () { ActualizarTooltipInerHTML(textoHTML) }, delayInMs);
        }else{
            if(elem.getAttribute("tooltip") != undefined && elem.getAttribute("tooltip") != null){
                timeout = setTimeout(function () { ActualizarTooltipInerHTML(elem.getAttribute("tooltip")) ; }, delayInMs);
            }else{
                if(elem.id != undefined && elem.id != null){
                    timeout = setTimeout(function () { ActualizarTooltipInerHTML(elem.id); }, delayInMs);
                }else{
                    console.error("el elemento no tiene id para mostrar");
                    console.error(elem);
                }
                
            }
            
        }
    };

    elem.onmouseout = function () {
        // Clear any timers set to timeout
        clearTimeout(timeout);
        ActualizarTooltipInerHTML("");
        //$(".ToolTip").text("");
    };

    elem.addEventListener('mousedown', function () {
        // Clear any timers set to timeout
        clearTimeout(timeout);
        ActualizarTooltipInerHTML("");
        //$(".ToolTip").text("");
    });
};

//elementos necesarios para disparar el tooltip
const Evt_TooltipUpdate = new Event("TooltipUpdate");
const Evt_MouseMoveOnMap = new Event("MouseMoveOnMap");
//dispara el evento del tooltip
var ActualizarTooltip = function(content){
    ToolTipElement.textContent = content;
    ToolTipElement.dispatchEvent(Evt_TooltipUpdate)
};

var ActualizarTooltipInerHTML = function(content){
    ToolTipElement.innerHTML = content;
    ToolTipElement.dispatchEvent(Evt_TooltipUpdate)
};

w.ActualizarCoordenadasMouse = function(content){
    // console.log("Actualizar Coordenadas Mouse")
    
    if(w.mapElement == undefined)
        w.mapElement = document.getElementById("map");

    mapElement.dispatchEvent(Evt_MouseMoveOnMap)
};

/** - Esto crea de forma generica el boton de apagar/prendewr Layers usando LayerData
 *
 * @param {HTMLElement} ChakcboxElement
 * @param {LayerData} LayerData
 */
function E_CeckboxApagarLayersByLayerData(ChakcboxElement, LayerData) {
    //apaga la capa asociada a es layerElementData (LayerData)
    ChakcboxElement.addEventListener('click', function () {
        SetLayerVisibilityByLayerDataOnGUI(ChakcboxElement, LayerData);
        SetLayerVisibilityByLayerData(LayerData, !LayerData.Visible);
    });
}

/** - Utilizando los datos del LayerData se cambia el menu contextual seun el formato de la capa y si es una capa por defecto
 * @param {LayerData} layerElementData Layer Data de la capa que se comprobara para crearle el menu contextual a medida
 */
function AdaptableContextMenu(layerElementData){

    let tipoCapa = layerElementData.Formato.toLowerCase();

    let esCapaVectorial = (tipoCapa != "basemap" && tipoCapa != "wms");
    let esPreCargada = layerElementData.CapaPreCargada;
    let esDescargable = layerElementData.CapaDescargable;

    CM_BotonZoomToLayer.style.display = "inline-flex";
    CM_Renombrar.style.display  = get_display(!esPreCargada);
    CM_BotonVerTabla.style.display = get_display(tipoCapa != "basemap");
    
    CM_BotonMetadata.style.display = "inline-flex";
    
    CM_BotonCambiarSimbolo.style.display = get_display(esCapaVectorial && !esPreCargada);
    CM_BotonEditarDatos.style.display = get_display(esCapaVectorial && !esPreCargada);
    CM_BotonDescargar.style.display = get_display(esCapaVectorial && !esPreCargada);

    CM_BotonDescargarWMS.style.display = get_display(tipoCapa == "wms" && esDescargable);
    
    CM_BotonEliminar.style.display = get_display(!esPreCargada);

    let CM_TransText_Cont = document.getElementById("CM_TransText_Container");
    CM_TransText_Cont.style.display = (esCapaVectorial && !esPreCargada) ? "inline-flex" : "block";
    if (document.getElementById("CM_BarraTransparenciaInput1") != null) {
        document.getElementById("CM_BarraTransparenciaInput1").id = "CM_BarraTransparenciaInput0";
    }
}

function get_display( boleano ){
    return boleano? "inline-flex" : "none";
}

//ELIMINAR LUEGO DE TESTEAR
/** - Utilizando los datos del LayerData se cambia el menu contextual seun el formato de la capa y si es una capa por defecto
 * @param {LayerData} layerElementData Layer Data de la capa que se comprobara para crearle el menu contextual a medida
 */
// function AdaptableContextMenu2(layerElementData){

//     //enciendo o apago los botones segun necesito utilizando como
//     //discriminante el formato de la capa y si es por defecto o no
//     //asumiendo que layerElementData es un objeto de tipo LayerData
//     switch (layerElementData.Formato.toLowerCase()) {
//         case "basemap":
//             CM_BotonZoomToLayer.style.display = "inline-flex";
//             CM_Renombrar.style.display = "none";
//             CM_BotonVerTabla.style.display = "none";
//             CM_BotonMetadata.style.display = "inline-flex";
//             CM_BotonCambiarSimbolo.style.display = "none";
//             CM_BotonEditarDatos.style.display = "none";
//             CM_BotonDescargar.style.display = "none";
//             CM_BotonDescargarWMS.style.display = "none";
//             CM_BotonEliminar.style.display = "none";
//             document.getElementById("CM_TransText_Container").style.display = "block";
//             if (document.getElementById("CM_BarraTransparenciaInput1") != null) {
//                 document.getElementById("CM_BarraTransparenciaInput1").id = "CM_BarraTransparenciaInput0";
//             }
//             break;

//         case "wms":
//             CM_BotonZoomToLayer.style.display = "inline-flex";
//             CM_Renombrar.style.display = "none";
//             CM_BotonVerTabla.style.display = "inline-flex";
//             CM_BotonMetadata.style.display = "inline-flex";
//             CM_BotonCambiarSimbolo.style.display = "none";
//             CM_BotonEditarDatos.style.display = "none";
//             CM_BotonDescargar.style.display = "none";
//             document.getElementById("CM_TransText_Container").style.display = "block";
//             if (document.getElementById("CM_BarraTransparenciaInput1") != null) {
//                 document.getElementById("CM_BarraTransparenciaInput1").id = "CM_BarraTransparenciaInput0";
//             }

//             //compruebo si el wms sera descargable
//             if (layerElementData.CapaDescargable == false) {
//                 CM_BotonDescargarWMS.style.display = "none";
//             } else {
//                 CM_BotonDescargarWMS.style.display = "inline-flex";
//             }
//             break;

//         default:
//             CM_BotonZoomToLayer.style.display = "inline-flex";
//             CM_Renombrar.style.display = "inline-flex";
//             CM_BotonVerTabla.style.display = "inline-flex";
//             CM_BotonMetadata.style.display = "inline-flex";
//             CM_BotonCambiarSimbolo.style.display = "inline-flex";
//             CM_BotonEditarDatos.style.display = "inline-flex";
//             CM_BotonDescargar.style.display = "inline-flex";
//             CM_BotonDescargarWMS.style.display = "none";
//             document.getElementById("CM_TransText_Container").style.display = "inline-flex";
//             if (document.getElementById("CM_BarraTransparenciaInput0") != null) {
//                 document.getElementById("CM_BarraTransparenciaInput0").id = "CM_BarraTransparenciaInput1";
//             }
//             break;
//     }

//     //en caso de que sea pre cargada se desactiva el boton de Eliminar
//     if (layerElementData.CapaPreCargada == true) {
//         CM_BotonEliminar.style.display = "none";

//         if(layerElementData.Formato.toLowerCase() == "geojson"){
//             CM_Renombrar.style.display = "none";
//             CM_BotonEditarDatos.style.display = "none";
//             CM_BotonDescargar.style.display = "none";
//             document.getElementById("CM_TransText_Container").style.display = "block";
//                 if (document.getElementById("CM_BarraTransparenciaInput1") != null) {
//                     document.getElementById("CM_BarraTransparenciaInput1").id = "CM_BarraTransparenciaInput0";
//                 }
//         }
            
//     } else {
//         CM_BotonEliminar.style.display = "inline-flex";
//     }

//     if(layerElementData.CapaPreCargada == true){
//         if(layerElementData.Formato.toLowerCase() == "wms"){
//             CM_BotonEliminar.style.display = "inline-flex";
//         }
//     }

// }

/** - Esto crea de forma generica el boton de menu contextual
 * @param {HTMLElement} LE_Options_Container
 */
function E_LayerContextMenuButon(LE_Options_Container) {
    LE_Options_Container.addEventListener('click', function () {
        //para obtener la id de la capa interactuada en la interface
        lastLayerElementChanged = this.parentElement;

        //la layerData de la capa interaccionada
        let layerElementData = w.layersDelMapa.Lista[lastLayerElementChanged.id.split("-")[0]];

        //guardo el context menu para afectarlo mas facilmente
        var contextMenu = document.getElementById('ContextMenu1');

        //re inicializo el tooltip  //esto se va a eliminar
        //document.getElementById("CM_ToolTip").textContent = "Seleccione una Opción...";

        //obtengo la posicion relativa del layerDysplay
        var layerDysplay = document.getElementById('LayerDisplay');
        var posicionCalculadaDesdeLayerDisplay = getOffset(layerDysplay);

        //reseteo la transparencia al valor que la capa tenia
        document.getElementsByClassName("CM_BarraTransparencia")[0].value = w.layersDelMapa.GetOpacacity(layerElementData) * 100;
        
        //lleno el porcentaje con el porcentaje de transparencia de la barra
        document.getElementById("CM_TextoTransparencia").textContent = "Opacidad -   " + CM_BarraTransparencia.value + " %";
        
        
        AdaptableContextMenu(layerElementData);

        //posicion relativa del boton que se pulso para abrir el menu
        var PosicionBotonOpcionesLE = getOffset(LE_Options_Container);
        var hideLayerDysplayButon = document.getElementsByClassName("hideLayerDisplay")[0];

        //comprubeo si el mouse esta por ensima de la mitad de la pantalla
        //logica detras de esto, la Y sube hacia abajo, por ende y + la mitad de la pamtalla quiere decir que esta abajo
        if (PosicionBotonOpcionesLE.top > (posicionCalculadaDesdeLayerDisplay.top + $(layerDysplay).height() - $(contextMenu).height() - 12)) {
            //console.log("Low Draw");
            // document.getElementById("LayerDisplay").style = "border-bottom-right-radius: 0px;";
            //posiciono el menu contextial desde la esquina inferior izquierda
            var posicionCalculada = (posicionCalculadaDesdeLayerDisplay.left + $(layerDysplay).width()) + "px" + "|" + (posicionCalculadaDesdeLayerDisplay.top + $(layerDysplay).height() - $(contextMenu).height() - 13) + "px";
        } else {
            
            
            if (PosicionBotonOpcionesLE.top < (posicionCalculadaDesdeLayerDisplay.top + $(hideLayerDysplayButon).height())) {
                //console.log("Top Draw");
                var posicionCalculada = (posicionCalculadaDesdeLayerDisplay.left + $(layerDysplay).width()) + "px" + "|" + (posicionCalculadaDesdeLayerDisplay.top -1) + "px";
                hideLayerDysplayButon.style = "visibility: hidden;";
            
            }else{
                //console.log("Mid Draw");
                //posiciono el menu contextial desde la esquina superior izquierda
                var posicionCalculada = (posicionCalculadaDesdeLayerDisplay.left + $(layerDysplay).width()) + "px" + "|" + (PosicionBotonOpcionesLE.top - 1) + "px";
            
            }
            
        }

        // if (lastLayerElementChanged.id.split('-')[0] == 0) {
        //     var posicionCalculada = (posicionCalculadaDesdeLayerDisplay.left + $(layerDysplay).width()) + "px" + "|" + (posicionCalculada2.top -1) + "px";
        //     document.getElementsByClassName("hideLayerDisplay")[0].style = "visibility: hidden;";
        // }

        //convertirPixelesAViewport("Xpx|Ypx"); return "Xvw|Yvh"
        //100% = 1080p
        // X = 500p
        // x = (100% * 500p)/1080p

        //con lo calculado muevo el elemento
        MoverHTMLElementToYRelativePorcentage(contextMenu, posicionCalculada, "absolute");

        //muetro y le doy focus al context menu
        MostrarElementoHTML(contextMenu);
        contextMenu.focus();

        lastLayerElementChanged.className = lastLayerElementChanged.className.replace("BaseColorSinHover","BaseColorEstadoHover");
        lastLayerElementChanged.id = lastLayerElementChanged.id.split("-")[0] + "-" + "pausado";

    });

    delayToolTip(LE_Options_Container, standarToolTipDelayInMS, "<span>Opciones de la Capa</span>");

}

/** - Funcion que disparara el estado "editando" del texto del name container pasado por parametro
 * @param {HTMLElement} LE_Name_Container
 */
function RenombrarCapa(LE_Name_Container) {
    //esta comprobacion es para evitar aplicar el imput cuando ya esta activado
    //"LE_Name_Text_Imput" se llamara mientras se este editando
    if (LE_Name_Container.childNodes[0].className == "LE_Name_Text") {

        //le quito la capacidad de ser dragueable a ese elemento mientras se edita el nombre
        LE_Name_Container.parentElement.draggable = "false";

        //activo la capacidad del texto de ser editable y le cambio la clase para evitar re disparar esto y para cambiar el style
        //(LE_Name_Container.childNodes[0] siempre sera el elemento que tenga el nombre dentro del LE_Name_Container)
        LE_Name_Container.childNodes[0].contentEditable = true;
        LE_Name_Container.childNodes[0].className = "LE_Name_Text_Imput";

        //luego de setear todos los eventos apunto el focus al editor del nombre
        LE_Name_Container.childNodes[0].focus();
    }
}

/** - EVENTO - esto creará el eveto para cambiar el nombre de una capa al hacer Doble Click
 * @param {HTMLElement} LE_Name_Container
*/
function E_NameContainerChangeTextOnClick(LE_Name_Container) {

    let layerElementData = w.layersDelMapa.Lista[LE_Name_Container.parentElement.id.split("-")[0]];
    // if (layerElementData.Formato.toLowerCase() != "wms" && layerElementData.Formato.toLowerCase() != "basemap") {
    if (layerElementData.CapaPreCargada == false) {
        //disparo un evento cuando se clickea
        LE_Name_Container.addEventListener('dblclick', function () {
            //disparo la funcion generica que hice para renombrar la capa
            RenombrarCapa(LE_Name_Container);
        });

        //esto pasa si se pierde el foco del texto que se esta editando
        LE_Name_Container.childNodes[0].addEventListener('focusout', function () {
            LE_Name_Container.childNodes[0].contentEditable = false;
            LE_Name_Container.childNodes[0].className = "LE_Name_Text";

            //me aseguro de no guardar el texto con un enter
            LE_Name_Container.childNodes[0].textContent = LE_Name_Container.childNodes[0].textContent.replace("\r\n", ""); //\r\n
            //aca hay que implementar Correcciones para poder controlar cosas que no van en el texto

            LE_Name_Container.parentElement.draggable = "true";

            //me aseguro de acualizar el texto del elemento del mapa
            layerElementData.Nombre = LE_Name_Container.childNodes[0].textContent;
            w.Update_EditableLayersTable();
        });

        //esto se disparara si se apreta el enter, y saldra de la edicion
        LE_Name_Container.childNodes[0].addEventListener('keydown', function (e) {
            if (e.keyCode === 13 && LE_Name_Container.childNodes[0].className == "LE_Name_Text_Imput") {
                LE_Name_Container.childNodes[0].blur()
            }
        });

        //este evento extraño se disparara cuand el texto cambie, esto lo que ara sera que
        //siempre que cambie el texto se comprobara si se puso un enter y lo borrara
        LE_Name_Container.childNodes[0].addEventListener('beforeinput', function () {
            LE_Name_Container.childNodes[0].textContent = LE_Name_Container.childNodes[0].textContent.replaceAll("\r\n", ""); //\r\n
        });
    }


}

/** - Comprueba se  el elemento tiene la clase Pasada por parametro
 * @param {HTMLElement} HTMLElement Elemento a comprobar
 * @param {string} className Clase a Comprobar
 */
function hasClass(HTMLElement, className) {
    return (' ' + HTMLElement.className + ' ').indexOf(' ' + className + ' ') > -1;
}

//#endregion

//#region CREANDO LAYERS EN EL MENU DE LAYERS Y ACTUALIZANDOLAS EN TIEMPO REAL
w.layersDelMapaGUI = class LayersDelMapa {
    constructor(Lista) {
        this.Lista = Lista;
    }
};

//inicializo la lista de capas de la interface
w.layersDelMapaGUI.Lista = [];

w.layersDelMapaGUI.UpdateAllLayersOnGUI = function () {
    //primero elimino todos los elementos en la lista
    let LayerDisplay = document.getElementById("LayerDisplay");
    for(let capaEliminando = LayerDisplay.children.length-1; capaEliminando > 0; capaEliminando--){
        LayerDisplay.children[capaEliminando].remove()
    }

    //agregar los elementos nuevamente desde los elementos de la lista
    for(let capaDibujando = 0; capaDibujando < layersDelMapa.Lista.length; capaDibujando++){
        LayerDisplay.appendChild(layersDelMapa.Lista[capaDibujando].GUILayer)
    }
}

//crea el elemento html compuesto que corresponde a la layer y se lo agrego
w.layersDelMapaGUI.CreateHTMLElementForLayerData = function (LayerData) {

    let LayerDisplay = document.getElementById("LayerDisplay");
    // LAYER ELEMENT
    //craeando los elementos uno por uno
    //creando <div class="LayerElement">
    let layerElement = document.createElement('div');
    layerElement.className = "LayerElement BaseColorSinHover";
    //layerElement.className = "LayerElement BaseColor Draggable";
    //layerElement.draggable = "true";
    layerElement.id = layersDelMapa.Lista.indexOf(LayerData) + "-";

    //#region LAYER ELEMENTS, Botones Animados, esto fue necesario para solucionar un bug
        layerElement.addEventListener('mouseover', function () {
            if(w.layersDelMapaGUI.selectedLayerClone == undefined){ // este if es para que no brillen las layers mientras se dragean
                //layerElement.style.backgroundColor = 'rgba(100, 148, 250, 0.3)';
                layerElement.className = layerElement.className.replace("BaseColorSinHover", "BaseColorEstadoHover")
            }
        });

        layerElement.addEventListener('mouseleave', function () {
            if (layerElement.id.split("-")[1] != "pausado")
            layerElement.className = layerElement.className.replace("BaseColorEstadoHover", "BaseColorSinHover")
        });
    //#endregion

    // CHECKBOX CONTAINER
    //creo el LE_Checkbox_Container
    let LE_Checkbox_Container = document.createElement('div');
    LE_Checkbox_Container.className = "LE_Checkbox_Container BaseColorExtraTransparent ";

    //hide Icon Checkbox
    let LE_Icon = document.createElement("img");
    LE_Icon.className = "LE_Icon";
    LE_Icon.src = LD_ShowLayer;

    // CHECKBOX
    let LE_Checkbox = document.createElement('input');
    LE_Checkbox.className = "LE_Checkbox";
    LE_Checkbox.type = "checkbox";
    LE_Checkbox.checked = LayerData.Visible;
    LE_Checkbox_Container.appendChild(LE_Checkbox);
    LE_Checkbox_Container.appendChild(LE_Icon);

    //lo agrego  LE_Checkbox_Container con el chekbox al elemento terminado
    layerElement.appendChild(LE_Checkbox_Container);

    // NAME CONTAINER
    let LE_Name_Container = document.createElement('div');
    LE_Name_Container.className = "LE_Name_Container";
    //LE_Name_Container.style.opacity = 1;

    // NAME TEXT
    let LE_Name_Text = document.createElement('a');
    LE_Name_Text.className = "LE_Name_Text";
    LE_Name_Text.textContent = LayerData.Nombre;
    //LE_Name_Text.style.opacity = 1;

    // NAME Format
    let LE_Format_Text = document.createElement('a');
    LE_Format_Text.className = "LE_Format_Text";
    LE_Format_Text.innerHTML = " (" + LayerData.Formato + ")";

    // NAME Fuente
    let LE_Fuente_Text = document.createElement('a');
    LE_Fuente_Text.className = "LE_Fuente_Text";
    var attributions = LayerData.Attributions;

    var attributions_url = LayerData.Attributions[0];
    var attributions_txt = LayerData.Attributions[1];

    
    if(attributions_txt != "" && attributions_txt != null && attributions_txt != undefined){
        LE_Fuente_Text.innerHTML = `
            <a>
                <br> 
                <span>Fuente:</span>
                <a class="FuenteLink" target="_blank"> 
                    ${attributions_txt}
                </a>
            </a>
        `

        if(attributions_url != "" && attributions_url != null && attributions_url != undefined){
            LE_Fuente_Text.getElementsByClassName("FuenteLink")[0].href = attributions_url
        }

    }else{
         LE_Fuente_Text.innerHTML = "<a></a>";
    }

    // if(attributions != "" && attributions != null && attributions != undefined){
    //     LE_Fuente_Text.innerHTML = "<a><br> (Fuente: " + attributions + ")</a>";
    //     LE_Fuente_Text.childNodes[1].className = "FuenteLink";
    //     LE_Fuente_Text.childNodes[1].target = "_blank";
    // }else{
    //     LE_Fuente_Text.innerHTML = "<a></a>";
    // }

    // NAME State
    let LE_State_Text = document.createElement('a');
    LE_State_Text.className = "LE_State_Text";
    LE_State_Text.innerHTML = "<br> <a class='editando'><a>";

    //agrego ambos textos al container
    LE_Name_Container.appendChild(LE_Name_Text);
    LE_Name_Container.appendChild(LE_Format_Text);
    LE_Name_Container.appendChild(LE_Fuente_Text);
    LE_Name_Container.appendChild(LE_State_Text);

    //lo agrego  LE_Checkbox_Container con el chekbox al elemento terminado
    layerElement.appendChild(LE_Name_Container);

    //OPTIONS CONTAINER
    let LE_Options_Container = document.createElement('div');
    LE_Options_Container.className = "LE_Options_Container BaseColorExtraTransparent ";

    //OPTIONS Icon
    let LE_IconOptions = document.createElement("img");
    LE_IconOptions.className = "LE_Icon";
    LE_IconOptions.src = LD_ContextMenu;

    LE_Options_Container.appendChild(LE_IconOptions);

    //configurando eventos del boton que abre el menu contextual
    E_LayerContextMenuButon(LE_Options_Container);

    //lo agrego  LE_Checkbox_Container con el chekbox al elemento terminado
    //LE_Options_Container.appendChild(LE_Options_Buton);
    layerElement.appendChild(LE_Options_Container);

    E_NameContainerChangeTextOnClick(LE_Name_Container);

    //ondragstart se cambia el elemento por una sombra, esto es para re organizar las capas
    E_ClickToDragLayerElement(layerElement)

    //esto lo agrego al final porque sino cuando busca al nombre para
    //ponerle la transparencia da null/undefined porque aun no esta todo unido

    //creo el evento para el boton del checkbox y activo la
    //visibilidad segun la capa
    E_CeckboxApagarLayersByLayerData(LE_Checkbox_Container, LayerData); //agrego el evento
    SetLayerVisibilityByLayerData(LayerData, LayerData.Visible); //pongo el valor por defecto de la visualizacion
    SetLayeDefaultVisibilityByLayerDataOnGUI(LE_Checkbox_Container, LayerData); //pongo la layer en prendio o apagado

    //ELEMENTO TERMINADO
    //agrego el elemento terminado al final
    //ahra no agrego el elemento a la hud sino a la layer
    //LayerDisplay.appendChild(layerElement);
    LayerData.GUILayer = layerElement;
}

//variables usadas para draguear las layers
    var LayerPadingY = 0
    var LayerOriginalClickPosition = 0
    var LayerDragActivated = false
    var LayerDragClick = false
    var LayerDragActivateDistance = 0
    var LayerDragDistance = 0
    var LayerDragRealTimeDistance = 0

//variables relacionadas al movimiento
    var MinimoSelectedLayerPrevLayer = 0
    var MaximoSelectedLayerNextLayer = 0
    var MedioSelectedLayer = 0

//variables referentes a la capa dragueada
    w.layersDelMapaGUI.positionCorrecter = true;
    w.layersDelMapaGUI.selectedLayer = undefined;
    w.layersDelMapaGUI.selectedLayerClone = undefined;
    var SelectedIndex = 0
    var NewIndex = 0

//para bloquear el scroll
    var ScrollBlock = false;
    var ScrollBlockX = null;
    var ScrollBlockY = null;
    var LayerDisplayElement = document.getElementById("LayerDisplay")
    var LayerDisplayFondo = document.getElementsByClassName("LayerDisplay_Fondo")[0]


//posicion dentrode LayerDisplay
var posisionLayerDisplay = 0
LayerDisplayElement.addEventListener('scroll', function (e) {

        ContextMenuElement.blur();

        var BgPositionXY = 0 + "px|" + LayerDisplayElement.scrollTop + "px"
        // MoverHTMLElementToXY(LayerDisplayFondo, BgPositionXY, "Absolute") //LayerDisplayFondo

        if (ScrollBlock == true) {
            if(isMobile){
                LayerDisplayElement.scrollTo(ScrollBlockX, ScrollBlockY);
            }
        }else{
            ScrollBlockY = LayerDisplayElement.scrollTop
            // console.log("ScrollBlockY = " + ScrollBlockY)
        }
});

//#region EVENTO MOUSEDOWN O TOUCH DOWN sobre la layer a arrastrar

    //funcion para activar el Drag, sirve para click y touch, para evitar repetir codigo
    function DragLayerStartDragEvent(e, HTMLElement){
            //pc control
        if(isMobile == false){
            if(!HTMLElement.childNodes[0].matches(":hover") && !HTMLElement.childNodes[2].matches(":hover")){
                if(!HTMLElement.childNodes[1].childNodes[0].className == "LE_Name_Text" && !HTMLElement.childNodes[1].childNodes[0].matches(":hover") || HTMLElement.childNodes[1].childNodes[0].className == "LE_Name_Text"){
                    //console.log(LE_Name_Text.textContent + " se marco...")

                    //w.layersDelMapaGUI.selectedLayerClone.className = w.layersDelMapaGUI.selectedLayerClone.className.replace("BaseColorEstadoHover", "BaseColorSinHover")

                    //guardo le elemento del LayerDisplay
                    let LayerDisplay = document.getElementById("LayerDisplay");

                    if(w.isMobile == false){
                        //esto es la distancia a la que se cliqueo dentro del bloque
                        LayerPadingY = e.offsetY;
                    }else{
                        var rect = e.target.getBoundingClientRect();
                        LayerPadingY = e.targetTouches[0].pageY - rect.top;
                    }

                    //seteo este elemento como el seleccionado
                    w.layersDelMapaGUI.selectedLayer = HTMLElement;

                    //seteo las variables de control para determinar si se esta dragueando una capa o no
                    LayerDragActivated = false
                    LayerDragClick = true
                    LayerOriginalClickPosition = mouseY;

                    //clono el elemento para simular el drag
                    w.layersDelMapaGUI.selectedLayerClone =  w.layersDelMapaGUI.selectedLayer.cloneNode(true);

                    //le cambio el stilo para no hover
                    w.layersDelMapaGUI.selectedLayerClone.style = "pointer-events: none; position: absolute; top = 0px; width: 100%; backdrop-filter: blur(5px); box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.4);"
                    w.layersDelMapaGUI.selectedLayerClone.className = w.layersDelMapaGUI.selectedLayerClone.className.replace("BaseColorEstadoHover", "BaseColorSinHover")

                    //agrego el clon al LayerDisplay para poder editarlo antes de que se evalue su altura
                    document.getElementsByClassName("LayerDisplay")[0].appendChild(w.layersDelMapaGUI.selectedLayerClone);
                    w.layersDelMapaGUI.selectedLayerClone.style.opacity = 0;

                    //esta variable es la distancia minima que tiene que recorrer el cursor para que se
                    //desplaze la layer, pero es calculado a partir del tamaño de la ventana para que
                    //sea mnas consistente
                    LayerDragActivateDistance = $(w).height()/100
                }
            }
        }else{
            //mobile phone
            if(!HTMLElement.parentElement.childNodes[1].childNodes[0].className == "LE_Name_Text" && !HTMLElement.parentElement.childNodes[1].childNodes[0].matches(":hover") || HTMLElement.parentElement.childNodes[1].childNodes[0].className == "LE_Name_Text"){
                //console.log(LE_Name_Text.textContent + " se marco...")

                //w.layersDelMapaGUI.selectedLayerClone.className = w.layersDelMapaGUI.selectedLayerClone.className.replace("BaseColorEstadoHover", "BaseColorSinHover")

                //guardo le elemento del LayerDisplay
                let LayerDisplay = document.getElementById("LayerDisplay");

                if(w.isMobile == false){
                    //esto es la distancia a la que se cliqueo dentro del bloque
                    LayerPadingY = e.offsetY;
                }else{
                    var rect = e.target.getBoundingClientRect();
                    LayerPadingY = e.targetTouches[0].pageY - rect.top;
                }

                //seteo este elemento como el seleccionado
                w.layersDelMapaGUI.selectedLayer = HTMLElement.parentElement;

                //seteo las variables de control para determinar si se esta dragueando una capa o no
                LayerDragActivated = false
                LayerDragClick = true
                LayerOriginalClickPosition = mouseY;

                //clono el elemento para simular el drag
                w.layersDelMapaGUI.selectedLayerClone =  w.layersDelMapaGUI.selectedLayer.cloneNode(true);

                //le cambio el stilo para no hover
                w.layersDelMapaGUI.selectedLayerClone.style = "pointer-events: none; position: absolute; top = 0px; width: 100%; backdrop-filter: blur(5px); box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.4);"
                w.layersDelMapaGUI.selectedLayerClone.className = w.layersDelMapaGUI.selectedLayerClone.className.replace("BaseColorEstadoHover", "BaseColorSinHover")

                //agrego el clon al LayerDisplay para poder editarlo antes de que se evalue su altura
                document.getElementsByClassName("LayerDisplay")[0].appendChild(w.layersDelMapaGUI.selectedLayerClone);
                w.layersDelMapaGUI.selectedLayerClone.style.opacity = 0;

                //esta variable es la distancia minima que tiene que recorrer el cursor para que se
                //desplaze la layer, pero es calculado a partir del tamaño de la ventana para que
                //sea mnas consistente
                LayerDragActivateDistance = $(w).height()/100

                ScrollBlock = true;
            }
        }

    };

    function E_ClickToDragLayerElement (layerElement){
        if(w.isMobile == false){
            //ondragstart se cambia el elemento por una sombra, esto es para re organizar las capas
            layerElement.addEventListener('mousedown', function(e){
                DragLayerStartDragEvent(e, this)
            });
        }else{
            layerElement.childNodes[2].addEventListener("touchstart", function(e){
                DragLayerStartDragEvent(e, this)
            });
        }
    } //END function E_ClickToDragLayerElement (layerElement){

//#endregion

//#region EVENTO MOUSEMOVE O TOUCHMOVE sobre la layer a arrastrar

    //FUNCION PARA EL EVENTO MOVE LAYER
    function DragLayerMoveEvent(e, HTMLElemnt){
        //si se cliqueo el elemento, entonces se esta dragueando, sino no se hace nada
        if(LayerDragClick == true){

            //guardo el LayerDysplay en una variable para ser mas claro
            let LayerDisplay = document.getElementById("LayerDisplay");

            //si no se esta dragueando la capa todavia. se setea todo lo necesario para poder empezar a draguear
            if(LayerDragActivated == false){
                //calculo la distancia del mouse hasta donde se cliqueo la layer
                //para que tenga un minimo de distancia de dragueo antes de comenzar el dragueo
                LayerDragDistance = Math.abs(mouseY - LayerOriginalClickPosition)

                //si la distancia del drag es mas00000 grande que la LayerDragActivateDistance entonces se comienda a draguear
                if(LayerDragDistance > LayerDragActivateDistance){

                    //hago visible el elemento clon y lo preparo para desplazarlo
                    w.layersDelMapaGUI.selectedLayerClone.style.opacity = 1;

                    //staileo el elemento como una sombra para esconderlo
                    w.layersDelMapaGUI.selectedLayer.style = 'background-color: rgba(0, 0, 0, 0.5); border-color: black; filter:blur(5px);'
                    w.layersDelMapaGUI.selectedLayer.childNodes[0].style.opacity = 0;
                    w.layersDelMapaGUI.selectedLayer.childNodes[1].style.opacity = 0;
                    w.layersDelMapaGUI.selectedLayer.childNodes[2].style.opacity = 0;

                    //activo el drag
                    LayerDragActivated = true;
                }
            }

            //esto es lo que ocurre cuando se activa el drag de la capa
            if(LayerDragActivated == true){

                //esta seran las cordenadas de la layer, esta calculada a partir del mouse, y el tamaño de la layers
                //var LayerElementNewY = mouseY - $(LayerDisplay).offset().top - LayerPadingY;
                var LayerElementNewY = mouseY - $(LayerDisplay).offset().top - LayerPadingY + ScrollBlockY;
                MoverHTMLElementToXY(w.layersDelMapaGUI.selectedLayerClone, "0px|"+ Math.max(LayerElementNewY, 0) +"px", "absolute" )

                //me guardo las posicioned de las capas, la nueva y la actual del la
                //layer para efectuar cambios solo si las capas no coinciden
                SelectedIndex = Array.prototype.indexOf.call(LayerDisplay.children, w.layersDelMapaGUI.selectedLayer)
                NewIndex = Array.prototype.indexOf.call(LayerDisplay.children, HTMLElemnt)

                //compruebo si el siguiente elemento es nulo o el fondo para asi setear la altura
                //minima a la que se tiene que subir para activar el cambio con la capa de arriba
                if(w.layersDelMapaGUI.selectedLayer.previousElementSibling == null || w.layersDelMapaGUI.selectedLayer.previousElementSibling == document.getElementsByClassName("LayerDisplay_Fondo")[0]){
                    MinimoSelectedLayerPrevLayer = 0
                }else{
                    MinimoSelectedLayerPrevLayer = (w.layersDelMapaGUI.selectedLayer.previousElementSibling).offsetTop + $(w.layersDelMapaGUI.selectedLayer.previousElementSibling).height()/2
                }

                //seteo la cantidad maxima a la que tiene que bajar la capa seleccionada para
                //cambiar con la capa siguiente
                MaximoSelectedLayerNextLayer = (w.layersDelMapaGUI.selectedLayer.nextElementSibling).offsetTop + $(w.layersDelMapaGUI.selectedLayer.nextElementSibling).height()/2

                //seteo la posicion atual a la que considero para medir, esta posicion se calcula
                //en el medio del elemento seleccionado
                MedioSelectedLayer = ((w.layersDelMapaGUI.selectedLayerClone).offsetTop + $(w.layersDelMapaGUI.selectedLayerClone).height()/2)

                //si la posicion nueva donde se debe poner la capa es distinta a la actual
                if(SelectedIndex != NewIndex){
                    if(SelectedIndex == 2){
                        if (w.layersDelMapaGUI.selectedLayerClone.offsetTop < 10) {
                            //basicamente re-inserto el elemento en una posicion nueva, en este
                            //caso la posicion del elemento anterior
                            LayerDisplay.insertBefore(w.layersDelMapaGUI.selectedLayer, w.layersDelMapaGUI.selectedLayer.previousElementSibling);
                        }else if( MedioSelectedLayer > MaximoSelectedLayerNextLayer ){
                            //console.log("Moviendo Abajo")
                            if (w.layersDelMapaGUI.selectedLayer.nextElementSibling != w.layersDelMapaGUI.selectedLayerClone) {
                                //basicamente re-inserto el elemento en una posicion nueva, en este caso la
                                //posicion SIGUIENTE del elemento siguiente, esto es necesario que sea asi
                                LayerDisplay.insertBefore(w.layersDelMapaGUI.selectedLayer, w.layersDelMapaGUI.selectedLayer.nextElementSibling.nextElementSibling);
                            }
                        }//END MedioSelectedLayer > MaximoSelectedLayerNextLayer
                    }else{

                        if( MedioSelectedLayer < MinimoSelectedLayerPrevLayer ){
                            //aca espesificamente no dejo subir a la primera capa por cuestiones complicadas, y mejor evitar.
                            if(SelectedIndex > 2){
                                //console.log("Moviendo Arriba")
                                if (w.layersDelMapaGUI.selectedLayer.previousElementSibling != w.layersDelMapaGUI.selectedLayerClone) {
                                    //basicamente re-inserto el elemento en una posicion nueva, en este
                                    //caso la posicion del elemento anterior
                                    LayerDisplay.insertBefore(w.layersDelMapaGUI.selectedLayer, w.layersDelMapaGUI.selectedLayer.previousElementSibling);
                                }
                            }

                        }else if( MedioSelectedLayer > MaximoSelectedLayerNextLayer ){
                            //console.log("Moviendo Abajo")
                            if (w.layersDelMapaGUI.selectedLayer.nextElementSibling != w.layersDelMapaGUI.selectedLayerClone) {
                                //basicamente re-inserto el elemento en una posicion nueva, en este caso la
                                //posicion SIGUIENTE del elemento siguiente, esto es necesario que sea asi
                                LayerDisplay.insertBefore(w.layersDelMapaGUI.selectedLayer, w.layersDelMapaGUI.selectedLayer.nextElementSibling.nextElementSibling);
                            }
                        }//END MedioSelectedLayer > MaximoSelectedLayerNextLayer
                    }

                }//END SelectedIndex != NewIndexSelectedIndex != NewIndex

            }//END if(LayerDragActivated == true)

        }//END if(LayerDragClick == true)
    }

    //EVENT LISTENER PARA MOVERMOUSE Y MOVER TOUCH
    //aqui se va a evaluar el movimiento del mouse para asi disparar el drag de la capa y el cambio de orden de capas
    if(w.isMobile == false){
        w.addEventListener("mousemove", function(e){
            DragLayerMoveEvent(e, this)
        }); //END w.addEventListener("mousemove", function(e){
    }else{
        w.addEventListener("touchmove", function(e){
            DragLayerMoveEvent(e, this)
        }); //END w.addEventListener("mousemove", function(e){
    }

//#endregion

//#region EVENTO MOUSEUP O TOUCHUP sobre la layer a arrastrar
    //FUNCION PARA EL EFENTO disparado al dejar de draguear una capa
    function DragLayerEndDragEvent(e, HTMLElement){
        //solo si se arrastro un elemento
        if(w.layersDelMapaGUI.selectedLayer != undefined ){

            //devuelvo el elemento al estilo original (el elemento seleccionado, no el clon)
            w.layersDelMapaGUI.selectedLayer.style = null;
            w.layersDelMapaGUI.selectedLayer.childNodes[0].style = null;
            w.layersDelMapaGUI.selectedLayer.childNodes[1].style = null;
            //esto es para dejar cas capas apagadas como apagadas al draguearlas
            var LE_Checkbox = w.layersDelMapaGUI.selectedLayer.getElementsByClassName("LE_Checkbox")[0]
            //w.layersDelMapaGUI.selectedLayer.childNodes[1].style.opacity = LE_Checkbox.checked ? 1 : 0.3;
            w.layersDelMapaGUI.selectedLayer.childNodes[2].style = null;

            //elimino el clon, porque ya no es necesario (solo si existe)
            if(w.layersDelMapaGUI.selectedLayerClone != undefined){
                w.layersDelMapaGUI.selectedLayerClone.remove();
                w.layersDelMapaGUI.selectedLayerClone = undefined
            }

            //actualizo la posicion del elemento en la tabla de LayerData
            //esta condicion es necesaria para no actualizar mal el orden
            //de las capas cuando no se alteró
            if(LayerDragActivated == true){
                ActualizarPosicionDeLasCapas(getLayerID(w.layersDelMapaGUI.selectedLayer), SelectedIndex-1)
            }

            //w.layersDelMapaGUI.selectedLayer.id = (SelectedIndex-1) + "-"

            //reinicializo la variable global que guarda la capa seleccionada
            w.layersDelMapaGUI.selectedLayer = undefined;

            //reseteo las variables de control
            LayerDragActivated = false
            LayerDragClick = false
            ScrollBlock = false;

        }
    }

    //EVENT LISTENER al levantar el click o dejar de hacer touch
    if(w.isMobile == false){
        //cuando se leveanta el click se deja de reorganizar elementos con el drag
        w.addEventListener('mouseup', function(e){
            DragLayerEndDragEvent(e, this)
        }); //END w.addEventListener('mouseup', function(e){
    }else{
        //cuando se leveanta el touch se deja de reorganizar elementos con el drag
        w.addEventListener('touchend', function(e){
            DragLayerEndDragEvent(e, this)
        }); //END w.addEventListener('mouseup', function(e){
    }
//#endregion

/** - Actualiza la posicion de una capa en la lista de capas al hacer el drag
 *
 * @param {number} posicionOriginal - posicion original de la capa
 * @param {number} posicionNueva - posicion nueva de la capa
 */
function ActualizarPosicionDeLasCapas(posicionOriginal, posicionNueva){
    //console.log("capa from " + posicionOriginal + " to " + posicionNueva)
    w.layersDelMapa.ChangeLayerPosition(posicionOriginal, posicionNueva);
    ActualizarPosicionDeLasCapasEnHud()
}

/** - Actualiza la posicion de una capa en HUD al hacer el drag
 */
function ActualizarPosicionDeLasCapasEnHud(){
    let LayerDisplay = document.getElementById("LayerDisplay");
    //console.log(LayerDisplay.children);

    var listaDeCapas = LayerDisplay.getElementsByClassName("LayerElement")

    for(var indiceCapa = 0; indiceCapa < listaDeCapas.length; indiceCapa++){
        if( getLayerID(listaDeCapas[indiceCapa]) != indiceCapa ){
            listaDeCapas[indiceCapa].id = indiceCapa + "-";
        }
    }

    //w.layersDelMapaGUI.UpdateLayersOnGUI();
}

//actualiza el elemento html compuesto que corresponde a la layer con la id indexc
w.layersDelMapaGUI.UpdateHTMLElementForLayerID = function (index, LayerActual, ElementoActual) {
    //seteo la LayerDisplay en una variable para poder reusalro
    let LayerDisplay = document.getElementById("LayerDisplay");

    ElementoActual.getElementsByClassName("LE_Name_Text")[0].textContent = LayerActual.Nombre;
    ElementoActual.getElementsByClassName("LE_Format_Text")[0].textContent = " (" + LayerActual.Formato + ")";
    ElementoActual.getElementsByClassName("LE_Checkbox")[0].checked = LayerActual.Visible;
}

//esto agrega las capas iniciales
//w.layersDelMapaGUI.UpdateLayersOnGUI();
w.layersDelMapaGUI.UpdateAllLayersOnGUI()

function HTMLelementAbsolutePosition(HTMLelement) {
    var CurrentLeftPosition = 0;
    var CurrentTopPosition = 0;
    if (HTMLelement.offsetParent) {
        do {
            CurrentLeftPosition += HTMLelement.offsetLeft;
            CurrentTopPosition += HTMLelement.offsetTop;
        } while (HTMLelement = HTMLelement.offsetParent);
    }
    return [CurrentLeftPosition, CurrentTopPosition];
}

var isIGMNegro = false;

function DarkThemeGUI( DarkThemeState ){
    if(DarkThemeState == true){
        isIGMNegro = false;
        RecalculateIGMPosition();
    }else{
        isIGMNegro = true;
        RecalculateIGMPosition();
    }
}

//#endregion

//#region Boton para esconer menu de layers

delayToolTip(botonHideDisplay, standarToolTipDelayInMS, null);

/** Escpnde el LayerDisplay
 */
function EsconderLayerDisplay(ejecucion){

    //si el meno esta a la vista pasa esto
    isLayerDusplayVisible = false;
    // EsconderElementoHTMLPorID('LayerDisplay');
    var LayerDysplayElement = document.getElementById("layerDisplayContainer")
    LayerDysplayElement.className = "LD_Cerrado";

    botonHideDisplay.style.height = "40px"
    botonHideDisplay.getElementsByClassName("LD_icon")[0].src = LD_ShowLayerDisplay;
    botonHideDisplay.id = "Mostrar el panel de Capas";

    //minimized zone cambia de tamaño para aprobecar el tamaño disponible
    document.getElementsByClassName("MinimizedZone")[0].className = document.getElementsByClassName("MinimizedZone")[0].className.replace('NormalWidth', 'FullWidth');
    ScaleBar_Container.className =  ScaleBar_Container.className.replace('LayerDisplayON', 'LayerDisplayOFF');
}

/** Muestra el LayerDisplay
 */
function MostrarLayerDisplay(ejecucion){

    //si el menu no esta a la vista pasa esto
    isLayerDusplayVisible = true;
    // MostrarElementoHTMLPorID('LayerDisplay');
    var LayerDysplayElement = document.getElementById("layerDisplayContainer")
    LayerDysplayElement.className = "LD_Abierto";

    botonHideDisplay.style.height = "40px"
    botonHideDisplay.getElementsByClassName("LD_icon")[0].src = LD_HideLayerDisplay;
    botonHideDisplay.id = "Esconde el panel de Capas";

    //minimized zone cambia de tamaño para aprobecar el tamaño disponible
    document.getElementsByClassName("MinimizedZone")[0].className = document.getElementsByClassName("MinimizedZone")[0].className.replace('FullWidth', 'NormalWidth');
    ScaleBar_Container.className =  ScaleBar_Container.className.replace('LayerDisplayOFF', 'LayerDisplayON');

}

//le coloco el evento al boton de esconder Layer Display
botonHideDisplay.addEventListener('click', function () {

    if (isLayerDusplayVisible == true) {
        EsconderLayerDisplay();
    } else {
        MostrarLayerDisplay();
    }
});
//#endregion

//#region Comportamintos del menu contextual
// //este bloque de cogio es para el boton de opciones para cada capa
var ContextMenuElement = document.getElementById("ContextMenu1");

//aca guardare el elemento para dejarlo coloreado mas
//tarde al tocar el boton de opciones
var lastLayerElementChanged; //elemetno de la clase HTMLElement(div)
var lastLayerInteracted; //Elemento de la clase LayerData()

//le doy el foco al menu contextual al cliquearlo
ContextMenuElement.addEventListener("click", function () {
    //nos pone el foco en el menu
    document.getElementById("ContextMenu1").focus();
});

//al perder el foco lo esconde y desactiva
$(ContextMenuElement).on('focusout', function () {
    // chequeo si me sali del menu contextual o si en realidad
    //toque la barra de transparencia
    if (!document.getElementsByClassName('CM_BarraTransparencia')[0].matches(':hover')) {

        if (!this.matches('hover')) {
            if (lastLayerElementChanged != undefined) { //esto arregla el error que se daba si se llamaban ambos eventos a la vez
                EsconderElementoHTML(this);
                lastLayerElementChanged.className = lastLayerElementChanged.className.replace("BaseColorEstadoHover","BaseColorSinHover");
                // lastLayerElementChanged.style.backgroundColor = 'rgba(101, 225, 240, 0.3)';
                lastLayerElementChanged.id = lastLayerElementChanged.id.split("-")[0] + "-" + "";
                //lastLayerElementChanged.setAttribute("pausado", true);
                lastLayerElementChanged = undefined;
                document.getElementsByClassName("hideLayerDisplay")[0].style = "visibility: visible;";
                // document.getElementById("LayerDisplay").style = "border-bottom-right-radius: 10px;";
            }
        }
    }
});
//#endregion

//#region BOTONES DEL MENU CONTEXTUAL

//esto mostrara el tooltip de todos los CM_Button con cierto delay
for (var index = 0; index < document.getElementsByClassName("CM_Buton").length; index++) {
    var elem = document.getElementsByClassName("CM_Buton")[index];

    delayToolTip(elem, standarToolTipDelayInMS, null);
}

//esto mostrara el tooltip de la barra trasnparencia con cierto delay
delayToolTip(document.getElementsByClassName("CM_Transparencia")[0], standarToolTipDelayInMS, "<span>Cambiar Opacacidad de la Capa.</span>", null);

//esto gestiona el evento del boton de zooom to layer del menu contextual
$(CM_BotonZoomToLayer).on('click', function () {
    var layerToUse = w.layersDelMapa.Lista[getLayerID(lastLayerElementChanged)];
    w.ZoomToLayer(layerToUse);
});

//esto gestiona el evento del boton de Renombrar del menu contextual
$(CM_Renombrar).on('click', function () {
    RenombrarCapa(lastLayerElementChanged.getElementsByClassName("LE_Name_Container")[0]);
});

$(CM_BotonVerTabla).on('click', function () {
    // console.log("Context menu: boton Ver Tabla... LayerId: " + lastLayerElementChanged.id.split("-")[0]);
});

$(CM_BotonMetadata).on('click', function () {
    if(!CM_BotonMetadata.classList.contains("Buton_OFF")){
        
        /** @type {LayerData} */
        var layerToUse = w.layersDelMapa.Lista[getLayerID(lastLayerElementChanged)];

        ContextMenuElement.blur();

        if(w.VentanaMetadatos != null && w.VentanaMetadatos != undefined){
            w.VentanaMetadatos.getElementsByClassName('W_Close')[0].click();
        }

        let nombreVentana = nombreCortado({nombre:layerToUse.Nombre, cantCaracteres:15, respetarEspacios:true, sobrecarga:true})

        //si la ventana no existe la creo
        w.VentanaMetadatos = CreateWindowID("Metadatos - " + nombreVentana, "MetadataWindow", modify, ['VentanaMetadatos', null]);
        // w.VentanaMetadatos = document.getElementById("Metadatos");

        //activo la ventana una vez creada
        ChangeActiveWindow(w.VentanaMetadatos);

        Metadata_CreateControls(w.VentanaMetadatos, layerToUse);

        //pongo la ventana en el medio de la ventana
        MoverVentanaAlCentroDiv(w.VentanaMetadatos, activeZone);
    
    }

    // console.log("Context menu: boton Metadatos... LayerId: " + lastLayerElementChanged.id.split("-")[0]);
});

$(CM_BotonCambiarSimbolo).on('click', function () {
    // console.log("Context menu: boton Cambiar Simbolo... LayerId: " + lastLayerElementChanged.id.split("-")[0]);
});

// function ventanaDePregunta(mensaje){
//     return confirm(mensaje);
// }

//trata deejecutar la operacin pedida en la capa seleccionada
function tryToExecuteLayerOperation(layerData, operation){

    //compruebo la tarea
    switch(operation){
        case "editar":
            return sePuedeEditar(layerData);
            break;

        case "descargar":
            return sePuedeDescargar(layerData);
            break;

        case "eliminar":
            return sePuedeEliminar(layerData);
            break;

        default:
            console.error("error desconocido, operacion invalida");
            break;
    }

}

//detiene la edicion en la segunda capa del array y la inicia en la primera capa del array
function changeEditingLayer(listOfLayerData){
    stopEditingInLayer(listOfLayerData[1]);
    setTimeout(() => {
        startEditingInLayer(listOfLayerData[0]);
    }, 1);
}

//inicia la edicion en la capa seleccionada
function startEditingInLayer(layerData){
    SetLayerState(layerData, "editando");
    IniciarEdicion();
}

//detiene la edicion en la capa seleccionada
function stopEditingInLayer(layerData){
    SetLayerState(layerData, "");
    DetenerEdicion();
}

//detiene la edicion en la capa pasada por parametro para luego iniciar el proceso de Download/Sescargar
function stopEditingInLayerAndGoToDownload(layerData){
    stopEditingInLayer(layerData)
    startDownloadLayer(layerData);
}

//detiene la edicion en la capa pasada por parametro para luego iniciar el proceso de eliminar
function stopEditingInLayerAndGoToDelete(layerData){
    stopEditingInLayer(layerData)
    startDeleteLayer(layerData);
}

//inicia la operacion de Delete (Eliminar) en la capa pasada por parametro
function startDeleteLayer(layerData){
    w.SetLayerState(layerData, "eliminando");
    w.Update_EditableLayersTable();
    var mensaje = "<p>¿Eliminar la capa"+" <strong>[" + layerData.Nombre + "]</strong> "+ "?</p><p><strong>*Esto no se puede deshacer</strong></p>"
    //console.log(mensaje)

    CreateOperationMensajeWindow({
        OperationName: "Eliminar...",
        Mensaje: mensaje,
        AskConfirmation: true,
        OpFunction: w.layersDelMapa.DeleteLayerByLayerData,
        OpParameters: layerData,
        OpFunctionOnNO: w.layersDelMapa.CancelDeleteLayerByLayerData,
        OpParametersOnNO: layerData,
    });
}

//inicia la operacion de Download (descargar) en la capa pasada por parametro
function startDownloadLayer(layerData){
    layerData.EstadoDeLaCapa = "descargando";

    w.Update_EditableLayersTable();

    //creo la ventana "Descargar capa" y la asigno luego
    CreateWindow("Descargar Capa", F_CancelarDescargaCruz ,[ layerData ] );
    VentanaDescargarCapa = document.getElementById("Descargar Capa");

    //activo la ventana una vez creada
    ChangeActiveWindowWithBlink(VentanaDescargarCapa);

    //creamos el contenido de la ventana
    //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
    DescargarCapa_CreateControls(VentanaDescargarCapa, layerData);

    //pongo la ventana en el medio de la ventana
    //MoverHTMLElementToXYRelative(VentanaCrearCapa, ($(document.getElementById("ActiveZone")).width()/2 - $(VentanaCrearCapa).width()/2 ) + "px|" +  ($(document.getElementById("ActiveZone")).height()/2 - $(VentanaCrearCapa).height()/2) + "px", "absolute");
    MoverVentanaAlCentroDiv(VentanaDescargarCapa, activeZone);
}

//trata la operacion editar en una capa
function sePuedeEditar(layerData){
   switch( w.GetLayerState(layerData) ){
        case "descargando":
            //aca se avisa de que se esta tratando de editar una capa que se esta descargando
            var mensaje = "<p>La capa"+" <strong>[" + layerData.Nombre + "]</strong> "+ "no se puede editar porque se esta tratando de descargar</p>"

            CreateOperationMensajeWindow({
                OperationName: "Error...",
                Mensaje: mensaje,
                AskConfirmation: false,
                OpFunction: ChangeActiveWindowWithBlink,
                OpParameters:VentanaDescargarCapa
            });
            break;

        case "editando":
            //aca se avisa de que se esta tratando de editar una capa que ya se esta editanando
            var mensaje = "<p>La capa <strong>[" + layerData.Nombre + "]</strong> ya se esta editando.</p><p>¿Detener la edición?</p>"

            CreateOperationMensajeWindow({
                OperationName: "Error...",
                Mensaje: mensaje,
                AskConfirmation: true,
                OpFunction: stopEditingInLayer,
                OpParameters:layerData
            });
           break;

        case "eliminando":
            //aca se avisa de que se esta tratando de editar una capa que se esta eliminando
            var mensaje = "<p>La capa"+" <strong>[" + layerData.Nombre + "]</strong> "+ "no se puede editar porque se esta tratando de eliminar<p>"

            CreateOperationMensajeWindow({
                OperationName: "Error...",
                Mensaje: mensaje,
                AskConfirmation: false,
                OpFunction: ChangeActiveWindow,
                OpParameters:w.operationWindow
            });
           break;

        case "":
            //aca se sigue con normalidad EXEPTO QUE SE ESTE EDITANDO OTRA CAPA
            var capaEditando = w.GetLayerWithState("editando") //getLayerEditing();
            //console.log(capaEditando);
            if( capaEditando == false /*capaEditando == null || capaEditando == undefined*/ ){
                startEditingInLayer(layerData)
            }else{
                var mensaje = "<p>¿Quieres detener la edición en la capa" + " <strong>[" + capaEditando.Nombre + "]</strong> " + "para a editar " +  " <strong>[" + layerData.Nombre + "]</strong> " + "?</p>"

                CreateOperationMensajeWindow({
                    OperationName: "Error...",
                    Mensaje: mensaje,
                    AskConfirmation: true,
                    OpFunction: changeEditingLayer,
                    OpParameters:[layerData, capaEditando]
                });
            }
           break;

        default:
            console.error("error desconocido, w.GetLayerState(layerData) retorno un estado invalido");
           break;
   }
}

//trata la operacion descargar en una capa
function sePuedeDescargar(layerData){
    switch( w.GetLayerState(layerData) ){
         case "descargando": //funciona
             //aca se avisa de que se esta tratando de editar una capa que se esta descargando
             var mensaje = "<p>La capa"+" <strong>[" + layerData.Nombre + "]</strong> "+ "ya se esta descargando...</p>"

             CreateOperationMensajeWindow({
                 OperationName: "Error...",
                 Mensaje: mensaje,
                 AskConfirmation: false,
                 OpFunction: ChangeActiveWindowWithBlink,
                 OpParameters:VentanaDescargarCapa,
             });
             break;

         case "editando": //sin testear
             //aca se avisa de que se esta tratando de editar una capa que ya se esta editanando
             var mensaje = "<p>La capa <strong>[" + layerData.Nombre + "]</strong> se esta editando.<p></p>¿detener edicion en la capa <strong>" + layerData.Nombre + "</strong> para poder descargar?</p>"

             CreateOperationMensajeWindow({
                 OperationName: "Error...",
                 Mensaje: mensaje,
                 AskConfirmation: true,
                 OpFunction: stopEditingInLayerAndGoToDownload,
                 OpParameters:layerData
             });
            break;

         case "eliminando": //sin testear
             //aca se avisa de que se esta tratando de editar una capa que se esta eliminando
             var mensaje = "<p>La capa"+" <strong>[" + layerData.Nombre + "]</strong> "+ "no se puede descargar porque se esta tratando de eliminar</p>"

             CreateOperationMensajeWindow({
                 OperationName: "Error...",
                 Mensaje: mensaje,
                 AskConfirmation: false,
                 OpFunction: ChangeActiveWindowWithBlink,
                 OpParameters:VentanaEliminarCapa
             });
            break;

         case "": //funciona

            //aca se sigue con normalidad EXEPTO QUE SE ESTE descargando OTRA CAPA
            var capaDescargando = w.GetLayerWithState("descargando") //getLayerEditing();

            if( capaDescargando == false /*capaEditando == null || capaEditando == undefined*/ ){
                startDownloadLayer(layerData);
            }else{
                var mensaje = "<p>Se Esta descargando" + " <strong>[" + capaDescargando.Nombre + "]</strong> " + "termina esa tarea primero...</p>"

                CreateOperationMensajeWindow({
                    OperationName: "Error...",
                    Mensaje: mensaje,
                    AskConfirmation: false,
                    OpFunction: ChangeActiveWindowWithBlink,
                    OpParameters:VentanaDescargarCapa
                });
            }

            //aca se sigue con normalidad a descargar


            break;

         default:
             console.error("error desconocido, w.GetLayerState(layerData) retorno un estado invalido");
            break;
    }
}

//trata la operacion eliminar en una capa
function sePuedeEliminar(layerData){
    switch( w.GetLayerState(layerData) ){
         case "descargando": //funciona
             //aca se avisa de que se esta tratando de editar una capa que se esta descargando
             var mensaje = "<p>La capa"+" <strong>[" + layerData.Nombre + "]</strong> "+ "no se puede eliminar porque se esta descargando.</p>"

             CreateOperationMensajeWindow({
                 OperationName: "Error...",
                 Mensaje: mensaje,
                 AskConfirmation: false,
                 OpFunction: ChangeActiveWindowWithBlink,
                 OpParameters:VentanaDescargarCapa,
             });
             break;

         case "editando": //sin testear
             //aca se avisa de que se esta tratando de editar una capa que ya se esta editanando
             var mensaje = "<p>La capa <strong>[" + layerData.Nombre + "]</strong> se esta editando.</p><p>¿Detener edición en la capa <strong>[ " + layerData.Nombre + " ]</strong> para poder elminarla?</p>"

             CreateOperationMensajeWindow({
                 OperationName: "Error...",
                 Mensaje: mensaje,
                 AskConfirmation: true,
                 OpFunction: stopEditingInLayerAndGoToDelete,
                 OpParameters:layerData
             });
            break;

         case "eliminando": //sin testear
             //aca se avisa de que se esta tratando de editar una capa que se esta eliminando
             var mensaje = "<p>La capa"+" <strong>[" + layerData.Nombre + "]</strong> "+ "ya se esta eliminando...</p>"

             CreateOperationMensajeWindow({
                 OperationName: "Error...",
                 Mensaje: mensaje,
                 AskConfirmation: false,
                 OpFunction: ChangeActiveWindowWithBlink,
                 OpParameters:VentanaEliminarCapa
             });
            break;

         case "": //funciona
            //aca se sigue con normalidad a descargar
            startDeleteLayer(layerData);
            break;

         default:
             console.error("error desconocido, w.GetLayerState(layerData) retorno un estado invalido");
            break;
    }
}

//crea una ventana de error o advertencia con un boton de aceptar o con un si o no,
//mas las funciones consiguientes para esos botones
function CreateOperationMensajeWindow(parameters){
    var windowName = parameters.OperationName;
    var mensaje = parameters.Mensaje;
    var AskConfirmation = parameters.AskConfirmation;
    var OpFunction = parameters.OpFunction;
    var OpParameters = parameters.OpParameters;
    var OpFunctionOnNO = parameters.OpFunctionOnNO;
    var OpParametersOnNO = parameters.OpParametersOnNO;

    CreateWindow(windowName)
    w.operationWindow = document.getElementById(windowName);

    EsconderElementoHTML(w.operationWindow.getElementsByClassName("W_MinimizeButon")[0]) //.remove();
    EsconderElementoHTML(w.operationWindow.getElementsByClassName("W_CloseButon")[0])//.remove();

    ChangeActiveWindowWithBlink(w.operationWindow);

    //create controls
    var panelMensaje = CreateSemiPanelOnWindow(w.operationWindow , "ErrorMensaje", true);
    var errorMensage = CreateCentredLabelHTMLText(panelMensaje , mensaje);

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(w.operationWindow , "Botones", false);
    var ventana = panelAcceptarCancelar.parentElement.parentElement;

    if(AskConfirmation == true){
        
        if(OpFunctionOnNO != undefined){
            var BotonNo = CreateButtons(panelAcceptarCancelar, "No", "", F_YesInOperationMensajeWindow, [OpParametersOnNO, OpFunctionOnNO, ventana], "")
        }else{
            var BotonNo = CreateButtons(panelAcceptarCancelar, "No", "", CancelOperation,[ventana], "" );
        }

        var BotonSi = CreateButtons(panelAcceptarCancelar, "Si", "", F_YesInOperationMensajeWindow, [OpParameters, OpFunction, ventana], "")
    
    }else{
        var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Aceptar", "", F_YesInOperationMensajeWindow, [OpParameters, OpFunction, ventana], "")
    }

    MoverVentanaAlCentroDiv(w.operationWindow, activeZone);

}

//operacion para disparar funciones en el boton de si y acepatr de la ventana de advertencia/error
var F_YesInOperationMensajeWindow = function(ArgumentOfFunction, funcionOfTheButton, ventana){
    //w.operationWindow.remove();
    //w.operationWindow.remove();
    CancelOperation(ventana);
    funcionOfTheButton(ArgumentOfFunction);
}

//funcion para cerrar la ventana de operaion (ventana de advertencia o error)
function CancelOperation(ventana){
    //w.operationWindow.remove();
    ventana.remove();
    ventana = null;
    w.operationWindow = null;
}

$(CM_BotonEditarDatos).on('click', function () {

    if(w.operationWindow != null && w.operationWindow != undefined){
        ChangeActiveWindowWithBlink(w.operationWindow)
        //ChangeActiveWindow(w.operationWindow);
        ContextMenuElement.blur();
    }else{
        var layerToUse = w.layersDelMapa.Lista[getLayerID(lastLayerElementChanged)];
        ContextMenuElement.blur();
        tryToExecuteLayerOperation(layerToUse, "editar");
    }

});

$(CM_BotonDescargar).on('click', function () {

    if(w.operationWindow != null && w.operationWindow != undefined){
        ChangeActiveWindowWithBlink(w.operationWindow)
        //ChangeActiveWindow(w.operationWindow);
        ContextMenuElement.blur();
    }else{
        var layerToUse = w.layersDelMapa.Lista[getLayerID(lastLayerElementChanged)];
        ContextMenuElement.blur();
        tryToExecuteLayerOperation(layerToUse, "descargar");
    }

});

$(CM_BotonEliminar).on('click', function () {

    if(w.operationWindow != null && w.operationWindow != undefined){
        ChangeActiveWindowWithBlink(w.operationWindow)
        //ChangeActiveWindow(w.operationWindow);
        ContextMenuElement.blur();
    }else{
        var layerToUse = w.layersDelMapa.Lista[getLayerID(lastLayerElementChanged)];
        ContextMenuElement.blur();
        tryToExecuteLayerOperation(layerToUse, "eliminar");
    }

});


$(CM_BotonDescargarWMS).on('click', function () {

    var layerToUse = w.layersDelMapa.Lista[getLayerID(lastLayerElementChanged)];
    copyToClipboard( layerToUse.Metadata.Origen )

});

//al cambiar el porcentaje de transparencia se muestra en
//pantalla en tiempo real con este JQuery
$(CM_BarraTransparencia).on('input', function () {

    var relleno = "";
    var layerToUse = w.layersDelMapa.Lista[getLayerID(lastLayerElementChanged)];
    //muestro el porcentaje en tiempo real
    document.getElementsByClassName("CM_TextoTransparencia")[0].textContent = "Opacidad -   " + CM_BarraTransparencia.value + " %" + relleno;
    w.layersDelMapa.SetOpacacity(layerToUse, (CM_BarraTransparencia.value / 100));
    document.getElementById("ContextMenu1").focus();
});
//#endregion

//#region Animacion y comportamiento del tooltip
var ToolTipElement = document.getElementsByClassName("ToolTip")[0];

var PorcentajePaddingX = 2;
var PorcentajePaddingY = 2;

var PaddingX = 20;
var PaddingY = 30;

var mouseX = 0;
var mouseY = 0;

//esto es para que el rectangulo del tooltip persiga el mouse con cierto padding
//pero tambien llena la variable global con la posicion del mouse o los clicks,
//para usarse en otras partes del codigo como el tooltip o el move_window.
if(w.isMobile == false){
    w.addEventListener('mousemove', function (e) {
        mouseX = MousePositionX(e);
        mouseY = MousePositionY(e);

        //esto es para tratar de que quede centrado
        //chequeo donde deberia posicionarse para evitar que quede fuera de la pantalla
        
        //esto es para que quede desviado contra el mouse
        //chequeo donde deberia posicionarse para evitar que quede fuera de la pantalla
        if (($(ToolTipElement).height() + PaddingY + mouseY) > (w.innerHeight - 10)) {
            if (($(ToolTipElement).width() + PaddingX + mouseX) > (w.innerWidth - 10)) {
                MoverHTMLElementToXY(ToolTipElement, (mouseX - PaddingX - $(ToolTipElement).width()) + "px" + "|" + (mouseY - PaddingY - $(ToolTipElement).height()) + "px", "absolute");
            } else {
                MoverHTMLElementToXY(ToolTipElement, (mouseX + PaddingX) + "px" + "|" + (mouseY - PaddingY - $(ToolTipElement).height()) + "px", "absolute");
            }
        } else {
            if (($(ToolTipElement).width() + PaddingX + mouseX) > (w.innerWidth - 10)) {
                MoverHTMLElementToXY(ToolTipElement, (mouseX - PaddingX - $(ToolTipElement).width()) + "px" + "|" + (mouseY + PaddingY) + "px", "absolute");
            } else {
                MoverHTMLElementToXY(ToolTipElement, (mouseX + PaddingX) + "px" + "|" + (mouseY + PaddingY) + "px", "absolute");
            }
        }

    });
}else{
    w.addEventListener('touchmove', function (e) {
        //console.log("Android Touch Move!");
        mouseX = TouchPositionX(e);
        mouseY = TouchPositionY(e);

        //console.log( "x:" + mouseX + " - y:" + mouseY);

        //chequeo donde deberia posicionarse para evitar que quede fuera de la pantalla
        // if (($(ToolTipElement).height() + PaddingY + mouseY) > (w.innerHeight - 10)) {
        //     if (($(ToolTipElement).width() + PaddingX + mouseX) > (w.innerWidth - 10)) {
        //         MoverHTMLElementToXY(ToolTipElement, (mouseX - PaddingX - $(ToolTipElement).width()) + "px" + "|" + (mouseY - PaddingY - $(ToolTipElement).height()) + "px", "absolute");
        //     } else {
        //         MoverHTMLElementToXY(ToolTipElement, (mouseX + PaddingX) + "px" + "|" + (mouseY - PaddingY - $(ToolTipElement).height()) + "px", "absolute");
        //     }
        // } else {
        //     if (($(ToolTipElement).width() + PaddingX + mouseX) > (w.innerWidth - 10)) {
        //         MoverHTMLElementToXY(ToolTipElement, (mouseX - PaddingX - $(ToolTipElement).width()) + "px" + "|" + (mouseY + PaddingY) + "px", "absolute");
        //     } else {
        //         MoverHTMLElementToXY(ToolTipElement, (mouseX + PaddingX) + "px" + "|" + (mouseY + PaddingY) + "px", "absolute");
        //     }
        // }

    }, false);
}

//esto se dispara cuando cambie el texto del tooltip, escondiendolo
//si no tiene texto o mostrandolo en caso contrario
if(w.isMobile == false){
    ToolTipElement.addEventListener("TooltipUpdate", (e) => {
        if (ToolTipElement.textContent != "") {
            ToolTipElement.style.display = "block";

            //esto es para tratar de que quede centrado
            //chequeo donde deberia posicionarse para evitar que quede fuera de la pantalla

            //chequeo donde deberia posicionarse para evitar que quede fuera de la pantalla
            if (($(ToolTipElement).height() + PaddingY + mouseY) > (w.innerHeight - 10)) {

                if (($(ToolTipElement).width() + PaddingX + mouseX) > (w.innerWidth - 10)) {
                    MoverHTMLElementToXY(ToolTipElement, (mouseX - PaddingX - $(ToolTipElement).width()) + "px" + "|" + (mouseY - PaddingY - $(ToolTipElement).height()) + "px", "absolute");
                } else {
                    MoverHTMLElementToXY(ToolTipElement, (mouseX + PaddingX) + "px" + "|" + (mouseY - PaddingY - $(ToolTipElement).height()) + "px", "absolute");
                }

            } else {

                if (($(ToolTipElement).width() + PaddingX + mouseX) > (w.innerWidth - 10)) {
                    MoverHTMLElementToXY(ToolTipElement, (mouseX - PaddingX - $(ToolTipElement).width()) + "px" + "|" + (mouseY + PaddingY) + "px", "absolute");
                } else {
                    MoverHTMLElementToXY(ToolTipElement, (mouseX + PaddingX) + "px" + "|" + (mouseY + PaddingY) + "px", "absolute");
                }

            }

        } else {
            ToolTipElement.style.display = "none";
        }
    });
}

function ToolTipPosition(position){
    switch (position){
        case 'arriba':
            break;

        case 'abajo':
            break;

        case 'izquierda':
            break;

        case 'derecha':
            break;

        case 'arriba-izquierda':
            break;

        case 'arriba-derecha':
            break;

        case 'abajo-izquierda':
            break;

        case 'abajo-derecha':
            break;
    }

}
//#endregion

//#region comportamiento de los botones de la barra de herramientas superior

//esto poner los tooltips a todos los M_Button con la id de los mismos
for (var index = 0; index < document.getElementsByClassName("M_Buton").length; index++) {
    var elem = document.getElementsByClassName("M_Buton")[index];
    delayToolTip(elem, standarToolTipDelayInMS, null);
}

//defino una variable por boton para configurarlos con sus funciones
var BS_CrearCapa = document.getElementsByName("BS_CrearCapa")[0]
var BS_SubirArchivo = document.getElementsByName("BS_SubirArchivo")[0]
var BS_CargarWMS =  document.getElementsByName("BS_CargarWMS")[0]
var BS_Boton_CapasIGM =  document.getElementsByName("BS_Boton_CapasIGM")[0]
var BS_Boton_DescargarPNG =  document.getElementsByName("BS_Boton_DescargarPNG")[0]
var BS_Boton_DescargarPDF =  document.getElementsByName("BS_Boton_DescargarPDF")[0]
var BS_Boton_Editar =  document.getElementsByName("BS_Boton_Editar")[0]
var BS_Boton_Seleccionar =  document.getElementsByName("BS_Boton_Seleccionar")[0]
var BS_Boton_Punto =  document.getElementsByName("BS_Boton_Punto")[0]
var BS_Boton_Linea =  document.getElementsByName("BS_Boton_Linea")[0]
var BS_Boton_Area =  document.getElementsByName("BS_Boton_Area")[0]
var BS_Boton_Medir_Distancia =  document.getElementsByName("BS_Boton_Medir_Distancia")[0]
var BS_Boton_Medir_Superficie =  document.getElementsByName("BS_Boton_Medir_Superficie")[0]
var BS_Boton_PedirInfo =  document.getElementsByName("BS_Boton_PedirInfo")[0]
var BS_Boton_Mano =  document.getElementsByName("BS_Boton_Mano")[0]
var BS_Boton_FullScreen =  document.getElementsByName("BS_Boton_FullScreen")[0]
var BS_Boton_Tips =  document.getElementsByName("BS_Boton_Tips")[0]
var BS_Boton_Help =  document.getElementsByName("BS_Boton_Help")[0]
var BS_Opciones =  document.getElementsByName("BS_Opciones")[0]

//esta es la lista de botones que se prenden y apagan durante la edicion
var listaDeBotones = [BS_Boton_Seleccionar, BS_Boton_Punto, BS_Boton_Linea, BS_Boton_Area, BS_Boton_Medir_Distancia, BS_Boton_Medir_Superficie, BS_Boton_PedirInfo, BS_Boton_Mano];
var TagActive = " M_Button_Selected";

//funcion que inicia la edicion
function IniciarEdicion(){
    //cambio el boton
    w.EditionEnabled = true;
    BS_Boton_Editar.id = "Detener Edición"
    BS_Boton_Editar.getElementsByClassName("M_icon")[0].src = M_Editar_Detener;

    BS_Boton_Editar.className = BS_Boton_Editar.className.replace("Buton_OFF", "Buton_ON");
    //.BotonCerrado //BotonAbierto
    BS_Boton_Seleccionar.className = BS_Boton_Seleccionar.className.replace("Buton_OFF", "Buton_ON");
    BS_Boton_Punto.className = BS_Boton_Punto.className.replace("Buton_OFF", "Buton_ON");
    BS_Boton_Linea.className = BS_Boton_Linea.className.replace("Buton_OFF", "Buton_ON");
    BS_Boton_Area.className = BS_Boton_Area.className.replace("Buton_OFF", "Buton_ON");

    BS_Boton_Seleccionar.className = BS_Boton_Seleccionar.className.replace("BotonCerrado", "BotonAbierto");
    BS_Boton_Punto.className = BS_Boton_Punto.className.replace("BotonCerrado", "BotonAbierto");
    BS_Boton_Linea.className = BS_Boton_Linea.className.replace("BotonCerrado", "BotonAbierto");
    BS_Boton_Area.className = BS_Boton_Area.className.replace("BotonCerrado", "BotonAbierto");

    //activo el boton de select por defecto
    ActivateButton(0, listaDeBotones, TagActive);

    w.ResetInteractions();
    w.AddInteractionOnMap( w.CreateSelect(w.GetLayerWithState("editando").OpenLayerSource ) );
    w.AddInteractionOnMap( w.CreateModify(w.interacciones[w.interacciones.length -1]) );

    w.Update_EditableLayersTable();

}

//funcion que detiene la edicion
function DetenerEdicion(){
    //cambio el boton
    w.EditionEnabled = false;
    BS_Boton_Editar.id = "Iniciar Edición"
    BS_Boton_Editar.getElementsByClassName("M_icon")[0].src = M_Editar_Iniciar;

    BS_Boton_Editar.className = BS_Boton_Editar.className.replace("Buton_ON", "Buton_OFF");

    BS_Boton_Seleccionar.className = BS_Boton_Seleccionar.className.replace("Buton_ON", "Buton_OFF");
    BS_Boton_Punto.className = BS_Boton_Punto.className.replace("Buton_ON", "Buton_OFF");
    BS_Boton_Linea.className = BS_Boton_Linea.className.replace("Buton_ON", "Buton_OFF");
    BS_Boton_Area.className = BS_Boton_Area.className.replace("Buton_ON", "Buton_OFF");

    BS_Boton_Seleccionar.className = BS_Boton_Seleccionar.className.replace("BotonAbierto", "BotonCerrado");
    BS_Boton_Punto.className = BS_Boton_Punto.className.replace("BotonAbierto", "BotonCerrado");
    BS_Boton_Linea.className = BS_Boton_Linea.className.replace("BotonAbierto", "BotonCerrado");
    BS_Boton_Area.className = BS_Boton_Area.className.replace("BotonAbierto", "BotonCerrado");

    ActivateButton(-1, listaDeBotones, TagActive);
    w.ResetInteractions();

    //desactivo la edicion en todas las capas que encuentre que tienen la edicion prendida
    for(var numero = 0; numero < w.layersDelMapa.Lista.length; numero++){
        if(w.GetLayerStateById(numero) == "editando"){
            w.SetLayerStateById(numero, "");
            break;
        }
    }

    lastLayerInteracted = undefined;
}

//le pone la tag ActivateClass al boton seleccionado en buttonToActivate
function ActivateButton(ButonToActivateIndex, ArrayButtons, ActivateClass){

    for(var ix = 0; ix < ArrayButtons.length; ix++){
        if(ButonToActivateIndex == -1){
            ArrayButtons[ix].className = ArrayButtons[ix].className.replace(ActivateClass, "");
        }else{
            if(ix == ButonToActivateIndex){
                    ArrayButtons[ButonToActivateIndex].className = ArrayButtons[ButonToActivateIndex].className.replace(ActivateClass, "");
                    ArrayButtons[ButonToActivateIndex].className = ArrayButtons[ButonToActivateIndex].className + ActivateClass;
            }else{
                ArrayButtons[ix].className = ArrayButtons[ix].className.replace(ActivateClass, "");
            }
        }
    }
}

//boton de editar features al pulsarlas
BS_Boton_Seleccionar.addEventListener('click', function(){
    if(hasClass(BS_Boton_Seleccionar, "Buton_OFF") != true){
        //activo el boton de select por defecto
        ActivateButton(0, listaDeBotones, TagActive);

        //reseto las interacciones
        w.ResetInteractions();
        //seteo las interaciones de select y modify
        w.AddInteractionOnMap( w.CreateSelect(w.GetLayerWithState("editando").OpenLayerSource ) );
        w.AddInteractionOnMap( w.CreateModify(w.interacciones[w.interacciones.length -1]) );
    }


})

//boton de dibujar punto
BS_Boton_Punto.addEventListener('click', function(){
    if(hasClass(BS_Boton_Punto, "Buton_OFF") != true){
        //activo el boton de select por defecto
        ActivateButton(1, listaDeBotones, TagActive);

        w.ResetInteractions();

        //intereaccion dibujar Punto
        w.AddInteractionOnMap(w.CreateDraw(w.GetLayerWithState("editando").OpenLayerSource, 'Point'));
    }
})

//boton de dibujar linea
BS_Boton_Linea.addEventListener('click', function(){
    if(hasClass(BS_Boton_Linea, "Buton_OFF") != true){
        //activo el boton de select por defecto
        ActivateButton(2, listaDeBotones, TagActive);

        w.ResetInteractions();

        //intereaccion dibujar linea
        w.AddInteractionOnMap(w.CreateDraw(w.GetLayerWithState("editando").OpenLayerSource, 'LineString'));
    }
})

//boton de dibujar area
BS_Boton_Area.addEventListener('click', function(){
    if(hasClass(BS_Boton_Area, "Buton_OFF") != true){
        //activo el boton de select por defecto
        ActivateButton(3, listaDeBotones, TagActive);

        w.ResetInteractions();

        //intereaccion dibujar area
        w.AddInteractionOnMap(w.CreateDraw(w.GetLayerWithState("editando").OpenLayerSource, 'Polygon'));
    }
})

//boton para iniciar/detener la edicion
BS_Boton_Editar.addEventListener('click', function () {
    if(hasClass(BS_Boton_Editar, "Buton_OFF") != true){
        if (w.EditionEnabled == false) {
            //IniciarEdicion();
            //VentanaEditar
            if(VentanaEditar == null || VentanaEditar != document.getElementById("Iniciar Edición...") ){

                //creo la ventana "Crear capa" y la asigno luego
                CreateWindow("Iniciar Edición...");
                VentanaEditar = document.getElementById("Iniciar Edición...");
    
                //activo la ventana una vez creada
                ChangeActiveWindow(VentanaEditar);
    
                //creamos el contenido de la ventana
                //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
                IniciarEdicion_CreateControls(VentanaEditar);
    
                //pongo la ventana en el medio de la ventana
                MoverVentanaAlCentroDiv(VentanaEditar, activeZone);
    
            }else{
                ChangeActiveWindow(VentanaEditar);
            }

        } else {
            DetenerEdicion();
            w.Update_EditableLayersTable()
        }
    }

});

BS_Boton_DescargarPNG.addEventListener('click', function () {
    if(hasClass(BS_Boton_DescargarPNG, "Buton_OFF") != true){
        //console.log("BS_Boton_DescargarPNG pulsado")
        //imprimo pantalla en png
        // w.ImprimirPNG()

        if(w.VentanaPrintPNG == null || w.VentanaPrintPNG != document.getElementById("Exportar Mapa") ){

            //creo la ventana "Crear capa" y la asigno luego
            CreateWindow("Exportar Mapa",F_CancelarEsportarPNG,[]);
            w.VentanaPrintPNG = document.getElementById("Exportar Mapa");

            //activo la ventana una vez creada
            ChangeActiveWindow(w.VentanaPrintPNG);

            //creamos el contenido de la ventana
            //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
            ExportarMapaPNG_CreateControls(w.VentanaPrintPNG);

            //pongo la ventana en el medio de la ventana
            MoverVentanaAlCentroDiv(w.VentanaPrintPNG, activeZone);

        }else{
            ChangeActiveWindow(w.VentanaPrintPNG);
        }

        // ActivateButton(4, listaDeBotones, TagActive);
        // w.ResetInteractions();
    }

});

//boton para medir
BS_Boton_Medir_Distancia.addEventListener('click', function () {
    if(hasClass(BS_Boton_Medir_Distancia, "Buton_OFF") != true){

        ActivateButton(4, listaDeBotones, TagActive);

        w.ResetInteractions();

        w.CreateMedir('LineString');
    }

});

//boton para medir
BS_Boton_Medir_Superficie.addEventListener('click', function () {
    if(hasClass(BS_Boton_Medir_Distancia, "Buton_OFF") != true){

        ActivateButton(5, listaDeBotones, TagActive);

        w.ResetInteractions();

        w.CreateMedir('Polygon');
    }

});

//boton para Pedir informacion a las features
BS_Boton_PedirInfo.addEventListener('click', function () {
    if(hasClass(BS_Boton_PedirInfo, "Buton_OFF") != true){
        // console.log("pedir info pulsado")
        ActivateButton(6, listaDeBotones, TagActive);

        w.ResetInteractions();
    }

});

//boton usado para apagar las interacciones del mouse en el mapa
BS_Boton_Mano.addEventListener('click', function () {
    if(hasClass(BS_Boton_Mano, "Buton_OFF") != true){
        ActivateButton(7, listaDeBotones, TagActive);

        w.ResetInteractions();
    }

});

function crearBienvenida() {
    //creo la ventana "Crear capa" y la asigno luego
    CreateWindow("Ayuda Rápida");
    w.VentanaTips = document.getElementById("Ayuda Rápida");

    //activo la ventana una vez creada
    ChangeActiveWindow(w.VentanaTips);

    //creamos el contenido de la ventana
    //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
    Tips_CreateControls(w.VentanaTips);

    //pongo la ventana en el medio de la ventana
    MoverVentanaAlCentroDiv(w.VentanaTips, activeZone);
}

//Boton de Ayuda Rapida
BS_Boton_Tips.addEventListener('click', function () {
    if(hasClass(BS_Boton_Tips, "Buton_OFF") != true){
        //console.log("BS_Boton_Tips pulsado")

        if(w.VentanaTips == null || w.VentanaTips != document.getElementById("Ayuda Rápida") ){

            //creo la ventana "Crear capa" y la asigno luego
            CreateWindow("Ayuda Rápida");
            w.VentanaTips = document.getElementById("Ayuda Rápida");

            //activo la ventana una vez creada
            ChangeActiveWindow(w.VentanaTips);

            //creamos el contenido de la ventana
            //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
            Tips_CreateControls(w.VentanaTips);

            //pongo la ventana en el medio de la ventana
            MoverVentanaAlCentroDiv(w.VentanaTips, activeZone);

        }else{
            ChangeActiveWindow(w.VentanaTips);
        }

    }

});

//boton full screen
BS_Boton_FullScreen.addEventListener('click', function(){
    toggleFullScreen();
});

//este evento crea una ventana de "crear capa" al pulsarlo
BS_CrearCapa.addEventListener("click", function(){
    if(VentanaCrearCapa == null || VentanaCrearCapa != document.getElementById("Crear capa") ){

        //creo la ventana "Crear capa" y la asigno luego
        CreateWindow("Crear capa");
        VentanaCrearCapa = document.getElementById("Crear capa");

        //activo la ventana una vez creada
        ChangeActiveWindow(VentanaCrearCapa);

        //creamos el contenido de la ventana
        //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
        CrearCapa_CreateControls(VentanaCrearCapa);

        //pongo la ventana en el medio de la ventana
        MoverVentanaAlCentroDiv(VentanaCrearCapa, activeZone);


    }else{
        ChangeActiveWindow(VentanaCrearCapa);
    }
});

//evento que crea la venatana de subir archivo
BS_SubirArchivo.addEventListener("click", function(){
    if(VentanaSubirCapa == null || VentanaSubirCapa != document.getElementById("Subir un archivo") ){

        //creo la ventana "Crear capa" y la asigno luego
        CreateWindow("Subir un archivo");
        VentanaSubirCapa = document.getElementById("Subir un archivo");

        //activo la ventana una vez creada
        ChangeActiveWindow(VentanaSubirCapa);

        //creamos el contenido de la ventana
        //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
        SubirCapa_CreateControls(VentanaSubirCapa);

        //pongo la ventana en el medio de la ventana
        MoverVentanaAlCentroDiv(VentanaSubirCapa, activeZone);

    }else{
        ChangeActiveWindow(VentanaSubirCapa);
    }
});

//evento que crea la ventana de opciones
BS_Opciones.addEventListener("click", function(){
    if(VentanaOpciones == null || VentanaOpciones != document.getElementById("Opciones / Creditos") ){

        //creo la ventana "Crear capa" y la asigno luego
        CreateWindow("Opciones / Creditos");
        VentanaOpciones = document.getElementById("Opciones / Creditos");

        //activo la ventana una vez creada
        ChangeActiveWindow(VentanaOpciones);

        //creamos el contenido de la ventana
        //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
        Opciones_CreateControls(VentanaOpciones);

        //pongo la ventana en el medio de la ventana
        MoverVentanaAlCentroDiv(VentanaOpciones, activeZone);

    }else{
        ChangeActiveWindow(VentanaOpciones);
    }
});

//evento que crea la ventana de subir wms
BS_CargarWMS.addEventListener("click", function(){
    if(w.VentanaCargarWMS == null || w.VentanaCargarWMS != document.getElementById("Cargar WMS") ){

        //creo la ventana "Crear capa" y la asigno luego
        CreateWindow("Cargar WMS");
        w.VentanaCargarWMS = document.getElementById("Cargar WMS");

        //activo la ventana una vez creada
        ChangeActiveWindow(w.VentanaCargarWMS);

        //creamos el contenido de la ventana
        //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
        CargarWMS_CreateControls(w.VentanaCargarWMS);

        //pongo la ventana en el medio de la ventana
        MoverVentanaAlCentroDiv(w.VentanaCargarWMS, activeZone);
        //MoverHTMLElementToXYRelative(VentanaCargarWMS, (($(activeZone).width()/1.71) - ($(VentanaCargarWMS).width()/2)) + "px|" + (($(activeZone).height()/2) - ($(VentanaCargarWMS).height())/2) + "px","absolute");
        //MoverHTMLElementToXYRelative(VentanaCargarWMS, ($(document.getElementById("ActiveZone")).width()/2 - $(VentanaCargarWMS).width()/2 ) + "px|" +  ($(document.getElementById("ActiveZone")).height()/2 - $(VentanaSubirCapa).height()/2) + "px", "absolute");
    }else{
        ChangeActiveWindow(w.VentanaCargarWMS);
    }
});

w.ShowFeatureInfoResults = function(ListOfelementsToShow, LayerDataSelected){
    $(w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[0]).empty();

    var Mensaje = CreateCentredLabelHTMLText(VentanaComprobarInformacion, "<p>" + LayerDataSelected.Nombre + " (" + LayerDataSelected.Formato + ")</p>")

    ConsultarInfo_CreateControls(w.VentanaComprobarInformacion, ListOfelementsToShow);

    if(w.VentanaComprobarInformacionFisrtTime == true){
        MoverVentanaAlCentroDiv(w.VentanaComprobarInformacion, activeZone);
    }
}

w.ConsultingFeatureInfoMensage = function(formatoElemento){
    //activo la ventana una vez creada
    ChangeActiveWindow(w.VentanaComprobarInformacion);

    $(w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[0]).empty();
    if(w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[1] != undefined){
        w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[1].remove();
    }

    var Mensaje = "ERROR al consultar";

    //muestro un mensaje distinto, segun si es Poligonal ("OL") o WMS (ArcGIS Server / GeoServer)
    switch(formatoElemento){
        case "OL":
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>Espere...<br>(Analizando Geometria...)</p>")
            break;

        case "WMS":
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>Espere...<br>(Esperando respuesta del WMS...)</p>")
            break;

        case "OSM":
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>No se puede Consultar el la capa<br>BaseMap(Open Street Map)</p>")
            break;

        case "VACIO":
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>No hay ninguna capa en la consulta</p>")
            break;

        case "SIN RESULTADOS":
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>No hay ninguna resultado para la consulta del WMS</p><p><strong>*Nota: Las anotaciones no devuelven resultados <br>en los WMS, pero este error tambien se da <br>cuando se pulsa justo en el borde de una feature del WMS.</strong></p>")
            break;

        case "ERROR GEOMETRIA":
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>No hay ninguna resultado para la consulta de geometría.</p><p><strong>*Nota: este error se da cuando se pide información <br>en los bordes de la geometría, sobretodo en <br>gometría de tipo MultiPoligon/Poligon.</strong></p>")
            break;

        case "ESPERE":
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>Espere...</p>")
            break;

        default:
            Mensaje = CreateCentredLabelHTMLText(w.VentanaComprobarInformacion, "<p>ERROR al consultar (algo salio mal y se obtuvo información incorrecta)</p>")            
            break
    }

    w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[0].appendChild(Mensaje)
    
}

w.CreateWindowFeatureInfo = function(formatoElemento){
    if(w.VentanaComprobarInformacion == null || w.VentanaComprobarInformacion != document.getElementById("Consultar Información") ){

        //creo la ventana "Crear capa" y la asigno luego
        CreateWindow("Consultar Información");
        w.VentanaComprobarInformacion = document.getElementById("Consultar Información");
        w.VentanaComprobarInformacionFisrtTime = true;

        //activo la ventana una vez creada
        ChangeActiveWindow(w.VentanaComprobarInformacion);

        //creamos el contenido de la ventana
        //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
        //ConsultarInfo_CreateControls(VentanaComprobarInformacion, ListOfelementsToShow);  //esto se movio aparte
        w.ConsultingFeatureInfoMensage(formatoElemento)

        //pongo la ventana en el medio de la ventana
        MoverVentanaAlCentroDiv(w.VentanaComprobarInformacion, activeZone);

    }else{

        w.VentanaComprobarInformacionFisrtTime = false;
        //activo la ventana una vez creada
        ChangeActiveWindow(w.VentanaComprobarInformacion);

        $(w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[0]).empty();
        if(w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[1] != undefined){
            w.VentanaComprobarInformacion.getElementsByClassName("Window_Content_Container")[0].childNodes[1].remove();
        }

        //creamos el contenido de la ventana
        //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
        w.ConsultingFeatureInfoMensage(formatoElemento)
        
    }

}

//este evento crea una ventana de "Cargar Capas del IGM" al pulsarlo
BS_Boton_CapasIGM.addEventListener("click", function(){
    w.open("http://www.igm.gub.uy/geoportal/cobertura-nacional-vectorial-wms/", "_blank");

});

w.CenterWindowIfNotMoved = function(ventana){
    if(ventana.getAttribute("window_original_pos") == "true" ){
        //console.log("true");
        MoverVentanaAlCentroDiv(ventana, activeZone);
    }
}

//#region boton del IGM
delayToolTip(document.getElementsByClassName("IGM_icon2")[0], w.standarToolTipDelayInMS, "<span>ir al sitio del Instituto Geografico militar</span>");
delayToolTip(document.getElementsByClassName("IGM_icon2")[1], w.standarToolTipDelayInMS, "<span>ir al sitio del Instituto Geografico militar</span>");

var BotonIGM = document.getElementsByClassName("IGM_icon2")[0];
var BotonIGMNegro = document.getElementsByClassName("IGM_icon2")[1];
var BotonIGM4 = document.getElementsByClassName("IGM_icon4")[0];
var BotonIGM_Container = document.getElementsByClassName("BI_IGM_Container")[0];
var BotonIGM_Container2 = document.getElementsByClassName("BI_IGM_Container")[1];
var BotonIGM_Container3 = document.getElementsByClassName("BI_IGM_Container")[2];
var BotonIGM_Container4 = document.getElementsByClassName("BI_IGM_Container")[3];

BotonIGM.addEventListener("mouseover", function () {
    BotonIGM.src = M_LogoIGM_Color;
});

BotonIGM.addEventListener("mouseleave", function () {
    BotonIGM.src = M_LogoIGM_Celeste;
    IGMStartsClick = false;
});

var IGMStartsClick = false;

BotonIGM.addEventListener("mousedown", function () {
    BotonIGM.src = M_LogoIGM_Celeste;
    IGMStartsClick = true;
})

BotonIGM.addEventListener("mouseup", function () {
    BotonIGM.src = M_LogoIGM_Color;
    if(IGMStartsClick == true){
        IGMStartsClick = false;
        w.open('http://www.igm.gub.uy/', 'http://www.igm.gub.uy/');
    }
})

BotonIGMNegro.addEventListener("mouseover", function () {
    BotonIGMNegro.src = M_LogoIGM_Color;
});

BotonIGMNegro.addEventListener("mouseleave", function () {
    BotonIGMNegro.src = M_LogoIGM_Negro;
    IGMStartsClick = false;
});

var IGMStartsClick = false;

BotonIGMNegro.addEventListener("mousedown", function () {
    BotonIGMNegro.src = M_LogoIGM_Negro;
    IGMStartsClick = true;
})

BotonIGMNegro.addEventListener("mouseup", function () {
    BotonIGMNegro.src = M_LogoIGM_Color;
    if(IGMStartsClick == true){
        IGMStartsClick = false;
        w.open('http://www.igm.gub.uy/', 'http://www.igm.gub.uy/');
    }
})

//Ajustando el Boton de IGM
var barraSuperior = document.getElementsByClassName("BarraSuperior")[0];
var iconoIGM = document.getElementsByClassName("IGM_icon2")[0];
var iconIGMNegro = document.getElementsByClassName("IGM_icon2")[1];
var iconoIGM2 = document.getElementsByClassName("IGM_icon3")[1];
var iconoIGM3 = document.getElementsByClassName("IGM_icon3")[0];
var iconoIGM4 = document.getElementsByClassName("IGM_icon4")[0];

var heightIGM = -1*($(iconoIGM).height()/2);
var widthIGM = -1*($(iconoIGM).width()/2);
var heightIGMNegro = -1*($(iconIGMNegro).height()/2);
var widthIGMNegro = -1*($(iconIGMNegro).width()/2);

var heightIGM2 = -1*($(iconoIGM2).height()/2);
var widthIGM2 = -1*($(iconoIGM2).width()/2);

var heightIGM3 = -1*($(iconoIGM3).height()/2);
var widthIGM3 = -1*($(iconoIGM3).width()/2);

var heightIGM4 = -1*($(iconoIGM4).height()/2);
var widthIGM4 = -1*($(iconoIGM4).width()/2);

RecalculateIGMPosition();

w.addEventListener("resize", function(){
    RecalculateIGMPosition();

    if(w.innerWidth < w.innerHeight){
        document.getElementById("BI_IGM").style.display = "none";
    }else{
        document.getElementById("BI_IGM").style.display = "block";
    }

});

function recalculateBottomTextVisibility(){
    if(w.innerWidth < w.innerHeight){
        document.getElementById("BI_IGM").style.display = "none";
    }else{
        document.getElementById("BI_IGM").style.display = "block";
    }
}

function RecalculateIGMPosition(){

    if(isIGMNegro){
        BotonIGM.style.display = "none";
        BotonIGMNegro.style.display = "block";
    }else{
        BotonIGM.style.display = "block";
        BotonIGMNegro.style.display = "none";
    }

    //hago visible el Logo del IGM cuando ya este posicionado,
    //por defecto esta en display = "none";
    BotonIGM_Container.style.display = "block";
    BotonIGM_Container2.style.display = "block";
    BotonIGM_Container3.style.display = "block";
    BotonIGM_Container4.style.display = "block";

    if(w.innerWidth < ((w.innerHeight/3)*4) ){

        //si la ventana esta cercana a un cuadrado pongo el icono abajo
        //de la barra para no tapar botones
        //tambien si esta mucho mas alta que ancha achico el icono del igm
        if(w.innerWidth < ((w.innerHeight/3)*2) ){
            BotonIGM.style.height = "6vh";
            BotonIGM.style.width = "6vh";
            BotonIGMNegro.style.height = "6vh";
            BotonIGMNegro.style.width = "6vh";
            heightIGM = 3*($(iconoIGM).height()/5);
            heightIGMNegro = 3*($(iconIGMNegro).height()/5);

            BotonIGM4.styleheight= "7.5vh";
            BotonIGM4.style.width= "7.5vh";
            heightIGM4 = 2*($(iconoIGM4).height()/38.2);

        }else{
            BotonIGM.style.height = "9vh";
            BotonIGM.style.width = "9vh";
            BotonIGMNegro.style.height = "9vh";
            BotonIGMNegro.style.width = "9vh";
            heightIGM = 2*($(iconoIGM).height()/5);
            heightIGMNegro = 2*($(iconIGMNegro).height()/5);

            BotonIGM4.styleheight= "12vh";
            BotonIGM4.style.width= "12vh";
            heightIGM4 = 2*($(iconoIGM4).height()/11);

        }
        //relleno las variables que se usan para repisicionar el logo del igm
        widthIGM = -1*($(iconoIGM).width()/1.3);
        widthIGMNegro = -1*($(iconIGMNegro).width()/1.3);

        heightIGM2 = -1*($(iconoIGM2).height()/2);
        widthIGM2 = -1*($(iconoIGM2).width()/2);

        heightIGM3 = -1*($(iconoIGM3).height()/2);
        widthIGM3 = -1*($(iconoIGM3).width()/2);

        widthIGM4 = -1*($(iconoIGM4).width()/1.42);

        BotonIGM_Container.style.display = "none";
        BotonIGM_Container2.style.display = "none";

    }else{
        //si la ventana esta bien ancha pongo el icono en el lugar por defecto
        if(BotonIGM.style.height == "6vh" || BotonIGM.style.height == "9vh" ){
            BotonIGM.style.height = "12vh";
            BotonIGM.style.width = "12vh";
            BotonIGMNegro.style.height = "12vh";
            BotonIGMNegro.style.width = "12vh";
        }
        //relleno las variables que se usan para repisicionar el logo del igm
        heightIGM = -1*($(iconoIGM).height()/2);
        widthIGM = -1*($(iconoIGM).width()/2);
        heightIGMNegro = -1*($(iconIGMNegro).height()/2);
        widthIGMNegro = -1*($(iconIGMNegro).width()/2);

        heightIGM2 = -1*($(iconoIGM2).height()/2);
        widthIGM2 = -1*($(iconoIGM2).width()/2);

        heightIGM3 = -1*($(iconoIGM3).height()/2);
        widthIGM3 = -1*($(iconoIGM3).width()/2);

        BotonIGM_Container.style.display = "block";
        BotonIGM_Container2.style.display = "block";
        BotonIGM_Container4.style.display = "none";
    }

    MoverHTMLElementToXY(iconoIGM, widthIGM + "px|" + (heightIGM +$(barraSuperior).height()) + "px", "relative");
    MoverHTMLElementToXY(BotonIGMNegro, widthIGMNegro + "px|" + (heightIGMNegro +$(barraSuperior).height()) + "px", "relative");

    MoverHTMLElementToXY(iconoIGM2, widthIGM2 + "px|" + (heightIGM2 + $(barraSuperior).height()) + "px", "relative");
    MoverHTMLElementToXY(iconoIGM3, widthIGM3 + "px|" + (heightIGM3 + $(barraSuperior).height()) + "px", "relative");
    MoverHTMLElementToXY(iconoIGM4, widthIGM4 + "px|" + (heightIGM4 + $(barraSuperior).height()) + "px", "relative");

}
//#endregion

//#endregion

//#region comportamiento barra de controles izquierda (zoom, zoom to extent y rotate)
//declaro los botones
var CL_Boton_ZoomIn = document.getElementById("ZoomIN");
var CL_Boton_ZoomOUT = document.getElementById("ZoomOUT");
var CL_Boton_ZoomToExtent = document.getElementById("ZoomToExtent");
var CL_Boton_RotateLeft = document.getElementById("RotateLeft");
var CL_Boton_RotateRight = document.getElementById("RotateRight");

//declaro el comportamiento del boton ZoomIN
$(CL_Boton_ZoomIn).on('click', function(){
    w.ZoomView("+", 0.5, 200);
    // w.ZoomIN();
});

//declaro el comportamiento del boton ZoomOUT
$(CL_Boton_ZoomOUT).on('click', function(){
    w.ZoomView("-", 0.5, 200);
    // w.ZoomOUT();
});

//declaro el comportamiento del boton ZoomToExtent
$(CL_Boton_ZoomToExtent).on('click', function(){
    w.ZoomToDefaultExtent(200);
    // w.ZoomToExtent();
});

//declaro el comportamiento del boton RotateLeft
$(CL_Boton_RotateLeft).on('click', function(){
    w.RotateViwe("izquierda", 30, 200);
});

//declaro el comportamiento del boton RotateRight
$(CL_Boton_RotateRight).on('click', function(){
    w.RotateViwe("derecha", 30, 200);
});

//#endregion

//#region Comportamientos barra inferior

//muestra el año actual en el visualizador
var fecha = new Date();
var anio = fecha.getFullYear();
var mes = fecha.getMonth();
//var dia = fecha.getDay();
var mesTexto = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
document.getElementById("BI_IGM").textContent = document.getElementById("BI_IGM").textContent.split("-")[0] + " - " + mesTexto[mes] + " " + anio;


document.getElementById("map").addEventListener('MouseMoveOnMap', function () {
    if (document.getElementById("BI_CoordenadasXYInternas").textContent != "Z") {
        var elementToWriteCordenates = document.getElementById("BI_CoordenadasXY");
        var elementWithCordenates = document.getElementById("BI_CoordenadasXYInternas");

        if(w.map != null){
            ShowMouseCoordenatesConverted(elementWithCordenates, elementToWriteCordenates, w.unidadesDeLaProyeccion, "X: ", "Y: ", "  |  ", "yx");
        }
        // document.getElementById("BI_CoordenadasXY").textContent = "X:" + document.getElementById("BI_CoordenadasXYInternas").textContent.split(",")[0] + " | " + "Y:" + document.getElementById("BI_CoordenadasXYInternas").textContent.split(",")[1];
    } else {
        document.getElementById("BI_CoordenadasXY").textContent = "X:-" + " | " + "Y:-";
    }
});

function ShowMouseCoordenatesConverted(elementWithCordenates, elementToWriteCordenates, unidades, textX, textY, separator, orden){
    //elementWithCordenates debe ser x,y
    var x = elementWithCordenates.textContent.split(",")[0]
    var y = elementWithCordenates.textContent.split(",")[1];

    //aqui se guarda la conversion
    var xProcessed = "";
    var yProcessed = "";

    //chequeo la unidad para hacer cada proceso
    switch(unidades.toLowerCase()){
        case "test":
            xProcessed = x;
            yProcessed = y;
            break;

        case "gms":
            xProcessed = DecimalDegreesToGMS(x, "x");
            yProcessed = DecimalDegreesToGMS(y, "y");
            break;

        case "g":
            xProcessed = textX + (x).toLocaleString('de-DE') + "° ";
            yProcessed = textY + (y).toLocaleString('de-DE') + "° ";
            break;

        case "m":
            xProcessed = textX + (x).toLocaleString('de-DE') + " m ";
            yProcessed = textY + (y).toLocaleString('de-DE') + " m ";
            break;

        case "km":
            // console.log(w.GlobalMapView.getZoom());
            xProcessed = textX + (x/1000).toLocaleString('de-DE')  + " Km ";
            yProcessed = textY + (y/1000).toLocaleString('de-DE')  + " Km ";
            break;

        case "km_adaptive":

            if(w.ScaleBarData.scaleType == 'scaleline'){
                var barra = document.getElementsByClassName("ol-scale-line-inner")[0];
                if(barra != undefined){
                    if(barra.textContent.split(' ')[1].toLowerCase() == "km"){
                        if(barra.textContent.split(' ')[0] < 100){
                            xProcessed = textX + (x/1).toLocaleString('de-DE') + " m ";
                            yProcessed = textY + (y/1).toLocaleString('de-DE') + " m ";
                            break;
                        }else{
                            xProcessed = textX + (Math.trunc(x/1000)).toLocaleString('de-DE')  + " Km ";
                            yProcessed = textY + (Math.trunc(y/1000)).toLocaleString('de-DE')  + " Km ";
                            break;
                        }
                    }else{
                            xProcessed = textX + (Math.trunc(x/1000)).toLocaleString('de-DE')  + " Km ";
                            yProcessed = textY + (Math.trunc(y/1000)).toLocaleString('de-DE')  + " Km ";
                            break;
                    }
                }
            }else{

            var barra = document.getElementById("ScaleBar_Container").getElementsByClassName("ol-scale-text")[0];  //document.getElementsByClassName("ol-scale-text")[0];
                //console.log(barra.textContent.split(":")[1].replaceAll('.',''));
                if(barra != undefined){
                    if(barra.textContent.split(":")[1].replaceAll('.','').replaceAll(',','') < 1500000){
                        xProcessed = textX + (x/1).toLocaleString('de-DE') + " m ";
                        yProcessed = textY + (y/1).toLocaleString('de-DE') + " m ";
                        break;
                    }else{
                        xProcessed = textX + (Math.trunc(x/1000)).toLocaleString('de-DE')  + " Km ";
                        yProcessed = textY + (Math.trunc(y/1000)).toLocaleString('de-DE')  + " Km ";
                        break;
                    }
                }
            }

            break;
        default:
            break;
    }

    var textoResultado = "";

    switch(orden.toLowerCase() ){

        case "xy":
            textoResultado = xProcessed + separator + yProcessed;
            break;

        case "yx":
            textoResultado = yProcessed + separator + xProcessed;
            break;
    }

    elementToWriteCordenates.textContent =   textoResultado;

}

function DecimalDegreesToGMS(value, axis){

    //#region variables
    var result = "";

    var character = "";

    var valueAbs = 0;

    var degree = "";
    var minutes = "";
    var seconds = "";

    var degreeTrunc = "";
    var minutesTrunc = "";

    var degreeChar = '° ';
    var minutesChar = "' ";
    var secondsChar = '" ';
    //#endregion

    //genero el E, O, N, o S dependiendo de el eje y si es negativo o positivo
    if(axis.toLowerCase() == "x"){
        if(value > 0){
            character = "E ";
        }else{
            character = "O ";
        }
    }else{
        if(value > 0){
            character = "N ";
        }else{
            character = "S ";
        }
    }

    //calculo el valor de los grados
    valueAbs = Math.abs(value);
    degreeTrunc = Math.trunc(valueAbs);

    //calculo el valor de los minutos
    minutes = (valueAbs - degreeTrunc)*60;
    minutesTrunc = Math.trunc(minutes)

    //calculo el valor de los segundos
    seconds = Math.round((minutes - minutesTrunc) * 60);

    //arrastro el redondeo para no mostrar datos invalidos
    if(seconds == 60){
        minutesTrunc++;
        seconds = 0;
    }
    //arrastro el redondeo para no mostrar datos invalidos
    if(minutes == 60){
        degreeTrunc++;
        minutesTrunc = 0;
    }

    //regreso el resultado
    result = character + degreeTrunc + degreeChar + minutesTrunc + minutesChar + seconds + secondsChar;
    return result;
}

function SepararMiles(numero, separador){

    var intPart = numero.toString().split(".")[0];

    var signo = "";
    var cantidadNumeros;
    var result = "";

    if(numero < 0 ){
        var signo = "-";
    }

    cantidadNumeros = (Math.abs(numero)).toString().length;

    return result;
}

//cambia el sistema de referencia
document.getElementById("BI_ProjectionDropDown").addEventListener('change', function () {
    w.setProjectionOnMap(document.getElementById("BI_ProjectionDropDown").value)
});

//tooltip del selector de proyeccion
delayToolTip(document.getElementById("BI_ProjectionDropDown"), standarToolTipDelayInMS, "<span>Permite cambiar la Proyección activa en el visualizador <br>(re-proyección en el vuelo) <br>[Función EXPERIMENTAL]</span>");

//#endregion

//#region //funciones relacionadas a las ventanas flotantes

//#region Parametros
//creando ventana flotante

/** - Ventana Activa Actual
 * @type {HTMLElement} 
 */
var ActiveWindow = null;
/**  - Ventana Activa EN MOVIMIENTO
 * @type {HTMLElement}
 */
var ActiveWindowInMovment = null;

//estas variables gestionaran la pisicion de la ventana y
//el pading con el borde de la pantalla

//posicion nueva a la que se va a mover la ventana
var NewX = 0;
var NewY = 0;

//elementos que se usan mucho mas abajo
var mapHTML = document.getElementsByClassName("mapContainer")[0];

/** - Zona Activa, Aqui se colocan las ventanas cuando no estan minimizadas
 * @type {HTMLElement} 
 */
var activeZone = document.getElementById("ActiveZone");

var NewXMinPadding = 0;
var NewXMaxPadding = 0;
var NewYMinPadding = 0;
var NewYMaxPadding = 0;

//esto guardara la distancia que hay al borde
//de la ventana con respecto al click
var windowPadingX = 0;
var windowPadingY = 0;

//#endregion

/** - esta funcion le cambia el estado a activo a una ventana y se encarga de maximizar la que se llame desde el menu
* @param {HTMLElement} Ventana - ventana que se vaa a activar
*/
function ChangeActiveWindow( Ventana ){
    //si hay una ventana actica, la desactiva primero
    if(ActiveWindow != null){
        // ActiveWindow.className = "Window_Container";
        ActiveWindow.classList.remove("Window_Container_Active");
    }

    //seteo la ventana actica
    ActiveWindow = Ventana;
    if(Ventana.classList.contains("Window_Container_Minimized")){
        Ventana.classList.remove("Window_Container_Minimized");

            minimizedWindows--;
            CheckMinimizedWindowsQuantity();

            activeZone.appendChild(Ventana);

            MoverVentanaAlCentroDiv(Ventana, activeZone)
            
            Ventana.style.height = "auto";
            Ventana.getElementsByClassName("Window_Content_Container")[0].style.display = "flex"
        }
    
        Ventana.classList.add("Window_Container_Active");
}

function ChangeActiveWindowWithBlink(Ventana){
    ChangeActiveWindow(Ventana)

    Ventana.style.animation="NoAnim 1s linear";
    setTimeout(() => {
        Ventana.style.animation="AlertWindow 1s linear";
    }, 1);

}

//este evento se encarga de cambiar la ventana activa al cliquear en la misma
/**
 * 
 * @param {HTMLElement} ElementoHTML 
 */
function E_ActiveWindowOnClick(ElementoHTML){

    if(w.isMobile == false){
        ElementoHTML.addEventListener("mousedown",function(e){
            if(!ElementoHTML.classList.contains("Window_Container_Minimized")){
                ChangeActiveWindow(ElementoHTML);
            }

        });
    }else{
        ElementoHTML.addEventListener("touchstart",function(e){
            if(!ElementoHTML.classList.contains("Window_Container_Minimized")){
                ChangeActiveWindow(ElementoHTML);
            }
        });
    }
} // END E_ActiveWindowOnClick()

//evento que se encarga de minimizar la ventana al darle a [-]
function E_MinimizeMaximizeWindowOnClick(ElementoHTML){
    //console.log("adiero el evento");
    var BotonMinimizr = ElementoHTML.getElementsByClassName("W_MinimizeButon")[0];
    BotonMinimizr.addEventListener("click",function(e){
        //console.log("evento boton minimizar");
        if(ElementoHTML.getElementsByClassName("Window_Content_Container")[0].style.display == "flex"){
            if(ActiveWindow == ElementoHTML){
                ActiveWindow.classList.remove("Window_Container_Minimized");
                //ActiveWindow.className = "Window_Container";
                ActiveWindow = null;
            }

            ElementoHTML.getElementsByClassName("Window_Content_Container")[0].style.display = "none"
            // ElementoHTML.style.height = "26px";

            minimizedWindows++;
            CheckMinimizedWindowsQuantity();
            document.getElementById("MinimizedZone").appendChild(ElementoHTML);
            
            MoverHTMLElementToXY(ElementoHTML, (0) + "px|" + (0) + "px","relative");

            ElementoHTML.classList.add("Window_Container_Minimized");
            ElementoHTML.classList.remove("Window_Container_Active");
            //ElementoHTML.className = "Window_Container Window_Container_Minimized";

            ElementoHTML.focus();
            ElementoHTML.blur();
        }else{
            ChangeActiveWindow( ElementoHTML );
            //document.getElementById("ActiveZone").appendChild(ElementoHTML);

            //MoverHTMLElementToXY(ElementoHTML, (22) + "%|" + (15) + "%","absolute");
            MoverVentanaAlCentroDiv(ElementoHTML, document.getElementById("ActiveZone")  )

            ElementoHTML.style.height = "auto";
            ElementoHTML.getElementsByClassName("Window_Content_Container")[0].style.display = "flex"
        }
    });
}

//evento que se envarga de cerrar la ventana al darle a [X]
function E_CloseWindowOnClick(ElementoHTML, funcionOfTheButton, ArgumentOfFunction){
    var BotonClose = ElementoHTML.getElementsByClassName("W_CloseButon")[0];
    BotonClose.addEventListener("click",function(e){

    if(ElementoHTML.classList.contains("Window_Container_Minimized")){ //hasClass(ElementoHTML, "Window_Container_Minimized")
        ElementoHTML.remove();
        minimizedWindows--;
        CheckMinimizedWindowsQuantity();
    }else{
        if (ActiveWindow == ElementoHTML){
            ActiveWindow = null;
            ElementoHTML.remove();
        }else{
            ElementoHTML.remove();
        }
    }

    if(funcionOfTheButton != null && funcionOfTheButton != undefined){
        funcionOfTheButton.apply(this, ArgumentOfFunction);
    }

    });
}

//Evento que va en la ventana para poder desplzarla al cliquear en la barra
function E_DrageableWindowOnTitleClick( ElementoHTML ){

    if(w.isMobile == false){
        ElementoHTML.addEventListener("mousedown",function(e){
            if(ElementoHTML.parentElement.classList.contains("Window_Container_Minimized")){
                
            //console.log(ElementoHTML.parentElement.className);
            }else{
                //entra en estado drag la ventana
                if (ElementoHTML.getElementsByClassName("W_BarButton")[0].matches(":hover") == false && ElementoHTML.getElementsByClassName("W_BarButton")[1].matches(":hover") == false){
                    ActiveWindowInMovment = ElementoHTML.parentElement;

                    ElementoHTML.parentElement.setAttribute("window_original_pos", false);

                    windowPadingX = e.offsetX;
                    windowPadingY = e.offsetY;

                }else{
                    ActiveWindowInMovment = null
                    windowPadingX = e.offsetX;
                    windowPadingY = e.offsetY;
                }
            }

        });
    }else{
        ElementoHTML.addEventListener("touchstart",function(e){
            if(ElementoHTML.parentElement.classList.contains("Window_Container_Minimized")){
               
            //console.log(ElementoHTML.parentElement.className);
            }else{
                //entra en estado drag la ventana
                if (ElementoHTML.getElementsByClassName("W_BarButton")[0].matches(":hover") == false && ElementoHTML.getElementsByClassName("W_BarButton")[1].matches(":hover") == false){
                    ActiveWindowInMovment = ElementoHTML.parentElement;

                    ElementoHTML.parentElement.setAttribute("window_original_pos", false);

                    var rect = e.target.getBoundingClientRect();

                    windowPadingX = e.targetTouches[0].pageX - rect.left;
                    windowPadingY = e.targetTouches[0].pageY - rect.top;

                }else{
                    ActiveWindowInMovment = null
                    windowPadingX = e.offsetX;
                    windowPadingY = e.offsetY;
                }
            }

        });
    }

}

//gestiono las ventanas activas
w.addEventListener("mouseup", function(){
    //sale del estado drag la ventana
    ActiveWindowInMovment = null;
})

//gestiono las ventanas activas touch divices
w.addEventListener("touchend", function(){
    //sale del estado drag la ventana
    ActiveWindowInMovment = null;
})

//muevo la ventana activa cuando tenes el click apretado
w.addEventListener("mousemove", function(){

    if(ActiveWindowInMovment != null){

        if( mouseX - $(activeZone).offset().left - windowPadingX + $( ActiveWindowInMovment ).width() > $( activeZone ).width() - NewXMaxPadding){
            //console.log("la ventana se salio por la Derecha");
            NewX = $( activeZone ).width() - NewXMaxPadding - $( ActiveWindowInMovment ).width();
        }else{
            if( mouseX - $(activeZone).offset().left - windowPadingX - NewXMinPadding < 0){
                NewX = 0 + NewXMinPadding;
                //console.log("la ventana se salio por la Izquierda");
            }else{
                NewX = mouseX - $(activeZone).offset().left - windowPadingX;
            }
        }

        if( mouseY - $(activeZone).offset().top - windowPadingY + $( ActiveWindowInMovment ).height() > $( activeZone ).height() - NewYMaxPadding){
            //console.log("la ventana se salio por Abajo");
            NewY = $( activeZone ).height() - NewYMaxPadding - $( ActiveWindowInMovment ).height();
        }else{
            if( mouseY - $(activeZone).offset().top - windowPadingY - NewYMinPadding< 0){
                NewY = 0 + NewYMinPadding;
                //console.log("la ventana se salio por Arriba");
            }else{
                NewY = mouseY -$(activeZone).offset().top - windowPadingY;
            }
        }

        //muevo la ventana a la pisicion segun los datos
        MoverHTMLElementToXYRelative(ActiveWindowInMovment, (NewX) + "px|" + (NewY) + "px","absolute");
    }
});

//muevo la ventana activa cuando tenes el Dedo en el celular
w.addEventListener("touchmove", function(){

    if(ActiveWindowInMovment != null){

        if( mouseX - $(activeZone).offset().left - windowPadingX + $( ActiveWindowInMovment ).width() > $( activeZone ).width() - NewXMaxPadding){
            //console.log("la ventana se salio por la Derecha");
            NewX = $( activeZone ).width() - NewXMaxPadding - $( ActiveWindowInMovment ).width();
        }else{
            if( mouseX - $(activeZone).offset().left - windowPadingX - NewXMinPadding < 0){
                NewX = 0 + NewXMinPadding;
                //console.log("la ventana se salio por la Izquierda");
            }else{
                NewX = mouseX - $(activeZone).offset().left - windowPadingX;
            }
        }

        if( mouseY - $(activeZone).offset().top - windowPadingY + $( ActiveWindowInMovment ).height() > $( activeZone ).height() - NewYMaxPadding){
            //console.log("la ventana se salio por Abajo");
            NewY = $( activeZone ).height() - NewYMaxPadding - $( ActiveWindowInMovment ).height();
        }else{
            if( mouseY - $(activeZone).offset().top - windowPadingY - NewYMinPadding< 0){
                NewY = 0 + NewYMinPadding;
                //console.log("la ventana se salio por Arriba");
            }else{
                NewY = mouseY -$(activeZone).offset().top - windowPadingY;
            }
        }

        //muevo la ventana a la pisicion segun los datos
        MoverHTMLElementToXYRelative(ActiveWindowInMovment, (NewX) + "px|" + (NewY) + "px","absolute");
    }
});

//crea una ventana flotante con el nombre Nombre Ventana
function CreateWindow( NombreVentana, funcionOfTheButton, ArgumentOfFunction){
    if(document.getElementById(NombreVentana) == null){

    //Creo el contenedo de la ventana
        let Window_Container = document.createElement('div');
        Window_Container.classList.add("Window_Container");
        Window_Container.classList.add("DesenfocaFondo");

        Window_Container.setAttribute("window_original_pos", true);
        Window_Container.id = NombreVentana;

    //Creo la barra de la ventan
        let Window_Title_Container = document.createElement('div');
        Window_Title_Container.className = "Window_Title_Container BaseColorSinHoverBordeVentana";
        //creo los eventos necesarios para poder arrastrar la ventana
        E_DrageableWindowOnTitleClick(Window_Title_Container);

    //Creo El bloque que tiene el nombre de la ventana
        let W_TitleText =  document.createElement('div');
        W_TitleText.className = "W_TitleText";
        W_TitleText.textContent = NombreVentana;
        //lo agrego a la barra
        Window_Title_Container.appendChild(W_TitleText);

    //Creo el boton de Cerrar Ventana
        let W_MinimizeButon =  document.createElement('div');
        W_MinimizeButon.className = "W_BarButton W_MinimizeButon BaseColorBotonMinimizar";

        let W_MinimizeButonIcon =  document.createElement('img');
        W_MinimizeButonIcon.className = "W_Minimize";
        W_MinimizeButonIcon.src = W_Minimizar;

        W_MinimizeButon.appendChild(W_MinimizeButonIcon);
        //W_MinimizeButon.textContent = "−";
        //lo agrego a la barra
        Window_Title_Container.appendChild(W_MinimizeButon);

    //Creo el boton de Cerrar Ventana
        let W_CloseButon =  document.createElement('div');
        W_CloseButon.className = "W_BarButton W_CloseButon BaseColorBotonCerrar";

        let W_CloseButonIcon =  document.createElement('img');
        W_CloseButonIcon.className = "W_Close";
        W_CloseButonIcon.src = W_Cerrar;

        W_CloseButon.appendChild(W_CloseButonIcon);

        //W_CloseButon.textContent = "X";
        //lo agrego a la barra
        Window_Title_Container.appendChild(W_CloseButon);

        //ahora agrego la barra a la ventana
        Window_Container.appendChild(Window_Title_Container);

    //Creo el contenedor del contenido de la ventana
        let Window_Content_Container = document.createElement('div');
        Window_Content_Container.className = "Window_Content_Container BaseColorSinHoverContenidoVentana";
        Window_Content_Container.style.display = "flex";

        let Window_Content_Container_Box = document.createElement('div');
        Window_Content_Container_Box.className = "Window_Content_Container_Box BlackScrollBar TransparentColor";
        Window_Content_Container_Box.style.display = "flex";

        Window_Content_Container.appendChild(Window_Content_Container_Box);
        Window_Container.appendChild(Window_Content_Container);

        //ahora agrego la ventana al body para que sea visible
        E_ActiveWindowOnClick(Window_Container)

        activeZone.appendChild(Window_Container);
        //document.body.appendChild(Window_Container);

        //eventos de los botones close y minimize, necesitan la ventana
        //terminada, por eso estan aca abajo
        E_MinimizeMaximizeWindowOnClick(Window_Container);
        E_CloseWindowOnClick(Window_Container, funcionOfTheButton, ArgumentOfFunction);
    }
}

//crea una ventana flotante con el nombre Nombre Ventana
function CreateWindowID( NombreVentana, ID, funcionOfTheButton, ArgumentOfFunction){
    if(document.getElementById(NombreVentana) == null){

    //Creo el contenedo de la ventana
        let Window_Container = document.createElement('div');
        Window_Container.classList.add("Window_Container");
        Window_Container.classList.add("DesenfocaFondo");

        Window_Container.setAttribute("window_original_pos", true);
        Window_Container.id = ID;

    //Creo la barra de la ventan
        let Window_Title_Container = document.createElement('div');
        Window_Title_Container.className = "Window_Title_Container BaseColorSinHoverBordeVentana";
        //creo los eventos necesarios para poder arrastrar la ventana
        E_DrageableWindowOnTitleClick(Window_Title_Container);

    //Creo El bloque que tiene el nombre de la ventana
        let W_TitleText =  document.createElement('div');
        W_TitleText.className = "W_TitleText";
        W_TitleText.textContent = NombreVentana;
        //lo agrego a la barra
        Window_Title_Container.appendChild(W_TitleText);

    //Creo el boton de Cerrar Ventana
        let W_MinimizeButon =  document.createElement('div');
        W_MinimizeButon.className = "W_BarButton W_MinimizeButon BaseColorBotonMinimizar";

        let W_MinimizeButonIcon =  document.createElement('img');
        W_MinimizeButonIcon.className = "W_Minimize";
        W_MinimizeButonIcon.src = W_Minimizar;

        W_MinimizeButon.appendChild(W_MinimizeButonIcon);
        //W_MinimizeButon.textContent = "−";
        //lo agrego a la barra
        Window_Title_Container.appendChild(W_MinimizeButon);

    //Creo el boton de Cerrar Ventana
        let W_CloseButon =  document.createElement('div');
        W_CloseButon.className = "W_BarButton W_CloseButon BaseColorBotonCerrar";

        let W_CloseButonIcon =  document.createElement('img');
        W_CloseButonIcon.className = "W_Close";
        W_CloseButonIcon.src = W_Cerrar;

        W_CloseButon.appendChild(W_CloseButonIcon);

        //W_CloseButon.textContent = "X";
        //lo agrego a la barra
        Window_Title_Container.appendChild(W_CloseButon);

        //ahora agrego la barra a la ventana
        Window_Container.appendChild(Window_Title_Container);

    //Creo el contenedor del contenido de la ventana
        let Window_Content_Container = document.createElement('div');
        Window_Content_Container.className = "Window_Content_Container BaseColorSinHoverContenidoVentana";
        Window_Content_Container.style.display = "flex";

        let Window_Content_Container_Box = document.createElement('div');
        Window_Content_Container_Box.className = "Window_Content_Container_Box BlackScrollBar TransparentColor";
        Window_Content_Container_Box.style.display = "flex";

        Window_Content_Container.appendChild(Window_Content_Container_Box);
        Window_Container.appendChild(Window_Content_Container);

        //ahora agrego la ventana al body para que sea visible
        E_ActiveWindowOnClick(Window_Container)

        activeZone.appendChild(Window_Container);
        //document.body.appendChild(Window_Container);

        //eventos de los botones close y minimize, necesitan la ventana
        //terminada, por eso estan aca abajo
        E_MinimizeMaximizeWindowOnClick(Window_Container);
        E_CloseWindowOnClick(Window_Container, funcionOfTheButton, ArgumentOfFunction);
    
        return Window_Container;
    }
}

function modify(name,newVal){
    window[name] = newVal;
  }

/** - recorta el texto y agrega ... par poder usarlo en ventanas por ejemplo si que quede muy largo
 * @param {Object} opciones - objeto de opciones con los parametros
 * @param {string} opciones.nombre - texto a utilizar
 * @param {number} opciones.cantCaracteres - numero de caracteres buscado
 * @param {boolean} opciones.respetarEspacios - si respeta espacios o no, si respeta espacios nunca cortara palabras, corta en los espacios
 * @param {boolean} opciones.sobrecarga - si se respetan los espacios, sobrecarga quiere decir que el texto final puede ser mas largo que los caracteres buscados para no cortar la palabra, en caso contrario simplemente se cortara cuando el texto actual mas la siguiente palabra supere los caracteres buscados
 * @returns {string} Tabla Lista y en la Ventana o Bloque
 *
 * @author Agustin Parodi
 */
function nombreCortado( opciones){

    let nombre = opciones.nombre;
    let cantCaracteres = opciones.cantCaracteres;
    let respetarEspacios = opciones.respetarEspacios;
    let sobrecarga = opciones.sobrecarga;

    if(respetarEspacios){

        let palabras = nombre.split(' ');
        let contador = 0;
        let resultado = "";

        for (const palabra of palabras) {

            if(sobrecarga){

                resultado += palabra + " ";
                if(resultado.length > cantCaracteres){
                    break;
                }

            }else{

                if((resultado.length + palabra.length) > cantCaracteres){
                    break;
                }else{
                    resultado += palabra + " ";
                }

            }
            
        }

        if(nombre.length > resultado.length){
            resultado += "...";
        }
        return (resultado);
        
    }else{
        if(nombre.length > cantCaracteres){
            return (nombre.substring(0, cantCaracteres) + "...")
        }

        return (nombre);
    
    }
}

function ColocarSemiPanel(inContent, VentanaObjetivo, W_SemiPanel){
    if(inContent){
        VentanaObjetivo.getElementsByClassName("Window_Content_Container_Box")[0].appendChild(W_SemiPanel);
    }else{
        VentanaObjetivo.getElementsByClassName("Window_Content_Container")[0].appendChild(W_SemiPanel);
    }
}

function CreateSemiPanelOnWindow(VentanaObjetivo, SemiPanelID, inContent){

    //Creo el bloque del semi panel
    let W_SemiPanel = document.createElement('div');
    W_SemiPanel.className = "W_SemiPanel BaseColorSinHoverSinFondoConBorde";
    W_SemiPanel.id = SemiPanelID;

    ColocarSemiPanel(inContent, VentanaObjetivo, W_SemiPanel);

    return W_SemiPanel;
}

function CreateSemiPanelOnWindowFlexHorizontal(VentanaObjetivo, SemiPanelID, inContent){

    //Creo el bloque del semi panel
    let W_SemiPanel = document.createElement('div');
    W_SemiPanel.className = "W_SemiPanel W_SemiPanel_FlexHorizontal BaseColorSinHoverSinFondoConBorde";
    W_SemiPanel.id = SemiPanelID;

    ColocarSemiPanel(inContent, VentanaObjetivo, W_SemiPanel);

    return W_SemiPanel;
}

//este evento da la capacidad de editar el texto, muestra el tooltip y
//ademas se encarga de filtrar los caracteres de entrada segun el ultimo parametro
function E_LabelImput(W_LabeledInput, Tooltip, restriccion, caracteres, HTMLToModify){

    var defaultText = W_LabeledInput.childNodes[1].textContent;

    //esto se disparara si se apreta el enter, y saldra de la edicion
    W_LabeledInput.childNodes[1].addEventListener('keydown', function (e) {
        if (e.keyCode === 13 && W_LabeledInput.childNodes[1].className == "W_ImputZone") {
            W_LabeledInput.childNodes[1].blur()
        }
    });

    W_LabeledInput.childNodes[1].addEventListener('click', function (e) {
        if(W_LabeledInput.childNodes[1].textContent == defaultText){
            W_LabeledInput.childNodes[1].textContent = "";
        }
    });

    if(restriccion.toLowerCase() == "file"){
        //este evento extraño se disparara cuand el texto cambie, esto lo que ara sera que
        //siempre que cambie el texto se comprobara si se puso un enter y lo borrara

        //binding keyup/down events on the contenteditable div
        $(W_LabeledInput.childNodes[1]).on('keyup', function(e){ check_charcount( caracteres, e); });
        $(W_LabeledInput.childNodes[1]).on('keydown', function(e){ check_charcount( caracteres, e); });

        $(W_LabeledInput.childNodes[1]).on('paste', function(e){
            var text = (e.originalEvent || e).clipboardData.getData('text/plain');
            text = text.replaceAll("\r\n", '');
            text = text.replaceAll("\\", '');
            text = text.replaceAll("/", '');
            text = text.replaceAll(":", '');
            text = text.replaceAll("*", '');
            text = text.replaceAll('"', '');
            text = text.replaceAll("<", '');
            text = text.replaceAll(">", '');
            text = text.replaceAll("|", '');
            text = text.replaceAll("?", '');
            text = text.replaceAll(".", '');
            text = text.replaceAll("-", '');
            text = text.replaceAll("_", '');
            //$(W_LabeledInput.childNodes[1]).text(texto);
            e.preventDefault();
            //(e.originalEvent || e).clipboardData = text;
            w.document.execCommand('insertText', false, text);
            //$(W_LabeledInput.childNodes[1]).text( $(W_LabeledInput.childNodes[1]).text() + text)
        });

        var restrictionChar = '\r\n \\ / : * " < > | ? . - _';

        function check_charcount(max, e)
        {
            //chequeo si ya se llego al limite de caracteres
            if(e.which != 8 && e.which != 17 && e.which != 37 && e.which != 39 &&  e.which != 38  && e.which != 40 &&$(W_LabeledInput.childNodes[1]).text().length > max-1)
            {
                //si ya esta lleno compruebo si se pasa para atrapar el control+v
                if($(W_LabeledInput.childNodes[1]).text().length > max){
                    e.preventDefault();
                    $(W_LabeledInput.childNodes[1]).text( $(W_LabeledInput.childNodes[1]).text().substring(0, max) );
                }
                e.preventDefault();
            }

            if(e.key == 'Enter' || e.key == '/' || e.key == '\\' || e.key == ':' || e.key == '*' || e.key == '"' || e.key == '<' || e.key == '>' || e.key == '|' || e.key == '?' || e.key == '.' || e.key == '-' || e.key == '_'){
                e.preventDefault();
            }

            if(e.which == 17){

                //console.log("hola");

                var needCorrections = false;

                for(var indiceA = 0; indiceA < $(W_LabeledInput.childNodes[1]).text().length; indiceA++){
                    //console.log($(W_LabeledInput.childNodes[1]).text().charAt(indiceA) + " = " + restrictionChar.includes( $(W_LabeledInput.childNodes[1]).text().charAt(indiceA) ));
                    if(restrictionChar.includes( $(W_LabeledInput.childNodes[1]).text().charAt(indiceA) )){
                        needCorrections = true;
                        //console.log("Error");
                    }
                }

                if(needCorrections){
                    var texto = $(W_LabeledInput.childNodes[1]).text();
                    texto = texto.replaceAll("\r\n", '');
                    texto = texto.replaceAll("\\", '');
                    texto = texto.replaceAll("/", '');
                    texto = texto.replaceAll(":", '');
                    texto = texto.replaceAll("*", '');
                    texto = texto.replaceAll('"', '');
                    texto = texto.replaceAll("<", '');
                    texto = texto.replaceAll(">", '');
                    texto = texto.replaceAll("|", '');
                    texto = texto.replaceAll("?", '');
                    texto = texto.replaceAll(".", '');
                    texto = texto.replaceAll("-", '');
                    texto = texto.replaceAll("_", '');
                $(W_LabeledInput.childNodes[1]).text(texto);
                }

            }
        }

        //esto pasa si se pierde el foco del texto que se esta editando
        W_LabeledInput.childNodes[1].addEventListener('focusout', function () {
        if($(W_LabeledInput.childNodes[1]).text().trim() == "" ){
            $(W_LabeledInput.childNodes[1]).text(defaultText);
        }
        //     //me aseguro de no guardar el texto con un enter
        //     var texto = W_LabeledInput.childNodes[1].textContent;
        //     texto = texto.replaceAll("\r\n", '');
        //     texto = texto.replaceAll("\\", '');
        //     texto = texto.replaceAll("/", '');
        //     texto = texto.replaceAll(":", '');
        //     texto = texto.replaceAll("*", '');
        //     texto = texto.replaceAll('"', '');
        //     texto = texto.replaceAll("<", '');
        //     texto = texto.replaceAll(">", '');
        //     texto = texto.replaceAll("|", '');
        //     texto = texto.replaceAll("?", '');
        //     texto = texto.replaceAll(".", '');
        //     texto = texto.replaceAll("-", '');
        //     texto = texto.replaceAll("_", '');
        //     W_LabeledInput.childNodes[1].textContent = texto;
        });
    }

    if(restriccion.toLowerCase() == "number"){
        var PermitedChar = "0123456789"

        W_LabeledInput.childNodes[1].addEventListener('keypress', function(e){ check_charcount( caracteres, e); });

        W_LabeledInput.childNodes[1].addEventListener('paste', function(e){
            e.preventDefault();
        });

        function check_charcount(max, e)
        {
            if(e.keyCode === 13){
                W_LabeledInput.childNodes[1].blur();
                e.preventDefault();
            }

            //chequeo si ya se llego al limite de caracteres
            if($(W_LabeledInput.childNodes[1]).text().length > max-1)
            {
                e.preventDefault();
            }else{
                // console.log("e.charCode = " + e.charCode)
                // console.log("e.keyCode = " + e.keyCode)
                if( !(e.charCode >= 48 && e.charCode <= 57) ){
                     e.preventDefault();
                }else{
                }
            }
        }
    }

    var internalText = "";

    if(restriccion.toLowerCase() == "wms"){

        $(W_LabeledInput.childNodes[1]).on('paste', function(e){
            var text = (e.originalEvent || e).clipboardData.getData('text/plain');
            text = text.replaceAll("\r\n", '');
            text = text.replaceAll(' ', '');
            e.preventDefault();
            w.document.execCommand('insertText', false, text);
            check_characters(e);
        });

        $(W_LabeledInput.childNodes[1]).on('keyup', function(e){ check_characters(e); });
        $(W_LabeledInput.childNodes[1]).on('keydown', function(e){ check_characters(e); });

        function check_characters(e){
            if(e.key == 'Enter' || e.key == ' '){
                e.preventDefault();
            }else{
                if(internalText != $(W_LabeledInput.childNodes[1]).text() ){
                    internalText = $(W_LabeledInput.childNodes[1]).text();
                    CheckWMS( $(W_LabeledInput.childNodes[1]).text(), HTMLToModify);

                    //reviso si existe el boton y el tick
                    var WMSCheckTick = HTMLToModify.parentElement.parentElement.parentElement.getElementsByClassName("WMSCheckTick");
                    var WMSCheckButton = HTMLToModify.parentElement.parentElement.parentElement.parentElement.getElementsByClassName("WMSCheckButton");
                    if(WMSCheckButton.length > 0){
                        ChangeButtonState(WMSCheckButton[0], false);
                        if(WMSCheckTick.length > 0){
                            ChangeButtonState(WMSCheckTick[0], false);

                        }
                    }

                }

            }
        }

    }

    delayToolTip(W_LabeledInput, standarToolTipDelayInMS, Tooltip);

}

function CheckWMS( WMSLink , HTMLToModify){
    //console.log(WMSLink);
    w.XMLRead(WMSLink, HTMLToModify);
}

/** - Agrega un control a una ventana o bloque objetivo
 * @param {HTMLElement} W_FileInput - Imput a colocar el evento
 * @param {string} Tooltip - texto del tooltip
 * @param {string[]} FormatRestriction - Lista de formatos soportados por el File Input
 * @author Agustin Parodi
*/
function E_FileImput(W_FileInput, Tooltip, FormatRestriction){

    var FileInputElement = W_FileInput.getElementsByClassName("W_InputFile")[0];
    var fileImputButonElement = W_FileInput.getElementsByClassName("W_button")[0];
    var W_FileLabelElement = W_FileInput.getElementsByClassName("W_FileLabel")[0];

    $(fileImputButonElement).on('click', function() {
        $(FileInputElement).trigger('click');
    });


    $(FileInputElement).on("change", function(){
        // console.log("se subio el archivo " + FileInputElement.files[0].name + " Size: " + (FileInputElement.files[0].size/1024/1014).toFixed(2) + "MB");

        if( FormatRestriction.toLowerCase().indexOf( ("." + FileInputElement.files[0].name.split(".")[1]).toLowerCase() ) != -1){
            if(hasClass(W_FileLabelElement, "ImputError") == true){
                W_FileLabelElement.className = W_FileLabelElement.className.replace(" ImputError", "");
            }
            $(W_FileLabelElement).text(FileInputElement.files[0].name + " (" + (FileInputElement.files[0].size/1024/1014).toFixed(2) + " MB)");

        }else{
            $(W_FileLabelElement).text("Archivo No Válido - Formatos permitidos: " + FormatRestriction);
            WindowMostrarError(W_FileLabelElement, "Archivo No Válido " + "Formatos permitidos: " + FormatRestriction, true);
        }
    });

    delayToolTip(W_FileInput, standarToolTipDelayInMS, Tooltip);

}

/** - Agrega un control a una ventana o bloque objetivo
 * @param {HTMLElement} VentanaOBloqueObjetivo - La Ventana o bloque a la que se va a agregar el control
 * @param {HTMLElement} Control - El control a agregar en la ventana o bloque
 * @author Agustin Parodi
*/
function AgregarControlAVentanaObloque (VentanaOBloqueObjetivo, Control){
    if(VentanaOBloqueObjetivo.className.indexOf("W_SemiPanel") != -1 ){
        VentanaOBloqueObjetivo.appendChild(Control);
    }else{
        if( VentanaOBloqueObjetivo.getElementsByClassName("Window_Content_Container_Box")[0] != undefined){
            VentanaOBloqueObjetivo.getElementsByClassName("Window_Content_Container_Box")[0].appendChild(Control);
        }else{
            VentanaOBloqueObjetivo.appendChild(Control);
        }
    }
}

/** - Mueve la ventana al Centro del div pasado por parametro
 * @param {HTMLElement} Ventana - La Ventana que se va a mover
 * @param {HTMLElement} ZonaDeMovimiento - Es El Div que se usa para calcular el centro
 * @author Agustin Parodi
*/
function MoverVentanaAlCentro(Ventana, ZonaDeMovimiento){
    MoverHTMLElementToXYRelative(Ventana, (($(ZonaDeMovimiento).width()/1.71) - ($(Ventana).width()/2)) + "px|" + (($(ZonaDeMovimiento).height()/2) - ( ($(Ventana).height())/2 )) + "px","absolute");
}

/** - Mueve la ventana al Centro del div pasado por parametro
 * @param {HTMLElement} Ventana - La Ventana que se va a mover
 * @param {HTMLElement} ZonaDeMovimiento - Es El Div que se usa para calcular el centro
 * @author Agustin Parodi
*/
function MoverVentanaAlCentroDiv(Ventana, ZonaDeMovimiento){
    MoverHTMLElementToXYRelative(Ventana, ( ($(ZonaDeMovimiento).width()/2) - ($(Ventana).width()/2)) + "px|" + (($(ZonaDeMovimiento).height()/2) - ( ($(Ventana).height())/2 )) + "px","absolute");
}

/** - Crea un boton, y le agrega su funcion
 * @param {HTMLElement} VentanaOBloqueObjetivo - La Ventana o bloque dentro de la ventana donde se va a crear el boton
 * @param {string} TextoBoton - Texto del boton
 * @param {string} ToolTipText - Texto del tooltip del boton
 * @param {() => void} funcionOfTheButton - Funcion que ejecutara el boton
 * @param {[]} ArgumentOfFunction - Lista de argumentos para la funcion del boton
 * @param {string} ExtraClass - funcion extra al agregar al boton (originalmente pensado para apagar el boton con "Buton_OFF")
 * @author Agustin Parodi
*/
function CreateButtons(VentanaOBloqueObjetivo, TextoBoton, ToolTipText, funcionOfTheButton, ArgumentOfFunction, ExtraClass){

    //Creo el bloque del label
    let W_button = document.createElement('div');
    W_button.className = "W_button BaseColorExtraTransparent ExtraBorder";
    W_button.textContent = TextoBoton;

    if(ToolTipText != ""){
        delayToolTip(W_button, standarToolTipDelayInMS, ToolTipText);
    }

    W_button.addEventListener('click', function(){
        //revisamos si el botton fue desactivado o no y si no fue desactivado ejecuto la accion
        if(hasClass(this, "Buton_OFF") == true){
            //console.log("Estoy apagado");
        }else{
            if(funcionOfTheButton != null && funcionOfTheButton != undefined){
                funcionOfTheButton.apply(this, ArgumentOfFunction);
            }else{
                console.warn("Este boton no hace nada todavia o algo salió mal");
            }
        }
    });

    if(ExtraClass != ""){
        W_button.className = W_button.className + " " + ExtraClass;
    }

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_button);

    return W_button;
}

/** - Crea Label con texto centrado
 * @param {HTMLElement} VentanaOBloqueObjetivo - La Ventana o bloque dentro de la ventana donde se va a crear el Elemento
 * @param {LayerData} layerDataToUse - layer data a ser usada
 * @author Agustin Parodi
*/
function CreateMetadataTable( VentanaOBloqueObjetivo, layerDataToUse){
    let W_MetaTable = document.createElement('table');
    W_MetaTable.className = "W_MetaTable";
    
    let origen = layerDataToUse.Metadata.Origen;
    let tipoDeCapa = Get_TipoDeCapa(layerDataToUse);

    let formato = layerDataToUse.Formato.toLowerCase()
    let atributions = layerDataToUse.Attributions

    let W_MetaTable_tbody = document.createElement('tbody');
    W_MetaTable.appendChild(W_MetaTable_tbody)

    //description
    let description = layerDataToUse.Description
    if(description == undefined){
        description = "Sin descripción."
    }

    W_MetaTable_tbody.innerHTML = 
    `
    <tr>
        <th>Nombre:</th>
        <td>${layerDataToUse.Nombre}</td>
    </tr>
    <tr>
        <th>Descripción:</th>
        <td>${description}</td>
    </tr>
    <tr>
        <th>Tipo de Capa:</th>
        <td>${ tipoDeCapa }</td>
    </tr>
    <tr>
        <th>Formato de Capa:</th>
        <td>${layerDataToUse.Formato}</td>
    </tr>
    <tr>
        <th>Origen:</th>
        <td class=BlackScrollBar> 
            <span class="WMSLink ${formato == "wms"? "W_link" : ""}" tooltip="${formato == "wms"? "<span>Click para copiar link al portapapeles</span>" : "Información del origen de los datos"}" >
                ${origen}
            </span> 
        </td>
    </tr>
    `
    let linkHTML = W_MetaTable.querySelector('span.WMSLink');
    delayToolTip(linkHTML, standarToolTipDelayInMS, null);
    if(formato == "wms"){
        linkHTML.addEventListener('click', (e)=>{
            //console.log("click origen")
            copyToClipboard( e.target.textContent.trim() )
        })
    }
   
    if(atributions != ""){
        let tr = document.createElement('tr'); 

        tr.innerHTML += 
        `
        <th>Fuente / Licencia:</th>
        <td>
            <span class="fuenteLink W_link" tooltip="<span>Click para ver detalles de la fuente / licencia</span>">
                ${atributions[1]}
            </span> 
        </td>
        `

        let fuenteLink = tr.querySelector('span.fuenteLink');
        delayToolTip(fuenteLink, standarToolTipDelayInMS, null);
        fuenteLink.addEventListener('click', (e)=>{
            console.log("click link atributions")
            window.open(atributions[0], '_blank');
        })

        W_MetaTable_tbody.appendChild(tr);
    }

    if(tipoDeCapa == "Servicio Web" && origen != "Open street map" ){
        //CREO EL PRIMER BLOQUE
        let tr1 = document.createElement('tr'); 
        tr1.innerHTML += `
            <th>Tipo Transferencia:</th>
            <td>${layerDataToUse.Metadata.Format}</td>
        `;
        W_MetaTable_tbody.appendChild(tr1);
        
        //CREO EL SEGUNDO BLOQUE
        let tr2 = document.createElement('tr'); 
        tr2.innerHTML +=`
            <th>Cantidad Capas:</th>
            <td>${layerDataToUse.Metadata.LayerCount}</td>
        `;
        W_MetaTable_tbody.appendChild(tr2);

        //CREO EL TERCER BLOQUE
        let tr3 = document.createElement('tr');
        tr3.innerHTML +=`
            <th>Capas:</th>
            <td>
                <table>
                    ${CrearTablaLayers( layerDataToUse ).innerHTML}
                </table>
            </td>
        `;
        W_MetaTable_tbody.appendChild(tr3);
    }

    
    //Creo el bloque compuesto
    let W_ElementBlock = document.createElement('div');
    W_ElementBlock.className = "W_MetaTableBlock";

    //agrego el label al bloque
    W_ElementBlock.appendChild(W_MetaTable);

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_ElementBlock);

    return W_ElementBlock;

}

function CrearTablaLayers( layerData ){
    // console.log("CrearTablaLayers")
    let tabla = document.createElement('table');
    let tbody = document.createElement('tbody');

    let titulos = layerData.LayerTitles;
    let nombre = layerData.LayerNames;

    for(let i = 0; i < titulos.length; i++){

        let tr = document.createElement('tr');

        tr.innerHTML=`
        <td class="${i < nombre.length ? "" : "W_Layer_NOT_Loaded"}">
            ${titulos[i]}  ${i < nombre.length ? "" : "<br>(No Cargada)"} 
        </td>
        `;

        tbody.appendChild(tr);
    }

    tabla.appendChild(tbody);

    return tabla;
}

/** - copia al portapapeles el texto pasado por parametro
 * @param {string} textToCopy - texto a copiar al portapapeles
 */
function CopiarAlPortapapeles( textToCopy ) {
  
     /* Copy the text inside the text field */
    navigator.clipboard.writeText(textToCopy);
  
    /* Alert the copied text */
    console.log("Copied the text: " + textToCopy);
  }

function copyToClipboard(textToCopy) {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        return navigator.clipboard.writeText(textToCopy);
    } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // here the magic happens
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
        });
    }
}

/** - Crea Label con texto centrado
 * @param {HTMLElement} VentanaOBloqueObjetivo - La Ventana o bloque dentro de la ventana donde se va a crear el Elemento
 * @param {string} LabelText - Texto del Label
 * @author Agustin Parodi
*/
function CreateCentredLabel( VentanaOBloqueObjetivo, LabelText){

    //Creo el bloque del label
    let W_Label = document.createElement('div');
    W_Label.className = "W_Label W_Label_Centred W_FullBlock";
    //$(W_Label).text('text\r\ntext2');
    //W_Label.textContent = LabelText;
    W_Label.innerText = LabelText;

    //Creo el bloque compuesto
    let W_LabeledBlock = document.createElement('div');
    W_LabeledBlock.className = "W_LabeledBlock";

    //agrego el label al bloque
    W_LabeledBlock.appendChild(W_Label);

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_LabeledBlock);

    return W_LabeledBlock;
}

/** - Crea Label con texto centrado
 * @param {HTMLElement} VentanaOBloqueObjetivo - La Ventana o bloque dentro de la ventana donde se va a crear el Elemento
 * @param {string} LabelText - Texto del Label
 * @author Agustin Parodi
*/
function CreateProgressBar( VentanaOBloqueObjetivo ){

    //Creo el bloque del label
    let W_ProgressBlock = document.createElement('div');
    W_ProgressBlock.className = "W_ProgressBarBlock" 

    let W_ProgressBar_BG = document.createElement('div');
    W_ProgressBar_BG.className = "W_ProgressBar_BG" 

    let W_ProgressBar_Value = document.createElement('div');
    W_ProgressBar_Value.className = "W_ProgressBar_Value AnimateBar" 
    
    W_ProgressBar_BG.appendChild(W_ProgressBar_Value);
    W_ProgressBlock.appendChild(W_ProgressBar_BG)

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_ProgressBlock);

    return W_ProgressBlock;
}

/** - Crea Label con texto en HTML centrado
 * @param {HTMLElement} VentanaOBloqueObjetivo - La Ventana o bloque dentro de la ventana donde se va a crear el Elemento
 * @param {string} LabelText - Texto del Label en formato HTML (ej: \<p>Texto\</p> )
 * @author Agustin Parodi
*/
function CreateCentredLabelHTMLText( VentanaOBloqueObjetivo, LabelText){

    //Creo el bloque del label
    let W_Label = document.createElement('div');
    W_Label.className = "W_Label W_Label_Centred W_FullBlock";
    //$(W_Label).text('text\r\ntext2');
    //W_Label.textContent = LabelText;
    //console.log(LabelText);
    W_Label.innerHTML = LabelText;

    //Creo el bloque compuesto
    let W_LabeledBlock = document.createElement('div');
    W_LabeledBlock.className = "W_LabeledBlock";

    //agrego el label al bloque
    W_LabeledBlock.appendChild(W_Label);

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_LabeledBlock);

    return W_LabeledBlock;
}

/** - Crea InputText con un Label con texto
 * @param {HTMLElement} VentanaOBloqueObjetivo - La Ventana o bloque dentro de la ventana donde se va a crear el Elemento
 * @param {string} LabelName - Texto del Label
 * @param {string} DefaultText - Texto por defecto del Input
 * @param {string} ToolTipText - Texto del Tooltip
 * @param {string} RestriccionesInput - Restriccion del Input (por ejemplo: numbers, solo permite numeros)
 * @param {Number} caracteres - Cantidad de caracteres maximos del Input
 * @param {HTMLDocument} HTMLToModify - HTML que modificara, en caso que sea necesario (se usa solo para la ventana de wms)
 * @author Agustin Parodi
*/
function CreateLabelImput( VentanaOBloqueObjetivo, LabelName, DefaultText, ToolTipText, RestriccionesInput, caracteres, HTMLToModify){

    //Creo el bloque del label
    let W_Label = document.createElement('div');
    W_Label.className = "W_Label";
    W_Label.textContent = LabelName;

    //Creo el bloque del label
    let W_ImputZone = document.createElement('div');
    W_ImputZone.className = "W_ImputZone BaseColorExtraTransparent ExtraBorder BlackScrollBar";
    W_ImputZone.textContent = DefaultText;
    W_ImputZone.contentEditable = true;

    //Creo el bloque del imput compuesto
    let W_LabeledInput = document.createElement('div');
    W_LabeledInput.className = "W_LabeledInput";
    W_LabeledInput.id = LabelName;

    //agrego los elementos al imput compuesto
    W_LabeledInput.appendChild(W_Label);
    W_LabeledInput.appendChild(W_ImputZone);

    //agrego eventos necesarios para el imput label
    E_LabelImput(W_LabeledInput, ToolTipText, RestriccionesInput, caracteres, HTMLToModify);

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_LabeledInput);

    return W_LabeledInput;
}

/** - Crea los eventos necesarios para hacer que se pueda minimizar la tabla
 * @param {HTMLDivElement} BotonMinimize - boton a cambiar al minimizar, para cambiar la flecha o el + - al minimizar
 * @param {HTMLDivElement} InteractuableButon Bloque/Boton a pulsar para minimizar la tabla
 * @param {HTMLDivElement} Table_TableElement Tabla a minimizar
 * @author Agustin Parodi
 */
function E_FeatureInfoMinimizeButon_ChangeState(BotonMinimize, InteractuableButon, Table_TableElement){

    InteractuableButon.addEventListener('click', function(e){
        if(BotonMinimize.childNodes[0].className == "CI_FeatureMinimizeButon_Icon IconON"){
            BotonMinimize.childNodes[0].className = "CI_FeatureMinimizeButon_Icon IconOFF";
            BotonMinimize.childNodes[1].className = "CI_FeatureMinimizeButon_Icon IconON";
            Table_TableElement.className = Table_TableElement.className.replace("TableON", "TableOFF")
        }else{
            BotonMinimize.childNodes[1].className = "CI_FeatureMinimizeButon_Icon IconOFF";
            BotonMinimize.childNodes[0].className = "CI_FeatureMinimizeButon_Icon IconON";
            Table_TableElement.className = Table_TableElement.className.replace("TableOFF", "TableON")
        }
    })

}

/** - Crea una Tabla en una ventana, puede minimizable o no, y tener nombre o no
 * @param {Object} opciones - Opriones con las que se crear la Ventana
 * @param {HTMLDivElement} opciones.VentanaOBloqueObjetivo - Ventana donde se creará la tabla
 * @param {Iterable<>} opciones.ListaDeFilas - lista de Filas, tal que [ [TitleCol_0, TitleCol_1], [Data_0_Col_0, Data_0_Col_1], ...]
 * @param {string} opciones.NombreTabla - Nombre de la tabla que se creara (opcional)
 * @param {boolean} opciones.Minimizable - Se Puede minimizar la tabla (opcional, default = false)
 * @param {boolean} opciones.TituloEnPrimeraFila - Si el titulo viene incluido en la tabla (se formatea como Titulo) (opcional, default = false)
 * @returns {HTMLElement} Tabla Lista y en la Ventana o Bloque
 *
 * @author Agustin Parodi
 */
function CreateTable({ VentanaOBloqueObjetivo , ListaDeFilas, NombreTabla , Minimizable, TituloEnPrimeraFila}){
    var Parametros = arguments[0]
    var VentanaOBloqueObjetivo = Parametros.VentanaOBloqueObjetivo
    var ListaDeFilas = Parametros.ListaDeFilas
    var NombreTabla = Parametros.NombreTabla
    var Minimizable = Parametros.Minimizable
    var TituloEnPrimeraFila = Parametros.TituloEnPrimeraFila

    var FeatureInfoContainer = document.createElement('div');
    FeatureInfoContainer.className = "CI_FeatureInfoContainer"

    var FeatureBlock = document.createElement('div');
    FeatureBlock.className = "CI_FeatureElementContainer BaseColorExtraTransparent ExtraBorder"

    var FeatureTitle = document.createElement('div');
    FeatureTitle.className = "CI_FeatureElementTitle";
    FeatureTitle.textContent = NombreTabla;

    FeatureBlock.appendChild(FeatureTitle)

    if(Minimizable == true){
        var FeatureInfoMinimizeButon = document.createElement('div');
        FeatureInfoMinimizeButon.className = "CI_FeatureMinimizeButon ";

        var MinimizeButonIconClose = document.createElement('img');
        MinimizeButonIconClose.className = "CI_FeatureMinimizeButon_Icon IconON";
        MinimizeButonIconClose.src = W_CheckInfoClose;

        var MinimizeButonIconOpen = document.createElement('img');
        MinimizeButonIconOpen.className = "CI_FeatureMinimizeButon_Icon IconOFF";
        MinimizeButonIconOpen.src = W_CheckInfoOpen;

        //esto son los botones de minimizar y abrir, necesito 2 para no cambiar
        //el SRC y no probocar una recarga del icono
        FeatureInfoMinimizeButon.appendChild(MinimizeButonIconClose)
        FeatureInfoMinimizeButon.appendChild(MinimizeButonIconOpen)

        FeatureBlock.appendChild(FeatureInfoMinimizeButon)
    }

    FeatureInfoContainer.appendChild(FeatureBlock)

    //creo la tabla
    var Table_TableElement = document.createElement('table');
    Table_TableElement.className = "CI_FeatureInfoTable TableON"

    //creo el primer renglon
    var Table_FirstRow = document.createElement('tr');
    Table_FirstRow.className = "CI_FilaEncabezado BaseColorSinHoverConColor"
    //creo los encavezados
    var Table_FieldTitle = document.createElement('th');
    var Table_ValueTitle = document.createElement('th');

    Table_FieldTitle.textContent = "Campo";
    Table_ValueTitle.textContent = "Valor";

    Table_FieldTitle.className = "CI_Table_Header";
    Table_ValueTitle.className = "CI_Table_Header";

    //aggrego los encabezados a la primera Fila
    Table_FirstRow.appendChild(Table_FieldTitle)
    Table_FirstRow.appendChild(Table_ValueTitle)

    //agrego la primera Row a la tabla
    Table_TableElement.appendChild(Table_FirstRow);

    //agrego la tabla bajo el bloque de titulo de la capa
    FeatureInfoContainer.appendChild(Table_TableElement)

    //creo el renglon para cada campo
    for(var campoActual = 0; campoActual<ResultLayerGetInfo.Fields.length; campoActual++){
        //creo el renglon
        var Table_NewRow = document.createElement('tr');

        //coloreo diferente cada renglon
        if(campoActual % 2 == 0){
            Table_NewRow.className = "CI_FilaPar XMLPar ExtraBorder"
        }else{
            Table_NewRow.className = "CI_FilaImpar BaseColorExtraTransparent ExtraBorder"
        }

        //creo las Celdas
        var Table_Field = document.createElement('td');
        Table_Field.className = "CI_ElementRightBorder"
        
        var Table_Value = document.createElement('td');
        Table_Value.className = "CI_Table_Value_column";

        Table_Field.textContent = ResultLayerGetInfo.Fields[campoActual];
        Table_Value.textContent = ResultLayerGetInfo.Values[campoActual];

        //aggrego los encabezados a la primera Fila
        Table_NewRow.appendChild(Table_Field)
        Table_NewRow.appendChild(Table_Value)

        //agrego la row a la tabla
        Table_TableElement.appendChild(Table_NewRow);
    }

    //agrego el evento de minimizar la tabla
    if(Minimizable == true){ E_FeatureInfoMinimizeButon_ChangeState(FeatureInfoMinimizeButon, FeatureBlock, Table_TableElement) }

    //agrego el elemento donde me pidieron
    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, FeatureInfoContainer);

    //returno el control por si es necesario
    return FeatureBlock;
}

/** - Crea una Tabla en una ventana, puede minimizable o no, y tener nombre o no
 * @param {Object} opciones - Opriones con las que se crear la Ventana
 * @param {HTMLDivElement} opciones.VentanaOBloqueObjetivo - Ventana donde se creará la tabla
 * @param {HTMLDivElement} opciones.BotonAPrender - Boton que se activa al tener una capa seleccionada
 * @returns {HTMLElement} Tabla Lista y en la Ventana o Bloque
 *
 * @author Agustin Parodi
 */
 function CreateEditableLayersTable({ VentanaOBloqueObjetivo , BotonAPrender, TituloDeLaTabla}){
    let PanelAnterior = VentanaOBloqueObjetivo.querySelector(".Editable_Layer_List")
    if(PanelAnterior != undefined && PanelAnterior != null){
        PanelAnterior.remove();
        PanelAnterior = undefined;
    }
    
    var EditableLayers = w.GetEditableLayersArray();
    
    var Parametros = arguments[0]
    var VentanaOBloqueObjetivo = Parametros.VentanaOBloqueObjetivo
    var BotonAPrender = Parametros.BotonAPrender
    var TituloDeLaTabla = Parametros.TituloDeLaTabla

    var FeatureInfoContainer = document.createElement('div');
    FeatureInfoContainer.className = "CI_FeatureInfoContainer"

    //compruebo si hay capas editables a mostrar
    if(EditableLayers.length != 0){

    var FeatureBlock = document.createElement('div');
    FeatureBlock.className = "CI_FeatureElementContainer BaseColorExtraTransparent ExtraBorder"

    var TituloTabla = document.createElement('div');
    TituloTabla.className = "CI_FeatureElementTitle";
    TituloTabla.textContent = TituloDeLaTabla;
    FeatureBlock.appendChild(TituloTabla)

    FeatureInfoContainer.appendChild(FeatureBlock)

    //creo la tabla
    var Table_TableElement = document.createElement('table');
    Table_TableElement.className = "CI_FeatureInfoTable TableON"

    //creo el primer renglon
    var Table_FirstRow = document.createElement('tr');
    Table_FirstRow.className = "CI_FilaEncabezado BaseColorSinHoverConColor"
    //creo los encavezados
    var Table_FieldTitle = document.createElement('th');
    var Table_ValueTitle = document.createElement('th');

    Table_FieldTitle.textContent = "Selec.";
    Table_ValueTitle.textContent = "Capa";

    //aggrego los encabezados a la primera Fila
    Table_FirstRow.appendChild(Table_FieldTitle)
    Table_FirstRow.appendChild(Table_ValueTitle)

    //agrego la primera Row a la tabla
    Table_TableElement.appendChild(Table_FirstRow);

    //agrego la tabla bajo el bloque de titulo de la capa
    FeatureInfoContainer.appendChild(Table_TableElement)

    //creo el renglon para cada campo
    for(var campoActual = 0; campoActual < EditableLayers.length; campoActual++){
        //creo el renglon
        var Table_NewRow = document.createElement('tr');

        //coloreo diferente cada renglon
        if(campoActual % 2 == 0){
            Table_NewRow.className = "CI_FilaPar XMLPar ExtraBorder"
        }else{
            Table_NewRow.className = "CI_FilaImpar BaseColorExtraTransparent ExtraBorder"
        }

        //creo las Celdas
        var Table_Value = document.createElement('td');

        //creo el bloque que tendra el tick dentro (esto para centrarlo y posicionarlo mejor)
        var Chekbox_Container =  document.createElement('td');
        Chekbox_Container.className = "W_CheckBox_Container_Editar CI_ElementRightBorder";
        var DefaultValue = false;

        //creo el tick
        var Chekbox = document.createElement('img');
        Chekbox.className = "W_CheckBox_Icon";

        //confirmo si tiene que venir en Verdadero/Tick o en Falso/Cuadrado
        if(DefaultValue == false){
            //seteo el SVG para falso
            Chekbox.src = W_Bool_False;
        }else{
            //seteo la clase que sirve como marcador de el estado verdadero
            Chekbox.className = "W_CheckBox_Icon" + " trueState";
            //seteo el SVG para verdadero
            Chekbox.src = W_Bool_True;
        }

        //le pongo los eventos (que sea verdadero o falso al clickear en el elemento)
        E_BooleanButton(Chekbox_Container, Chekbox, "Seleccionar esta capa");
        E_BooleanButtonLayerToEdit(Chekbox_Container, Table_TableElement, BotonAPrender, EditableLayers);

        //le agrego el checkbox al div del imput
        Chekbox_Container.appendChild(Chekbox);

        Table_Value.textContent = EditableLayers[campoActual].Nombre + " (" + EditableLayers[campoActual].Formato + ") " + (EditableLayers[campoActual].EstadoDeLaCapa != ""? "[" + EditableLayers[campoActual].EstadoDeLaCapa + "]" : "");

        //aggrego los encabezados a la primera Fila
        Table_NewRow.appendChild(Chekbox_Container)
        Table_NewRow.appendChild(Table_Value)

        //agrego la row a la tabla
        Table_TableElement.appendChild(Table_NewRow)

        }
        //agrego el elemento donde me pidieron
        FeatureInfoContainer.classList.add("Editable_Layer_List");
        AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, FeatureInfoContainer);
    }else{

        let Mensaje = CreateCentredLabel(VentanaOBloqueObjetivo, "No hay capas editables");
        Mensaje.classList.add("Editable_Layer_List");
    }
    //testing
    // var Test = document.createElement('div');
    // Test.className = "CI_FeatureElementContainer"
    // Test.textContent = "TESTING OBJECT"
    // FeatureInfoContainer.appendChild(Test)

    //returno el control por si es necesario
    return FeatureBlock;
}
w.Update_EditableLayersTable = function(){
    if(w.VentanaEditar != null && w.VentanaEditar != undefined){
        let semiPanel = VentanaEditar.querySelector("#PanelCapas");
        let panelAceptarCancelar = VentanaEditar.querySelector("#AceptarCancelar");
        let botonEditar = panelAceptarCancelar.childNodes[1];
        CreateEditableLayersTable({ VentanaOBloqueObjetivo: semiPanel , BotonAPrender: botonEditar, TituloDeLaTabla:"Lista de capas editables"})
    }
}

/** - En una ventana, Crea una Tabla minimizable con los datos de ResultLayerGetInfo
 * @param {HTMLDivElement} VentanaOBloqueObjetivo - Ventana donde se creará la tabla
 * @param {ResultLayerGetInfo} ResultLayerGetInfo - Resultados de WMS.CheckInfo {Nombre, Title, Fields, Values, ServerType}
 * @returns {HTMLElement} Tabla Lista y en la Ventana o Bloque seleccionado
 *
 * @author Agustin Parodi
 */
function CreateDropDownTable(VentanaOBloqueObjetivo, ResultLayerGetInfo){

    var FeatureInfoContainer = document.createElement('div');
    FeatureInfoContainer.className = "CI_FeatureInfoContainer"

    var FeatureBlock = document.createElement('div');
    FeatureBlock.className = "CI_FeatureElementContainer BaseColorExtraTransparent ExtraBorder"

    var FeatureTitle = document.createElement('div');
    FeatureTitle.className = "CI_FeatureElementTitle";
    if(ResultLayerGetInfo.Title != undefined){
        FeatureTitle.textContent = ResultLayerGetInfo.Title
    } else{
        FeatureTitle.textContent = ResultLayerGetInfo.Nombre
    }

    var FeatureInfoMinimizeButon = document.createElement('div');
    FeatureInfoMinimizeButon.className = "CI_FeatureMinimizeButon ";

    var MinimizeButonIconClose = document.createElement('img');
    MinimizeButonIconClose.className = "CI_FeatureMinimizeButon_Icon IconON";
    MinimizeButonIconClose.src = W_CheckInfoClose;

    var MinimizeButonIconOpen = document.createElement('img');
    MinimizeButonIconOpen.className = "CI_FeatureMinimizeButon_Icon IconOFF";
    MinimizeButonIconOpen.src = W_CheckInfoOpen;

    //esto son los botones de minimizar y abrir, necesito 2 para no cambiar
    //el SRC y no probocar una recarga del icono
    FeatureInfoMinimizeButon.appendChild(MinimizeButonIconClose)
    FeatureInfoMinimizeButon.appendChild(MinimizeButonIconOpen)

    FeatureBlock.appendChild(FeatureTitle)
    FeatureBlock.appendChild(FeatureInfoMinimizeButon)

    FeatureInfoContainer.appendChild(FeatureBlock)

    //creo la tabla
    var Table_TableElement = document.createElement('table');
    Table_TableElement.className = "CI_FeatureInfoTable TableON"

    //creo el primer renglon
    var Table_FirstRow = document.createElement('tr');
    Table_FirstRow.className = "CI_FilaEncabezado BaseColorSinHoverConColor"
    //creo los encavezados
    var Table_FieldTitle = document.createElement('th');
    var Table_ValueTitle = document.createElement('th');

    Table_FieldTitle.className = "CI_Table_Header";
    Table_ValueTitle.className = "CI_Table_Header";

    Table_FieldTitle.textContent = "Campo";
    Table_ValueTitle.textContent = "Valor";

    //aggrego los encabezados a la primera Fila
    Table_FirstRow.appendChild(Table_FieldTitle)
    Table_FirstRow.appendChild(Table_ValueTitle)

    //agrego la primera Row a la tabla
    Table_TableElement.appendChild(Table_FirstRow);

    //agrego la tabla bajo el bloque de titulo de la capa
    FeatureInfoContainer.appendChild(Table_TableElement)

    //creo el renglon para cada campo
    for(var campoActual = 0; campoActual<ResultLayerGetInfo.Fields.length; campoActual++){
        //creo el renglon
        var Table_NewRow = document.createElement('tr');

        //coloreo diferente cada renglon
        if(campoActual % 2 == 0){
            Table_NewRow.className = "CI_FilaPar XMLPar ExtraBorder"
        }else{
            Table_NewRow.className = "CI_FilaImpar BaseColorExtraTransparent ExtraBorder"
        }

        //creo las Celdas
        var Table_Field = document.createElement('td');
        Table_Field.className = "CI_ElementRightBorder"

        var Table_Value = document.createElement('td');
        Table_Value.className = "CI_Table_Value_column";

        Table_Field.textContent = ResultLayerGetInfo.Fields[campoActual];
        Table_Value.textContent = ResultLayerGetInfo.Values[campoActual];

        //aggrego los encabezados a la primera Fila
        Table_NewRow.appendChild(Table_Field)
        Table_NewRow.appendChild(Table_Value)

        //agrego la row a la tabla
        Table_TableElement.appendChild(Table_NewRow);
    }

    //agrego el evento de minimizar la tabla
    E_FeatureInfoMinimizeButon_ChangeState(FeatureInfoMinimizeButon, FeatureBlock, Table_TableElement)

    //testing
    // var Test = document.createElement('div');
    // Test.className = "CI_FeatureElementContainer"
    // Test.textContent = "TESTING OBJECT"
    // FeatureInfoContainer.appendChild(Test)

    //agrego el elemento donde me pidieron
    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, FeatureInfoContainer);

    //returno el control por si es necesario
    return FeatureBlock;
}

/** - Crea el control LabelCheckbox, que consiste en un Checkbox, con un texto para explicar que hace
 * @param {HTMLDivElement} VentanaOBloqueObjetivo - Ventana donde se creará el control
 * @param {string} LabelName - Texto que explica que hace el checkbox
 * @param {Boolean} DefaultValue - Si el mismo esta prendido o apagado por defecto
 * @param {string} ToolTipText - Texto que explica que hace el botom, mas detallado para ponerlo en el tooltip
 * @param {string} HTMLClass - Classe extra, normalemnte usado para discriminarlo en caso de que otro control tenga que encontrarlo para prenderlo o apagarlo
 * @returns {HTMLElement} Control Listo
 *
 * @author Agustin Parodi
 */
function CreateLabelCheckbox( VentanaOBloqueObjetivo, LabelName, DefaultValue, ToolTipText, HTMLClass){

    //Creo el bloque del label
    let W_Label = document.createElement('div');
    W_Label.className = "W_Chekbox_Label";
    W_Label.textContent = LabelName;

    //creo el bloque que tendra el tick dentro (esto para centrarlo y posicionarlo mejor)
    var Chekbox_Container =  document.createElement('div');
    Chekbox_Container.className = "W_CheckBox_Container";

    //creo el tick
    var Chekbox = document.createElement('img');
    Chekbox.className = "W_CheckBox_Icon";

    //confirmo si tiene que venir en Verdadero/Tick o en Falso/Cuadrado
    if(DefaultValue == false){
        //seteo el SVG para falso
        Chekbox.src = W_Bool_False;
    }else{
        //seteo la clase que sirve como marcador de el estado verdadero
        Chekbox.className = "W_CheckBox_Icon" + " trueState";
        //seteo el SVG para verdadero
        Chekbox.src = W_Bool_True;
    }

    //Creo el bloque del imput compuesto
    let W_LabeledCheckbox = document.createElement('div');
    if(HTMLClass != null){
        W_LabeledCheckbox.className = "W_LabeledCheckbox BaseColorExtraTransparentSoloHover " + HTMLClass;
    }else{
        W_LabeledCheckbox.className = "W_LabeledCheckbox BaseColorExtraTransparentSoloHover";
    }
    W_LabeledCheckbox.id = LabelName;

    //le pongo los eventos (que sea verdadero o falso al clickear en el elemento)
    E_BooleanButton(W_LabeledCheckbox, Chekbox, ToolTipText);

    //le agrego el checkbox al div del imput
    Chekbox_Container.appendChild(Chekbox);

    //agrego los elementos al imput compuesto
    W_LabeledCheckbox.appendChild(Chekbox_Container);
    W_LabeledCheckbox.appendChild(W_Label);

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_LabeledCheckbox);

    return W_LabeledCheckbox;
}

//Cambia la opcion de un Dropdown (creado por CreateDropDown), y le dispara el evento "change"
w.SetDropDownOptionByIndex = function(id, OptionIndex){
    
    //console.log(document.querySelector("select[id='"+id+"']")); //debug

    //obteno los elementos
    let selectObjectElement = document.querySelector("[id='"+id+"']");
    let selectObject = document.querySelector("select[id='"+id+"']");
    let listaOpciones = selectObject.childNodes;

    //recorto los valores a los limites del dropdown
    OptionIndex = (OptionIndex < listaOpciones.length)? OptionIndex : listaOpciones.length-1;
    OptionIndex = (OptionIndex >= 0)? OptionIndex : 0;

    //se cambia el elemento seleccionado en el dropdown
    listaOpciones[OptionIndex].selected = true;
    //se dispara el evento 'change' en el pdre para que funcione
    selectObjectElement.dispatchEvent(new Event("change"));
}

/** - crea un DropDown, y lo coloca en el bloque o ventana objetivo
 * @param {HTMLDivElement} VentanaOBloqueObjetivo - Ventana donde se creará el control
 * @param {string} LabelName - Nombre del dropdown para mostrar como label
 * @param {number} DefaultOption - indice del elemento por defecto de la lista
 * @param {string} ToolTipText - Texto que explica que hace el control, mas detallado para ponerlo en el tooltip
 * @param {string} Separator - separador que se usara para separar el valor de la opcion del texto a mostrar en la misma, ej  ["A-Valor A", "B-Valor B",...] el Separator seria "-"
 * @param {string} InputListValueLabel - lista de elementos para mostrar en el dropdown, con separadores entre Valor de la opcion y Texto a mostrar. ej. ["A-Valor A", "B-Valor B",...]
 * @returns {HTMLElement} Control Listo
 *
 * @author Agustin Parodi
 */
function CreateDropDown( VentanaOBloqueObjetivo, LabelName, DefaultOption, ToolTipText, Separator, InputListValueLabel){

    //Creo el bloque del label
    let W_Label = document.createElement('div');
    W_Label.className = "W_Label";
    W_Label.textContent = LabelName;

    //Creo el bloque del drop Down
    let W_ImputDropDown = document.createElement('select');
    W_ImputDropDown.className = "W_ImputDropDown BaseColorExtraTransparent ExtraBorder";
    W_ImputDropDown.name = LabelName;
    W_ImputDropDown.id = LabelName;

    //revision de opciones para agregarlas
    for(var ValueIndex = 0; ValueIndex < InputListValueLabel.length ;ValueIndex++){
        //creo la opcion
        let OptionElement = document.createElement('option');
        OptionElement.className = "DropDownOptionColor";
        OptionElement.value = InputListValueLabel[ValueIndex].split(Separator)[0];
        OptionElement.textContent = InputListValueLabel[ValueIndex].split(Separator)[1];

        //selecciono el elemento por defecto
        if(DefaultOption == ValueIndex){
            OptionElement.selected = true;
        }

        //agrego los elementos creados
        W_ImputDropDown.appendChild(OptionElement);

    }

    //Creo el bloque del imput DropDown compuesto
    let W_LabeledDropDown = document.createElement('div');
    W_LabeledDropDown.className = "W_LabeledDropDown";
    W_LabeledDropDown.id = LabelName;

    //agrego los elementos al imput compuesto
    W_LabeledDropDown.appendChild(W_Label);
    W_LabeledDropDown.appendChild(W_ImputDropDown);

    //agrego eventos necesarios para el imput label
    //E_LabelImput(W_LabeledDropDown, ToolTipText, RestriccionesInput, caracteres);
    delayToolTip(W_LabeledDropDown, standarToolTipDelayInMS, ToolTipText);

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_LabeledDropDown);


    return W_LabeledDropDown;
}

/** - crea un DropDown, y lo coloca en el bloque o ventana objetivo
 * @param {HTMLDivElement} VentanaOBloqueObjetivo - Ventana donde se creará el control
 * @param {string} LabelName - Nombre del dropdown para mostrar como label
 * @param {number} DefaultOption - indice del elemento por defecto de la lista
 * @param {string} ToolTipText - Texto que explica que hace el control, mas detallado para ponerlo en el tooltip
 * @param {string} Separator - separador que se usara para separar el valor de la opcion del texto a mostrar en la misma, ej  ["A-Valor A", "B-Valor B",...] el Separator seria "-"
 * @param {string} InputListValueLabel - lista de elementos para mostrar en el dropdown, con separadores entre Valor de la opcion y Texto a mostrar. ej. ["A-Valor A", "B-Valor B",...]
 * @returns {HTMLElement} Control Listo
 *
 * @author Agustin Parodi
 */
 function CreateDropDown_SinLabel( VentanaOBloqueObjetivo, LabelName, DefaultOption, ToolTipText, Separator, InputListValueLabel){

    //Creo el bloque del drop Down
    let W_ImputDropDown = document.createElement('select');
    W_ImputDropDown.className = "W_ImputDropDown BaseColorExtraTransparent ExtraBorder";
    W_ImputDropDown.name = LabelName;
    W_ImputDropDown.id = LabelName;

    //revision de opciones para agregarlas
    for(var ValueIndex = 0; ValueIndex < InputListValueLabel.length ;ValueIndex++){
        //creo la opcion
        let OptionElement = document.createElement('option');
        OptionElement.className = "DropDownOptionColor";
        OptionElement.value = InputListValueLabel[ValueIndex].split(Separator)[0];
        OptionElement.textContent = InputListValueLabel[ValueIndex].split(Separator)[1];

        //selecciono el elemento por defecto
        if(DefaultOption == ValueIndex){
            OptionElement.selected = true;
        }

        //agrego los elementos creados
        W_ImputDropDown.appendChild(OptionElement);

    }

    //Creo el bloque del imput DropDown compuesto
    let W_LabeledDropDown = document.createElement('div');
    W_LabeledDropDown.className = "W_LabeledDropDown noTopMargin";
    W_LabeledDropDown.id = LabelName;

    W_LabeledDropDown.appendChild(W_ImputDropDown);

    //agrego eventos necesarios para el imput label
    //E_LabelImput(W_LabeledDropDown, ToolTipText, RestriccionesInput, caracteres);
    delayToolTip(W_LabeledDropDown, standarToolTipDelayInMS, ToolTipText);

    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_LabeledDropDown);


    return W_LabeledDropDown;
}

/** - Crea un FileInput, y lo coloca en el bloque o ventana objetivo
 * @param {HTMLDivElement} VentanaOBloqueObjetivo - Ventana donde se creará el control
 * @param {string} buttonName - Nombre del boton para Cargar, normalmente se usa "Abrir..." o "Seleccionar..."
 * @param {number} DefaultText - Texto que se muestra a modo de ayuda al usuario para mostrarle por ejemplo los formatos soportados, es reemplazado por el archivo al seleccionarse el mismo
 * @param {string} FileInputId - Id del control, usado normalmente para buscarlo y leer su coentenido por otros controles
 * @param {string} ToolTipText - Texto que explica que hace el control, mas detallado para ponerlo en el tooltip
 * @param {string} FileRestrictions - Restriccion de formato en este formato ( ".formato1, .formato2" ) ej ".KML, .GPX, etc"
 * @returns {HTMLElement} Control Listo
 *
 * @author Agustin Parodi
 */
function CreateFileInput(VentanaOBloqueObjetivo, buttonName, DefaultText, FileInputId, ToolTipText, FileRestrictions){
    var parametros = arguments[0]

    //Creo el bloque del imput
    let W_UploadButon = document.createElement('div');
    W_UploadButon.className = "W_button W_Seleccionar BaseColorExtraTransparent ExtraBorder";
    W_UploadButon.textContent = buttonName;

    //Creo el bloque del label del archivo
    let W_FileLabel = document.createElement('div');
    W_FileLabel.className = "W_FileLabel BaseColorExtraTransparent ExtraBorder";
    W_FileLabel.textContent = DefaultText;

    //Creo el bloque del Imput
    let W_InputFile = document.createElement('input');
    W_InputFile.type = "file";
    W_InputFile.accept = FileRestrictions.toLowerCase();
    W_InputFile.className = "W_InputFile";

    //Creo el bloque del FileInput compuesto
    let W_FileInput = document.createElement('div');
    W_FileInput.className = "W_FileInput";
    W_FileInput.id = FileInputId;

    //agrego los elementos al imput compuesto
    W_FileInput.appendChild(W_UploadButon);
    W_FileInput.appendChild(W_FileLabel);
    W_FileInput.appendChild(W_InputFile);

    //agrego eventos necesarios para el imput label
    E_FileImput(W_FileInput, ToolTipText, FileRestrictions);


    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_FileInput);

    return W_FileInput;
}


/** - Crea un FileInput, y lo coloca en el bloque o ventana objetivo
 * @param {HTMLDivElement} VentanaOBloqueObjetivo - Ventana donde se creará el control
 * @param {string} buttonName - Nombre del boton para Cargar, normalmente se usa "Abrir..." o "Seleccionar..."
 * @param {number} DefaultText - Texto que se muestra a modo de ayuda al usuario para mostrarle por ejemplo los formatos soportados, es reemplazado por el archivo al seleccionarse el mismo
 * @param {string} FileInputId - Id del control, usado normalmente para buscarlo y leer su coentenido por otros controles
 * @param {string} ToolTipText - Texto que explica que hace el control, mas detallado para ponerlo en el tooltip
 * @param {string} FileRestrictions - Restriccion de formato en este formato ( ".formato1, .formato2" ) ej ".KML, .GPX, etc"
 * @returns {HTMLElement} Control Listo
 *
 * @author Agustin Parodi
 */
 function Create_TipsControl(VentanaOBloqueObjetivo){


    //Creo el bloque del imput
    let W_Tips_Container = document.createElement('div');
    W_Tips_Container.className = "W_Tips_Container";


    //creamos la barra de controles
    let W_controlBlock = document.createElement('div');
    W_controlBlock.className = "W_Tips_Control";


    //Creamos el boton de izquierda
    let W_button = document.createElement('div');
    W_button.className = "W_button BaseColorExtraTransparent ExtraBorder";
    W_button.appendChild(w.Recursos.W_Prev.cloneNode(true));
    //W_button.textContent = "<";

    delayToolTip(W_button, standarToolTipDelayInMS, "<span>Consejo anterior</span>");
    W_controlBlock.appendChild(W_button);

    let ObjetoAyuda = document.getElementById("TipsList");
    let ListaAyuda = ObjetoAyuda.getElementsByClassName("TipObject");
    let NombresListaAyuda = [];

    for (const ayuda of ListaAyuda) {
        NombresListaAyuda.push(ayuda.getAttribute("name") + "-" + ayuda.getAttribute("name"));
    }

    //Creamos el desplegable
    let id_Dropdown = "TemasAudaRapida";
    var DropDownTema = CreateDropDown_SinLabel(W_controlBlock, id_Dropdown , 0, "<span>Seleccionar un tema</span>", "-" , NombresListaAyuda );


    //Creamos el boton de derecho
    let W_button2 = document.createElement('div');
    W_button2.className = "W_button BaseColorExtraTransparent ExtraBorder";
    W_button2.appendChild(w.Recursos.W_Next.cloneNode(true));
    //W_button2.textContent = ">";

    delayToolTip(W_button2, standarToolTipDelayInMS, "<span>Consejo siguiente</span>");
    W_controlBlock.appendChild(W_button2);

    let W_Ayuda = document.createElement('div');
    W_Ayuda.className = "TipObject BlackScrollBar";
    W_Ayuda.innerHTML = getHelpById(0).innerHTML;

    //reviso el drop down si este cambia y seteo la escala
    DropDownTema.addEventListener('change', function(e){
        W_Ayuda.innerHTML = getHelpById( DropDownTema.getElementsByTagName("select")[0].selectedIndex ).innerHTML;
    });

    //accion del boton >
    W_button.addEventListener('click', function(){
        //revisamos si el botton fue desactivado o no y si no fue desactivado ejecuto la accion
        if(hasClass(this, "Buton_OFF") == true){
            //console.log("Estoy apagado");
        }else{
            SetDropDownOptionByIndex(id_Dropdown, DropDownTema.getElementsByTagName("select")[0].selectedIndex - 1)
        }
    });
    
    //accion del boton <
    W_button2.addEventListener('click', function(){
        //revisamos si el botton fue desactivado o no y si no fue desactivado ejecuto la accion
        if(hasClass(this, "Buton_OFF") == true){
            //console.log("Estoy apagado");
        }else{
            SetDropDownOptionByIndex(id_Dropdown, DropDownTema.getElementsByTagName("select")[0].selectedIndex + 1)
        }
    });


   

    W_Tips_Container.appendChild(W_controlBlock);
    W_Tips_Container.appendChild(W_Ayuda);
    AgregarControlAVentanaObloque(VentanaOBloqueObjetivo, W_Tips_Container);

    return W_Tips_Container;
}

function getHelpById( id ){
    return document.getElementById("Tip" + id)
}

w.root = document.documentElement;
function setValueOnCSS(Element, varName ,value, unit){
    if(unit == ''){
      Element.style.setProperty(varName, (value));
    }else{
      Element.style.setProperty(varName, (value + unit));
    }  
  }

w.valorPorcentajeExportarMapa =  0;
w.CambiarPorcentajeExportarMapa = function(nuevoPorcentaje){
    if(w.VentanaExportandoMapa != null){
        w.valorPorcentajeExportarMapa = nuevoPorcentaje;
        // console.log("Progress: " + w.valorPorcentajeExportarMapa + "%");
        
        setValueOnCSS(w.root, '--nuevoValor', nuevoPorcentaje, '');
        setValueOnCSS(w.root, '--nuevoValorPorcentaje', nuevoPorcentaje, '%');
    }
}

/** - Funcion de Descargar Imagen para poner a un boton
 * @param {HTMLElement} WindowElement - Ventana que se cerrara al dispararse la funcion
 * @param {string} NombreArchivo - Nombre del archivo a descargar
 * @param {string} Formato - Formato del archivo a descargar
 * @param {string} PosicionBarraEscala - Posicion donde estara la barra de escala en la impresion (POS0, POS1, POS2, POS3, POS4)
 * @param {string} PosicionNorte - Posicion donde estara El norte en la impresion (POS0, POS1, POS2, POS3, POS4)
 *
 * @author Agustin Parodi
 */
var F_DescargarImagen = function(WindowElement, NombreArchivo, Formato, PosicionBarraEscala, PosicionNorte, InputEscala){
    
    //pongo la patalla borrosa con estas 4 lineas
    var bloqueoInterface_Bloque = document.getElementsByClassName("BloqueadorDeInterface_Block")[0];
    var bloqueoInterface_Efecto = document.getElementsByClassName("BloqueadorDeInterface_Efecto")[0];
    bloqueoInterface_Bloque.className = "BloqueadorDeInterface_Block Bloqueado";
    bloqueoInterface_Efecto.className = "BloqueadorDeInterface_Efecto Bloqueado";

        //creo la ventana "Descargando" y la asigno luego
        CreateWindow("Exportando Mapa", F_CancelarExportarCruz, []);
        w.VentanaExportandoMapa = document.getElementById("Exportando Mapa");

        //activo la ventana una vez creada
        ChangeActiveWindow(w.VentanaExportandoMapa);

        w.CambiarPorcentajeExportarMapa(0);

        //creamos el contenido de la ventana
        //hay que crear el lavel con imput text y luego los botones de cancelar y aceptar
        ExportandoMapa_CreateControls(w.VentanaExportandoMapa);

        EsconderElementoHTML(w.VentanaExportandoMapa.getElementsByClassName("W_MinimizeButon")[0])
        //pongo la ventana en el medio de la ventana
        MoverVentanaAlCentroDiv(w.VentanaExportandoMapa, activeZone);

        bloqueoInterface_Bloque.appendChild(w.VentanaExportandoMapa);
        w.VentanaExportandoMapa.style.left = $(bloqueoInterface_Bloque).width()/2 + "px";

    F_CancelarOperacion(WindowElement)
    w.ImprimirPNG(NombreArchivo, Formato, PosicionBarraEscala, PosicionNorte, InputEscala)
}

/** - Funcion que se llamara al tocar el boton de cancelar
 * @param {HTMLElement} WindowElement - Ventana que se cerrara al dispararse la funcion
 *
 * @author Agustin Parodi
 */
var F_CancelarOperacion = function(WindowElement, VariableVentana){
    ActualizarTooltip("");
    WindowElement.remove();

    if(VariableVentana != undefined){
        w[VariableVentana] = undefined; 
    }
}


var F_CancelarEsportarPNG = function(){
    ActualizarTooltip("")
    w.VentanaPrintPNG.remove();
    w.VentanaPrintPNG = null;
}

var F_IniciarEdicionDesdeMenu = function(WindowElement){
    ActualizarTooltip("")
    tryToExecuteLayerOperation( w.LayerToEditFromMenu, "editar");
    WindowElement.remove();
}

/** - Funcion que se llamara al tocar el boton de cancelar
 * @param {HTMLElement} WindowElement - Ventana que se cerrara al dispararse la funcion
 * @param {number} IDCapaADescargar - ID de la capa que se va a descargar
 *
 * @author Agustin Parodi
 */
var F_CancelarDescarga = function(WindowElement, CapaADescargar){
    w.SetLayerState(CapaADescargar, '');

    w.Update_EditableLayersTable();
    
    WindowElement.remove();
}

var F_CancelarExportarCruz = function(){
    w.VentanaExportandoMapa = null;

    var bloqueoInterface_Bloque = document.getElementsByClassName("BloqueadorDeInterface_Block")[0];
    var bloqueoInterface_Efecto = document.getElementsByClassName("BloqueadorDeInterface_Efecto")[0];
    
    bloqueoInterface_Bloque.className = "BloqueadorDeInterface_Block";
    bloqueoInterface_Efecto.className = "BloqueadorDeInterface_Efecto";
}

var F_CancelarExportar = function(){
    w.VentanaExportandoMapa.remove();
    w.VentanaExportandoMapa = null;

    var bloqueoInterface_Bloque = document.getElementsByClassName("BloqueadorDeInterface_Block")[0];
    var bloqueoInterface_Efecto = document.getElementsByClassName("BloqueadorDeInterface_Efecto")[0];
    
    bloqueoInterface_Bloque.className = "BloqueadorDeInterface_Block";
    bloqueoInterface_Efecto.className = "BloqueadorDeInterface_Efecto";
}

var F_CancelarDescargaCruz = function(CapaADescargar){
    w.SetLayerState(CapaADescargar, '');
    w.Update_EditableLayersTable();
}

//funcion que se llamara al tocar el boton de crear capa
var F_AceptarCrearCapa = function(WindowElement, imputName, defaultText){
    var operationSucceded = false;

    if(imputName.childNodes[1].textContent != defaultText && imputName.childNodes[1].textContent.trim() != ""){
        operationSucceded = true;
        w.layersDelMapa.CreateEmptyLayer(imputName.childNodes[1].textContent);
        //w.layersDelMapaGUI.UpdateLayersOnGUI();
        w.layersDelMapaGUI.UpdateAllLayersOnGUI()
        w.Update_EditableLayersTable();

    }else{
        WindowMostrarError(imputName.childNodes[1], "El nombre introducido no es valido", true);
    }

    if(operationSucceded == true){
        F_CancelarOperacion(WindowElement);
    }
}

var F_SubirCapa = function(WindowElement, BotonSubir, defaultText, ErrorText){
    var operationSucceded = false;

    var FileInputElement = BotonSubir.getElementsByClassName("W_InputFile")[0];

    if(BotonSubir.childNodes[1].textContent != defaultText && BotonSubir.childNodes[1].textContent.trim() != "" && BotonSubir.childNodes[1].textContent != ErrorText){
        operationSucceded = true;

        w.layersDelMapa.UploadLayer(FileInputElement.files[0]);

    }else{
        WindowMostrarError(BotonSubir.childNodes[1], "Seleccione un archivo valido primero", true);
    }

    if(operationSucceded == true){
        WindowElement.remove();
    }

}

//funcion del boton de descargar capa
var F_DescargarArchivo = function(WindowElement, CapaADescargar, OutputName, OutputFormat){

    var FileName = OutputName.childNodes[1].textContent;
    var FileFormat = OutputFormat.childNodes[1].value;

    //console.log("IDCapaADescargar = " + IDCapaADescargar);

    w.layersDelMapa.DescargarCapa(CapaADescargar, FileName, FileFormat);
    w.SetLayerState(CapaADescargar, '');
    WindowElement.remove();
}

//funcion generica para mostrar errores pintando o modificando Elementos
//su funcion principal es colorear por ejemplo en rojo un imput mal llenado
function WindowMostrarError( ElementoHTML, ErrorText, CambiaColor){

    if(CambiaColor == true && hasClass(ElementoHTML, "ImputError") == false){
        ElementoHTML.className = ElementoHTML.className + " ImputError";
    }

    if(hasClass(ElementoHTML, "W_ImputZone") == true)
    {
        ElementoHTML.addEventListener('click', (ev) => {
        if(CambiaColor == true && hasClass(ElementoHTML, "ImputError") == true){
            ElementoHTML.className = ElementoHTML.className.replace(" ImputError", "");
        }
      }, { once: true });
    }

}

//lista de las layers del XML, es publica para evitar re descargar la
//informacion y reducir el consumo de datos de la aplicacion
w.ArrayXMLLayers = [];

//esta funcion consume el resultado del WMS y muestra si hay error, es publica porque
//se consume desde main pero afecta a la interface asi que debe estar aqui
w.MostrarErrorListaDeDatosXML = function(XMLResult, HTMLElementList, ErrorNumber){
    //vacio el elemento por si ya se habia creado una tabla, esto deja el
    //terreno libre para luego escribir el error
    // console.log("error en el link");
    // console.log(HTMLElementList);
    $( HTMLElementList ).empty();

    //trato de capturar cada posible error conocido al escribir el link
    var XMLElement = document.createElement('div');
    XMLElement.className = "XMLElement ListElement";
    if(ErrorNumber == 403){
        XMLElement.innerHTML = "Error: " + ErrorNumber + " Dirección Inaccesible";
    }else if(ErrorNumber == 404){
        XMLElement.innerHTML = "Error: " + ErrorNumber + " No Existe el archivo";
    }else if(ErrorNumber == 0){
        XMLElement.innerHTML = "Error: " + ErrorNumber + " No se puede Resolver el host";
    }else{
        XMLElement.innerHTML = "Error: " + ErrorNumber + "";
    }
    // XMLElement.textContent = "Dirección de WMS Incorrecta... \r\n(Error: " + ErrorNumber + ")";

    //agregamos el error al elemento para que el usuario lo vea
    HTMLElementList.appendChild(XMLElement);

}

//consumiendo el XMLResult de el XMLRead generara un HTML con la lista de capas obtenoda del
//XML y le agregara a cada una un boton para marcar si queremos cargarla
w.CrearListaDeDatosXML = function(XMLResult, HTMLElementList){

    //vaciamos cualquier contenido del listado para evitar errores
    $( HTMLElementList ).empty();

    // console.log(XMLResult);
    //obtenemos la lista de layers del XMLResult
    w.ArrayXMLLayers = w.XMLGetLayers(XMLResult);

    //creamos el titulo de las columnas
    var XMLElement = document.createElement('div');
    XMLElement.className = "XMLElement ListElement BaseColorSinHoverConColor ";

    var XMLElementTitle =  document.createElement('div');
    XMLElementTitle.className = "ColumnTitle XMLElementColumn TitleColumn  ";
    XMLElementTitle.textContent = "Titulo";

    var XMLElementToLoad =  document.createElement('div');
    XMLElementToLoad.className = "ColumnTitle XMLElementColumn BoolColumn  ";
    XMLElementToLoad.textContent = "Cargar";

    XMLElement.appendChild(XMLElementToLoad);
    XMLElement.appendChild(XMLElementTitle);
    HTMLElementList.appendChild(XMLElement);

    //genero un elemento que representa cada Elemento del XML con cada iteracion
    //ademas en la primer en vez de crear el primer elemento creara la barra del
    //titulo de la tabla
    for(var k = 0; k < w.ArrayXMLLayers.length; k++){
        
        //creo la fila nueva para poner los bloques de las columnas
        var XMLElement = document.createElement('div');
        if(k % 2 == 0){
            XMLElement.className = "XMLElement ListElement BaseColorExtraTransparent ExtraBorder";
        }else{
            XMLElement.className = "XMLElement ListElement XMLPar ExtraBorder";
        }

        //creo el bloque de la tabla con el nombre
        var XMLElementTitle =  document.createElement('div');
        XMLElementTitle.className = "XMLElement_Title XMLElementColumn TitleColumn ";
        XMLElementTitle.textContent = w.XMLGetLayerTitle(w.ArrayXMLLayers[k]);

        ////////////////////////////////////////////////////////////////////////////////////////////

        //creo el bloque de la tabla con el bool
        var XMLElementToLoad =  document.createElement('div');
        XMLElementToLoad.className = "XMLElementBool_Container XMLElementColumn BoolColumn";

        //creo el bloque del tick
        var Tick = document.createElement('img');
        Tick.className = "XMLElement_Icon";
        Tick.src = W_Bool_False;

        XMLElementToLoad.appendChild(Tick);

        E_BoolXMLLoadLayer(XMLElementToLoad);

        XMLElement.appendChild(XMLElementToLoad);
        XMLElement.appendChild(XMLElementTitle);

        // XMLElement.appendChild(XMLElementName);
        // XMLElement.appendChild(XMLElementBBox);

        HTMLElementList.appendChild(XMLElement);
    }
}

//esta funcion cambia el estado de un boton. usando la clase Buton_OFF para dehabilitar e mismo
function ChangeButtonState(HTMLElement, Estado){
    //agregarle la tag deberia ser sificiente para hacer que el mismo se bloquee,
    //tanto visualmente como en funcionalidad, ahora mismo funciona con los CreateButons
    //de las ventanas, y con los botones de la barra superior
    if(Estado == true){
        if(hasClass(HTMLElement, "Buton_OFF") == true){
            HTMLElement.className = HTMLElement.className.replaceAll(" Buton_OFF", "");
        }
    }else{
        if(hasClass(HTMLElement, "Buton_OFF") == false){
            HTMLElement.className = HTMLElement.className + " Buton_OFF" ;
        }
    }
}

//esto revisara si existe algun tick marcado en los wms de la lista
//y si eso pasa enciende el boton de Cargar WMS y sino lo apaga, por defecto
//esta apagado usando la tag Buton_OFF
function CheckWMSBooleanState(HTMLelement, ButonToChange, tickToChange){
    var TrueStateCases = 0;

    for(var IndiceWMS = 0; IndiceWMS < HTMLelement.childNodes.length; IndiceWMS++){
        if(hasClass(HTMLelement.childNodes[IndiceWMS].childNodes[0].childNodes[0],"trueState")){
            TrueStateCases++;
            if(TrueStateCases >1 ){
                break; //esto deberia mejorar el rendimiento en WMS que tengan muchas capas
                //pero no permitira saber cuantas capas se seleccionaron
            }
        }
    }

    if(TrueStateCases > 0){
        //console.log("boton prendio (" + TrueStateCases + " WMS seleccionados)");
        if(ButonToChange != null){
            ChangeButtonState(ButonToChange, true);
        }

        if(TrueStateCases > 1){
            if(tickToChange != null){
                ChangeButtonState(tickToChange, true);
            }
        }else{
            if(tickToChange != null){
                ChangeButtonState(tickToChange, false);
            }
        }

    }else{

        //console.log("boton apagado (" + TrueStateCases + " WMS seleccionados)");
        if(ButonToChange != null){
            ChangeButtonState(ButonToChange, false);
        }

        if(tickToChange != null){
            ChangeButtonState(tickToChange, false);
        }

    }

}

function E_BooleanButtonLayerToEdit(HTMLelementToInteract, Table_TableElement, BotonAPrender, EditableLayers){
    var indexAEditar = 0
    $(HTMLelementToInteract).on('click', function(){
        for(var rowActual = 0; rowActual<Table_TableElement.childNodes.length; rowActual++){
            if(Table_TableElement.childNodes[rowActual].childNodes[0] == HTMLelementToInteract){
                indexAEditar = rowActual
            }
            if(Table_TableElement.childNodes[rowActual].childNodes[0] != HTMLelementToInteract && Table_TableElement.childNodes[rowActual].childNodes[0].childNodes[0].className != "W_CheckBox_Icon"){
                //seteo el SVG para falso
                Table_TableElement.childNodes[rowActual].childNodes[0].childNodes[0].className = "W_CheckBox_Icon"
                Table_TableElement.childNodes[rowActual].childNodes[0].childNodes[0].src = W_Bool_False;
            }
        }

        if(HTMLelementToInteract.childNodes[0].className != "W_CheckBox_Icon"){
            w.LayerToEditFromMenu = EditableLayers[indexAEditar-1]
            BotonAPrender.className = BotonAPrender.className.replace("Buton_OFF", "")
        }else{
            w.LayerToEditFromMenu = undefined;
            BotonAPrender.className = BotonAPrender.className + " Buton_OFF"
        }

    });
    
}

//esto chequea el Tick del booleano de las opciones booleanas de los menus
function E_BooleanButton(HTMLelementToInteract, HTMLelementToChange, Tooltip){

    $(HTMLelementToInteract).on('click', function(){

        if( !hasClass(HTMLelementToInteract, "Buton_OFF") ){
            //esto setea el estado true y false en cada capa segun se necesite, ademas de cambiar los graficos SVG del tick
            if( hasClass(HTMLelementToChange, "trueState") == false){
                // el check queda en true
                HTMLelementToChange.className = HTMLelementToChange.className + " trueState";
                HTMLelementToChange.src = W_Bool_True;

            }else{
                // el check queda en false
                HTMLelementToChange.className = HTMLelementToChange.className.replace(" trueState", "");
                HTMLelementToChange.src = W_Bool_False;
            }
        } //Buton_OFF

    });

    delayToolTip(HTMLelementToInteract, standarToolTipDelayInMS, Tooltip);

}

w.keyStatusOnMap = "";
w.mouseStatusOnMap = "";
w.mouseClick = false;
E_MousePointerOnMap(document.getElementById('map'));
E_MousePointerOnMapChengePointer();

function E_MousePointerOnMapChengePointer(){
        //console.log("hola");
        //boolDeAccion = true;
        var mapa = document.getElementById("map");

        if(w.keyStatusOnMap == "alt + shift"){
            //estado rotacion
            mapa.className = "map " + "Cursor_Rotate";

        }else if(w.keyStatusOnMap == "shift"){
            //estado lupa de zoom en zona
            mapa.className = "map " + "Cursor_Zoom";

        }else if(hasClass(BS_Boton_Medir_Distancia, "M_Button_Selected") && mouseStatusOnMap != "Drag"){
            //estado pedirInfo
            mapa.className = "map " + "Cursor_Medir_Distancia";
            // console.log("Cursor_Medir_Distancia")

        }else if(hasClass(BS_Boton_Medir_Superficie, "M_Button_Selected") && mouseStatusOnMap != "Drag"){
            //estado pedirInfo
            mapa.className = "map " + "Cursor_Medir_Superficie";
            // console.log("Cursor_Medir_Superficie")

        }else if(hasClass(BS_Boton_PedirInfo, "M_Button_Selected") && mouseStatusOnMap != "Drag"){
            //estado pedirInfo
            mapa.className = "map " + "Cursor_PedirInfo";
            //console.log("BS_Boton_PedirInfo")

        }else if(hasClass(BS_Boton_Seleccionar, "M_Button_Selected") && mouseStatusOnMap != "Drag"){
            //estado seleccion
            mapa.className = "map " + "Cursor_Select";
            //console.log("BS_Boton_Seleccionar")

        }else if(mouseStatusOnMap == "Drag"){
            //estado dragueando mapa
            //console.log("grabing...");
            mapa.className = "map " + "Cursor_Grabbing";

        }else if(hasClass(BS_Boton_Punto, "M_Button_Selected") ){
            //estado Punto
            mapa.className = "map " + "Cursor_Edit_Punto";

        }else if(hasClass(BS_Boton_Linea, "M_Button_Selected") ){
            //estado Linea
            mapa.className = "map " + "Cursor_Edit_Linea";

        }else if(hasClass(BS_Boton_Area, "M_Button_Selected") ){
            //estado Area
            mapa.className = "map " + "Cursor_Edit_Area";

        }else {
            //estado con solamente el mouse sobre el mapa
            mapa.className = "map " + "Cursor_Grab";
        }
}

//esto chequea el pointer del mapa segun ciertas condiciones
function E_MousePointerOnMap(HTMLelement){

    HTMLelement.addEventListener('mousedown', function(){
        mouseStatusOnMap = "click";
        w.mouseClick = true;
        E_MousePointerOnMapChengePointer();
    });

    w.addEventListener('mouseup', function(){
        mouseStatusOnMap = "";
        w.mouseClick = false;
        E_MousePointerOnMapChengePointer();
    });

    //var boolDeAccion = false;

    $(HTMLelement).on('mousemove', function(e){
        if(w.mouseClick == true){
            mouseStatusOnMap = "Drag";
        }
        E_MousePointerOnMapChengePointer();
    });

    $(w).on('keydown', function(e){
            check_keyboard_In(e);
            E_MousePointerOnMapChengePointer();
    });


    $(w).on('keyup', function(e){
        check_keyboard_Out(e);
        E_MousePointerOnMapChengePointer();
    });

    function check_keyboard_In(e){

        // if(e.altKey){
        //     console.log("Alt Down!");
        //     e.preventDefault();
        // }

        if(e.shiftKey && e.altKey ){
            w.keyStatusOnMap = "alt + shift";
            //console.log(keyStatusOnMap + " Down!");
            e.preventDefault();
            //console.log("Alt + shift Down!");
        }else{
            if(e.shiftKey){
                w.keyStatusOnMap = "shift";
                //console.log(keyStatusOnMap + " Down!");
                //console.log("shift Down!");
            }
        }
    }

    function check_keyboard_Out(e){
        if(!e.shiftKey){
            if(w.keyStatusOnMap == "shift"){
                //console.log(keyStatusOnMap + " Up!");
                w.keyStatusOnMap = "";
                //console.log("shift up!");
            }

        }

        if(!e.altKey){
            if(w.keyStatusOnMap == "alt + shift"){
                //console.log(keyStatusOnMap + " Up!");
                w.keyStatusOnMap = "";
                //console.log("Alt up!");
            }

        }

    }
}

//chequeara esta funcion cuando se interactue con los cheks de la lista de WMS
function E_BoolXMLLoadLayer(HTMLelement){

    ///esto se disparara cada vez que se cliquea en el Check del WMS en la lista
    $(HTMLelement).on('click', function(){

        //esto setea el estado true y false en cada capa segun se necesite, ademas de cambiar los graficos SVG del tick
        if( hasClass(HTMLelement.childNodes[0], "trueState") == false){
            // el check queda en true
            HTMLelement.childNodes[0].className = HTMLelement.childNodes[0].className + " trueState";
            HTMLelement.childNodes[0].src = W_Bool_True;

        }else{
            // el check queda en false
            HTMLelement.childNodes[0].className = HTMLelement.childNodes[0].className.replace(" trueState", "");
            HTMLelement.childNodes[0].src = W_Bool_False;
        }

        //si existe un boton que activar en caso de que hayan boleanos en true se ara aqui
        //trato de volver asta la ventana para buscar el boton en toda la ventana flotante pero asi evitar buscarlo en toda la pagina
        //console.log(HTMLelement.parentElement.parentElement.parentElement.parentElement); //<== esta seria la ventana

        //luego implementare una forma generica de llegar a la ventana

        //el boton a prender y apagar sera el que tenga esa clase, pero no es necesario, por si se quiere reutilizar esto
        var WMSCheckTick = HTMLelement.parentElement.parentElement.parentElement.parentElement.getElementsByClassName("WMSCheckTick");
        var WMSCheckButton = HTMLelement.parentElement.parentElement.parentElement.parentElement.parentElement.getElementsByClassName("WMSCheckButton");
        if(WMSCheckButton.length > 0){
            if(WMSCheckTick.length > 0){
                CheckWMSBooleanState(HTMLelement.parentElement.parentElement, WMSCheckButton[0],  WMSCheckTick[0]);
            }else{
                CheckWMSBooleanState(HTMLelement.parentElement.parentElement, WMSCheckButton[0], null);
            }

        }else{
            if(WMSCheckTick.length > 0){
                CheckWMSBooleanState(HTMLelement.parentElement.parentElement, null, WMSCheckTick[0]);
            }else{
                CheckWMSBooleanState(HTMLelement.parentElement.parentElement, null, null);
            }
        }

    });

}

//funcion que dispara para crear una capa nueva con un WMS
var F_AceptarSubirCapa = function(VentanaHTML, imputNameHTML, BoolMultiHTML){

    //reviso si se marco la opcion de cargar todas las capas como una sola, si multiLayer es 1
    var IsMultiLayerButonActive = !(hasClass(BoolMultiHTML, "Buton_OFF"));
    //console.log("La Opcion de Multi Layer esta disponible: " + IsMultiLayerButonActive);

    //reviso si se marco la opcion de cargar todas las capas como una sola, si multiLayer es 1
    var IsMultiLayerActive = BoolMultiHTML.getElementsByClassName("trueState").length == 1;
    //console.log("Cargar Capas del WMS combinadas: " + IsMultiLayerActive);

    var LinkWMS = imputNameHTML.getElementsByClassName("W_ImputZone")[0].textContent;
    //console.log("Link: " + LinkWMS);

    var listaDeCapas = VentanaHTML.getElementsByClassName("XMLElement_Icon");
    //console.log(listaDeCapas);
    //esto comprueba si el tick estaba desactivado al poner cargar WMS
    //(esto significa que solo hay una capa seleccionada, sino estaria encendido)
    if(IsMultiLayerButonActive == false){
        for(var CapaActual = 0; CapaActual < listaDeCapas.length; CapaActual++){
            if( hasClass( listaDeCapas[CapaActual] , "trueState") == true ){
                //console.log("la capa seleccionada es " + w.XMLGetLayerTitle(w.ArrayXMLLayers[CapaActual]) );
                w.layersDelMapa.AddLayerFromWMS(LinkWMS, [w.ArrayXMLLayers[CapaActual]], 'image/png');
            }
        }
    }else{
        //esto significa que hay mas de una capa seleccionada
        if(IsMultiLayerActive){
            //esto quiere decir que se va cargar las capas como 1 sola
            var WMSLayersToLoad = [];
            for(var capaActual = 0; capaActual < listaDeCapas.length; capaActual++){
                if( hasClass( listaDeCapas[capaActual] , "trueState") == true ){
                    //console.log("la capa seleccionada es " + w.XMLGetLayerTitle(w.ArrayXMLLayers[capaActual]) );
                    WMSLayersToLoad.push(w.ArrayXMLLayers[capaActual]);
                }
            }

            w.layersDelMapa.AddLayerFromWMS(LinkWMS, WMSLayersToLoad, 'image/png');

        }else{
            //esto quiere decir que se va cargar las capas como capas independientes


            for(var capaActual = 0; capaActual < listaDeCapas.length; capaActual++){
                if( hasClass( listaDeCapas[capaActual] , "trueState") == true ){
                    //console.log("la capa seleccionada es " + w.XMLGetLayerTitle(w.ArrayXMLLayers[capaActual]) );
                    w.layersDelMapa.AddLayerFromWMS(LinkWMS, [w.ArrayXMLLayers[capaActual]], 'image/png');
                }
            }
        }



    }

    //para remover la ventana
    F_CancelarOperacion(VentanaHTML)

}

//crea los controles por defecto de la ventana de crear capa
function CrearCapa_CreateControls(WindowElement){
    var panelParametros = CreateSemiPanelOnWindow(WindowElement, "Parametros", true);
    var imputName = CreateLabelImput(panelParametros, "Nombre:", "Introduzca el nombre", "Nombre de la Capa a crear", "file", 60, null);

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "Parametros", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cancelar", "Cancela la operación", F_CancelarOperacion,[WindowElement], "" );
    var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Crear Capa", "Crear capa &nbsp(tiene que haberse definido un nombre)", F_AceptarCrearCapa, [WindowElement, imputName, "Introduzca el nombre"], "");

    //esto va a perminit crear la capa simplemente tocando el enter,
    //una vez creado el nombre claro
    imputName.childNodes[1].addEventListener("keydown", function(e){
        if(e.which == 13){
            imputName.childNodes[1].textContent = imputName.childNodes[1].textContent.trim();
            BotonAceptar.click();
        }
    });

    //esto es para que al apretar Escape se elimine la ventana
    WindowElement.addEventListener("keydown", function(e){
        if(e.which == 27){
            BotonCancelar.click();
        }
        //esta linea sirve para chequer que tecla se apreto
        //console.log("Tecla: " + e.which );
    });

    //esto es para probocar que cuando se crea esta ventanba nueva
    //se selecciona automaticamente el bloque del nombre, para hacer
    //mas fluido el uso de la aplicacion
    imputName.childNodes[1].click();
    imputName.childNodes[1].focus();
}

//crea los controles por defecto de la ventana de Cargar WMS
function CargarWMS_CreateControls(WindowElement){
    var XMLElementsTitleListed = document.createElement('div');
    var XMLElementsListed = document.createElement('div');

    var panelParametros = CreateSemiPanelOnWindow(WindowElement, "Parametros", true);
    var imputWMS = CreateLabelImput(panelParametros, "Link:", "", "Link del WMS", "wms", -1, XMLElementsListed);
    imputWMS.childNodes[1].style.scrollX = "auto";

    var imputWMCheck = CreateLabelCheckbox(panelParametros, "Cargar Capas del WMS combinadas", false, "Carga todas las capas del WMS seleccionadas &nbspcomo una sola capa combinada", "WMSCheckTick Buton_OFF" );
    var panelXMLResults = CreateSemiPanelOnWindow(WindowElement, "Resultados del WMS", true);

    XMLElementsTitleListed.className = "XMLResultTitleContainer BordeNoRoundBottom BlackScrollBar";
    // XMLElementsTitleListed.textContent = "Dirección de WMS Incorrecta...";

    var XMLElement = document.createElement('div');
    XMLElement.className = "XMLTitleElement ListElement BaseColorSinHoverConColor ";

    var XMLElementTitle =  document.createElement('div');
    XMLElementTitle.className = "XMLColumnTitle XMLElementColumn TitleColumn  ";
    XMLElementTitle.textContent = "Titulo";

    var XMLElementToLoad =  document.createElement('div');
    XMLElementToLoad.className = "XMLColumnTitle XMLElementColumn BoolColumn  ";
    XMLElementToLoad.textContent = "Cargar";

    XMLElement.appendChild(XMLElementToLoad);
    XMLElement.appendChild(XMLElementTitle);
    XMLElementsTitleListed.appendChild(XMLElement);
    panelXMLResults.appendChild(XMLElementsTitleListed);

    XMLElementsListed.className = "XMLResultContainer BordeNoRoundTop BlackScrollBar";
    XMLElementsListed.textContent = "Dirección de WMS Incorrecta...";
    panelXMLResults.appendChild(XMLElementsListed);

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "Parametros", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cancelar", "Cancela la operación", F_CancelarOperacion,[WindowElement], "");
    var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Cargar WMS", "Carga WMS &nbsp(Tiene que estar el link escrito arriba)&nbspY tiene que seleccionarse al menos una capa", F_AceptarSubirCapa, [WindowElement, imputWMS, imputWMCheck], "WMSCheckButton Buton_OFF" );

    //esto es para que al apretar Escape se elimine la ventana
    WindowElement.addEventListener("keydown", function(e){
        if(e.which == 27){
            BotonCancelar.click();
        }
        //esta linea sirve para chequer que tecla se apreto
        //console.log("Tecla: " + e.which );
    });

    //esto es para probocar que cuando se crea esta ventanba nueva
    //se selecciona automaticamente el bloque del nombre, para hacer
    //mas fluido el uso de la aplicacion
    imputWMS.childNodes[1].click();
    imputWMS.childNodes[1].focus();
}

//crea los controles por defecto de la ventana de Cargar WMS
function IniciarEdicion_CreateControls(WindowElement){
    //me guardo la escala original
    
    var PanelCapas = CreateSemiPanelOnWindow(WindowElement, "PanelCapas", true);
    // var ArchivoLabel = CreateCentredLabel(PanelCapas , "Lista de capas editables" );    

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "AceptarCancelar", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cancelar", "Cancela la operación", F_CancelarOperacion,[WindowElement, "VentanaEditar"], "");
    var BotonEditar = CreateButtons(panelAcceptarCancelar, "Editar", "Inicia la edición con la capa seleccionada", F_IniciarEdicionDesdeMenu,[WindowElement], "EditableLayerSelectedButon Buton_OFF");
    //var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Exportar", "Exportar Mapa &nbsp(Exporta el mapa con los parametros seleccionados)", F_DescargarImagen,[WindowElement, A, OutputFormat.childNodes[1], ScaleBarrPos.childNodes[1], NorthPos.childNodes[1]], "");
    //var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Exportar", "Exportar Mapa &nbsp(Exporta el mapa con los parametros seleccionados)", F_AceptarSubirCapa, [WindowElement, imputWMS, imputWMCheck], "WMSCheckButton Buton_OFF" );

    var Tabla = CreateEditableLayersTable({VentanaOBloqueObjetivo: PanelCapas, BotonAPrender: BotonEditar, TituloDeLaTabla:"Lista de capas editables"})

    //esto es para que al apretar Escape se elimine la ventana
    WindowElement.addEventListener("keydown", function(e){
        if(e.which == 27){
            BotonCancelar.click();
        }
        //esta linea sirve para chequer que tecla se apreto
        //console.log("Tecla: " + e.which );
    });

}

//crea los controles de la ventana de metadatos de la capa seleccionada
function Metadata_CreateControls(WindowElement, layerData){
    var panelDatos = CreateSemiPanelOnWindow(WindowElement, "Datos", true);
    var ArchivoLabel = CreateCentredLabel(panelDatos, "Metadatos" );

    var metaDataTable = CreateMetadataTable( panelDatos, layerData);
}

//crea los controles por defecto de la ventana de Cargar WMS
function ExportarMapaPNG_CreateControls(WindowElement){
    //me guardo la escala original
    var originalScale = Math.round(w.ScaleBar.getScaleForResolution())

    var panelArchivo = CreateSemiPanelOnWindow(WindowElement, "Archivo", true);
    var ArchivoLabel = CreateCentredLabel(panelArchivo , "Opciones de Archivo" );
    var NombreArchivo = CreateLabelImput(panelArchivo, "Nombre:", ("Mapa - " + w.GetDateOnText("dia")), "Nombre del archivo de salida", "file", 100, null)
    var OutputFormat = CreateDropDown(panelArchivo, "Formato:" , 0, "Seleccionar formato del archivo de salida", "-" , ["PNG-.png (Calidad Alta)","JPEG-.jpg (Calidad Alta)","JPEG2-.jpg (Calidad Estandar)","JPEG3-.jpg (Calidad Baja)"] );

    var panelEscala = CreateSemiPanelOnWindow(WindowElement, "Escala", true);
    var ScaleLabel = CreateCentredLabel(panelEscala , "Opciones de Escala" );
    var OutputScale = CreateDropDown(panelEscala, "Escala:" , 0, "Seleccionar la escala de salida", "-" , [originalScale + "-Vista Original","PERSONALIZADA-Personalizada","1000-1:1.000","2500-1:2.500","5000-1:5.000","10000-1:10.000","20000-1:20.000","25000-1:25.000","50000-1:50.000","10000-1:100.000","250000-1:250.000","500000-1:500.000","1000000-1:1.000.000","3000000-1:3.000.000"]);
    var CustomScale = CreateLabelImput(panelEscala, "Escala 1:", "0", "Escala Personalizada", "number", 6, null)

    //la seteo en el onjeto en pantalla y me guardo el objeto en una variable
    var TextoEscala = CustomScale.childNodes[1]
    TextoEscala.textContent = originalScale;
    var TextoEscakaClassName = TextoEscala.className + " ";

    //lo seto en off por defecto al recuadro de escala custome, porque sino
    //no puedo setear la vista como ecala por defecto, porque se podria editar
    TextoEscala.className = TextoEscakaClassName + "Buton_OFF";
    TextoEscala.contentEditable = false;

    //reviso el drop down si este cambia y seteo la escala
    OutputScale.addEventListener('change', function(e){

        var DropDownValue = OutputScale.childNodes[1].value
        if(!isNaN(DropDownValue)){
            TextoEscala.textContent = DropDownValue;
            TextoEscala.className = TextoEscakaClassName + "Buton_OFF";
            TextoEscala.contentEditable = true;
            TextoEscala.focus();
            TextoEscala.blur();
            TextoEscala.contentEditable = false;
        }else{
            if(DropDownValue == "VISTA"){
                TextoEscala.textContent = originalScale;
                TextoEscala.className = TextoEscakaClassName + "Buton_OFF";
                TextoEscala.contentEditable = true;
                TextoEscala.focus();
                TextoEscala.blur();
                TextoEscala.contentEditable = false;
            }else{
                TextoEscala.textContent = Math.round(w.ScaleBar.getScaleForResolution())
                TextoEscala.className = TextoEscakaClassName;
                TextoEscala.contentEditable = true;
            }
        }
    });

    //en vez de ser el drop down el que setea la escala,
    //sera el recuadro, para asi hacer mas simple el codigo
    TextoEscala.addEventListener('focusout', function(e){
        //console.log(TextoEscala.textContent)
        w.SetScaleOnMap(TextoEscala.textContent)
    })

    // NombreArchivo.className = NombreArchivo.className + " Buton_OFF"

    var panelExtra = CreateSemiPanelOnWindow(WindowElement, "Extra", true);
    var ArchivoLabel = CreateCentredLabel(panelExtra , "Opciones Extra" );
    var ScaleBarrPos = CreateDropDown(panelExtra, "Barra Escala:" , 3, "Opciones de la barra de escala", "-" , ["POS0-Arriba Izquierda","POS1-Arriba Derecha", "POS2-Abajo Derecha", "POS3-Abajo Izquierda", "POS4-Desactivada"] );
    var NorthPos = CreateDropDown(panelExtra, "Flecha Norte:" , 3, "Opciones del Norte", "-" , ["Pos0-Arriba Izquierda","POS1-Arriba Derecha", "POS2-Abajo Derecha", "POS3-Abajo Izquierda", "POS4-Desactivada"] );

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "AceptarCancelar", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cancelar", "Cancela la operación", F_CancelarEsportarPNG,[], "");
    var BotonExportar = CreateButtons(panelAcceptarCancelar, "Exportar", "Exportar Mapa &nbsp(Exporta el mapa con los parametros seleccionados)", F_DescargarImagen,[WindowElement, NombreArchivo.childNodes[1], OutputFormat.childNodes[1], ScaleBarrPos.childNodes[1], NorthPos.childNodes[1], TextoEscala], "");
    //var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Exportar", "Exportar Mapa &nbsp(Exporta el mapa con los parametros seleccionados)", F_AceptarSubirCapa, [WindowElement, imputWMS, imputWMCheck], "WMSCheckButton Buton_OFF" );

    //esto es para que al apretar Escape se elimine la ventana
    WindowElement.addEventListener("keydown", function(e){
        if(e.which == 27){
            BotonCancelar.click();
        }
        //esta linea sirve para chequer que tecla se apreto
        //console.log("Tecla: " + e.which );
    });

    //esto es para probocar que cuando se crea esta ventanba nueva
    //se selecciona automaticamente el bloque del nombre, para hacer
    //mas fluido el uso de la aplicacion
    // imputWMS.childNodes[1].click();
    // imputWMS.childNodes[1].focus();
}

//crea los controles por defecto de la ventana de Consultar info
function ConsultarInfo_CreateControls(WindowElement, ListOfelementsToShow){

    var panelXMLResults = CreateSemiPanelOnWindow(WindowElement, "ResultadosConsulta", true);

    for(var indiceElemento = ListOfelementsToShow.length-1; indiceElemento>-1; indiceElemento--){
        var CheckInfoResultElement = CreateDropDownTable(panelXMLResults, ListOfelementsToShow[indiceElemento])
        if(indiceElemento < ListOfelementsToShow.length-1){
            CheckInfoResultElement.childNodes[0].click();
        }
    }

    //pone el panel de Aceptar/Cancelar con su boton de "Cerrar" solamente
    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "Parametros", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cerrar", "Cancela la operación", F_CancelarOperacion,[WindowElement], "");

    //esto es para que al apretar Escape se elimine la ventana
    WindowElement.addEventListener("keydown", function(e){
        //chequeo la tecla Esc
        if(e.which == 27){
            BotonCancelar.click();
        }
    });

}

//crea los controles por defecto de la ventana de subir capa
function SubirCapa_CreateControls(WindowElement){
    var panelParametros = CreateSemiPanelOnWindow(WindowElement, "Parametros", true);
    //CreateFileInput( VentanaOBloqueObjetivo, buttonName, DefaultText, labelName, ToolTipText, FileRestrictions){
    let formats = ".KML, .GPX, .IGC, .GeoJSON, .TopoJSON";
    var BotonSubir = CreateFileInput(panelParametros, "Seleccionar", "Formatos Permitidos: "+formats, "FileToUpload", "Seleccionar un archivo &nbsp("+formats+")", formats );

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "Parametros", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cancelar", "Cancela la operación", F_CancelarOperacion,[WindowElement],"" );
    var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Subir Archivo", "Subir archivo al visualizador &nbsp (Formatos permitidos: "+formats+")", F_SubirCapa, [WindowElement, BotonSubir, "Formatos Permitidos: "+formats, "Archivo No Válido - Formatos permitidos: "+formats], "" );

}

function ExportandoMapa_CreateControls(WindowElement){

    var panelDatos = CreateSemiPanelOnWindow(WindowElement, "Datos de la Operación", true);
    w.ExportActualState = CreateCentredLabelHTMLText(panelDatos ,"<br>Preparando mapa...");   

    var barraProgreso = CreateProgressBar(panelDatos);

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "AceptarCancelar", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cancelar", "Cancela la operación", F_CancelarExportar,[] , "");
}

//crea los controles de descargar capa
function DescargarCapa_CreateControls(WindowElement, CapaADescargar){

    var panelArchivo = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "ArchivoSeleccionado", true);
    var FileLabel = CreateCentredLabel(panelArchivo ,"Descargar: " + CapaADescargar.Nombre + " (" +  CapaADescargar.Formato +")" );

    var panelRenombrarArchivoYFormato = CreateSemiPanelOnWindow(WindowElement, "Parametros", true);
    var OutputName = CreateLabelImput(panelRenombrarArchivoYFormato, "Nombre:", CapaADescargar.Nombre , "(Opcional) Cambiar Nombre del archivo a descargar", "file", 59);
    var OutputFormat = CreateDropDown(panelRenombrarArchivoYFormato, "Formato:" , 0, "Seleccionar formato del archivo de salida", "-" , ["KML-.KML (Keyhole Markup Language)","GeoJSON-.GeoJSON (GeoJSON)", "JSON-.JSON (GeoJSON)"] );

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "AceptarCancelar", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cancelar", "Cancela la operación", F_CancelarDescarga,[WindowElement, CapaADescargar] , "");
    var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Descargar", "Descarga el archivo", F_DescargarArchivo, [WindowElement, CapaADescargar, OutputName, OutputFormat] , "");

}

//crea los controles de Tips
function Tips_CreateControls(WindowElement){
    var panelArchivo = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "ArchivoSeleccionado", true);
    var AyudaRapida = Create_TipsControl(WindowElement);

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "AceptarCancelar", false);
    var cerrar = CreateButtons(panelAcceptarCancelar, "Cerrar", "Cancela la operación", F_CancelarOperacion,[WindowElement] , "");
}



//crea los controles de opciones capa
function Opciones_CreateControls(WindowElement){

    var panelOpciones = CreateSemiPanelOnWindow(WindowElement, "Opciones", true);
    var FileLabel = CreateCentredLabel(panelOpciones , "Opciones de Interface" );
    // var OutputName = CreateLabelImput(panelRenombrarArchivoYFormato, "Nombre:", w.layersDelMapa.Lista[IDCapaADescargar].Nombre , "(Opcional) Cambiar Nombre del &nbsp=>archivo a descargar", "file", 59);
    // var UIColor = CreateDropDown(panelOpciones, "Colores:" , w.InterfaceColor, "Seleccionar Colores de la intarface", "-" , ["Original-Oscuros (Original)", "Clara-Claro (Celeste)"] );
    var UIBlur = CreateDropDown(panelOpciones, "Desenfoque:" , w.InterfaceBlur, "Seleccionar el nuvel de Desenfoque de fondo de la intarface", "-" , ["off-Desactivado", "bajo-Desenfoque bajo", "alto-Desenfoque alto"] );

    // UIColor.childNodes[1].addEventListener("change", function(e){
    //     //console.log("Change!");
    //     //console.log(UIColor.childNodes[1].value);

    //     if(UIColor.childNodes[1].value == "Original"){
    //         w.InterfaceColor = 0;;
    //         toggleStyle("BaseColorClaro", false);
    //     }

    //     if(UIColor.childNodes[1].value == "Clara"){
    //         w.InterfaceColor = 1;
    //         toggleStyle("BaseColorClaro", true);
    //         // toggleStyle("BaseColorDefault", true);
    //     }
    // })


    UIBlur.childNodes[1].addEventListener("change", function(e){
        if(UIBlur.childNodes[1].value == "off"){
            w.InterfaceBlur = 0;
        }

        if(UIBlur.childNodes[1].value == "bajo"){
            w.InterfaceBlur = 1;
        }

        if(UIBlur.childNodes[1].value == "alto"){
            w.InterfaceBlur = 2;
        }

        ChangeInterfaceBlur( w.InterfaceBlur );
    })

    //me guardo los elementos necesarios del html para cambiar el fondo
    let padreFondos = document.getElementsByClassName("LayerDisplay_Fondo_Base")[0];
    let listaDeFondosHTML = document.getElementsByClassName("LayerDisplay_Fondo_Imagen");
    let listaDeFondosNombres = [];

    //se va a usar el id de las imagenes en el html para hacer los fonods, esto hace que no se tengan 
    //que cargar mas de una vez porque lo que se hará es apagarlos y prenderlos no cambiar el src
    //armo la lista que se vera en el desplegable tal que "ID-Con-Guiones" + "|" + "ID Sin Guiones"
    for(let indice = 0; indice<listaDeFondosHTML.length; indice++){
        let IdFondo = listaDeFondosHTML[indice].id;
        let NombreFondo = IdFondo.substr(6, IdFondo.length-1);
        listaDeFondosNombres.push(IdFondo + "|" + NombreFondo.replace('-', ' '))
    }

    //creo un drop down con los datos de los fondos
    var UIFondo = CreateDropDown(panelOpciones, "  Fondo:" , listaDeFondosNombres[0].split('|')[0], "Seleccionar fondo de la interface", "|" , listaDeFondosNombres );

    //este es el evento que se dispara a lacambiar el desplegable
    UIFondo.childNodes[1].addEventListener("change", function(e){

        //busco los fondos que estan activados (esto se hace como lista para evitar bugs a futuro)
        let FondosActivados = padreFondos.getElementsByClassName("Fondo_Seleccionado");

        //con la lista de fondos activos, los des-activo
        for(let indiceF = 0; indiceF<FondosActivados.length; indiceF++){
            FondosActivados[indiceF].classList.remove("Fondo_Seleccionado");
        }

        //busco el elemento con la id de la lista y lo activo agregamdole la clase "Fondo_Seleccionado"
        padreFondos.querySelector("#" + UIFondo.childNodes[1].value).classList.add("Fondo_Seleccionado");        
    })

    var panelCraditos = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "Creditos", true);
    var FileLabel = CreateCentredLabelHTMLText(panelCraditos , w.CreditsHTML);
    //var FileLabel = CreateCentredLabel(panelCraditos ,"Creditos\n" + w.Credits);

    var panelAcceptarCancelar = CreateSemiPanelOnWindowFlexHorizontal(WindowElement, "AceptarCancelar", false);
    var BotonCancelar = CreateButtons(panelAcceptarCancelar, "Cerrar", "Cerrar ventana", F_CancelarOperacion,[WindowElement] , "");
    // var BotonAceptar = CreateButtons(panelAcceptarCancelar, "Descargar", "Descarga el archivo", F_DescargarArchivo, [WindowElement, IDCapaADescargar, OutputName, OutputFormat] , "");

}

//#endregion

//crea la biemvenida 
crearBienvenida();
ChangeInterfaceBlur( w.InterfaceBlur );

//descomentar esto en la version final
//browser exit confirmation
w.addEventListener("beforeunload", function (e) {
    var confirmationMessage = "\o/";
    (e || w.event).returnValue = confirmationMessage; //Gecko + IE
    console.log(confirmationMessage);
    return confirmationMessage;                           //Webkit, Safari, Chrome
});

// function myFunction() {
//     var txt;
//     if (confirm("Press a button!")) {
//       txt = "You pressed OK!";
//     } else {
//       txt = "You pressed Cancel!";
//     }
//     return txt;
//   }

// document.getElementById("Eliminar capa").addEventListener('click',function(){
//     confirm("Are you sure to delete?");
// })
